/**
 * Auto-generated game name mapping
 * Maps walletId/gameId to game name (translationKey)
 * Generated on: 2026-04-30T10:52:37.630123
 * Updated on: 2026-07-21 (added 46 Evolution/NetEnt live-table IDs from Eva API)
 * Updated on: 2026-10-02 (added 3 Oaks Gaming)
 * Total games: 6341
 * Includes: Eva/PM8 games + RebelTech games (Pragmatic + Evolution)
 */

import { betinovioGameNameMapping } from './betinovioGameNameMapping';
import { databetrixGameNameMapping } from './databetrixGameNameMapping';
import { rebeltechGameNameMapping } from './rebeltechGameNameMapping';

// Game name mapping object
const gameNameMapping = {
  "3426": "24D Spin",
  "vs20wildparty": "3 Buzzing Wilds™",
  "vswaysmonkey": "3 Dancing Monkeys™",
  "vs50aladdin": "3 Genie Wishes",
  "vs25kingdoms": "3 Kingdoms - Battle of Red Cliffs",
  "vs25wolfgmm": "3 Magic Eggs",
  "3591": "30 Ball Bingo",
  "vswayscharms": "5 Frozen Charms Megaways™",
  "vs243lions": "5 Lions",
  "vs1024lionsd": "5 Lions Dance",
  "vs243lionsgold": "5 Lions Gold",
  "vswayslions": "5 Lions Megaways",
  "vsways5lions2": "5 Lions Megaways 2",
  "vsways5lionsr": "5 Lions Reborn",
  "vs5magicdoor": "6 Jokers",
  "vswayssevenc": "7 Clovers of Fortune",
  "vs7monkeys": "7 Monkeys",
  "vs7pigs": "7 Piggies",
  "sc7piggies": "7 Piggies 5,000",
  "3593": "75 Ball Bingo",
  "vs5t8goldfp": "777 Rush",
  "vs20eightdragons": "8 Dragons",
  "vs10gdchalleng": "8 Golden Dragon Challenge™",
  "vs1dragon8": "888 Dragons",
  "vs5triple8gold": "888 Gold",
  "3592": "90 Ball Bingo",
  "vs20hotzone": "African Elephant™",
  "vs20aladdinsorc": "Aladdin and the Sorcerer",
  "vs50amt": "Aladdin's Treasure",
  "vs20alieninv": "Alien Invaders",
  "bjmb": "American Blackjack",
  "950": "American Roulette",
  "vswaysacnd": "Anaconda Gold",
  "vs10egypt": "Ancient Egypt",
  "vs10egyptcls": "Ancient Egypt Classic",
  "vswaysmodfr": "Ancient Island Megaways",
  "1024": "Andar Bahar",
  "vs15fghtmultlv": "Angel vs Sinner",
  "vswaysargonts": "Argonauts",
  "vs25asgard": "Asgard",
  "210": "Auto Mega Roulette",
  "225": "Auto Roulette",
  "vs25kfruit": "Aztec Blaze",
  "vs7776aztec": "Aztec Bonanza",
  "vs5aztecgems": "Aztec Gems",
  "vs9aztecgemsdx": "Aztec Gems Deluxe",
  "vswaysaztec": "Aztec Gems Megaways™",
  "vs20sbpnudge": "Aztec Powernudge",
  "vs20plsmcannon": "Aztec Smash",
  "vs20trswild3": "Aztec Treasure Hunt",
  "425": "Baccarat 7",
  "436": "Baccarat 9",
  "401": "Baccarat A",
  "404": "Baccarat B",
  "422": "Baccarat C",
  "411": "Baccarat D",
  "413": "Baccarat E",
  "vs25badge": "Badge Blitz",
  "vswaysbandit": "Bandit Megaways™",
  "vs20farmfest": "Barn Festival",
  "vswaysmegahays": "Barnyard Megahays Megaways™",
  "vs10beekeep": "Bee Keeper",
  "vs40beowulf": "Beowulf",
  "912": "Bet Behind Pro Blackjack",
  "vswaysbewaretd": "Beware The Deep Megaways™",
  "vs10bbkir": "Big Bass - Keeping it Reel™",
  "vs10bbextreme": "Big Bass Amazon Xtreme™",
  "vs10bbbonanza": "Big Bass Bonanza",
  "vs10bbbrlact": "Big Bass Bonanza - Reel Action",
  "vs10bbbnz1000": "Big Bass Bonanza 1000",
  "vs5bb3reeler": "Big Bass Bonanza 3 Reeler",
  "vswaysbbb": "Big Bass Bonanza Megaways™",
  "vs10bbbbrnd": "Big Bass Boxing Bonus Round",
  "vs10bbsplxmas": "Big Bass Christmas Bash™",
  "vs10bbglxmas": "Big Bass Christmas – Frozen Lake",
  "1320": "Big Bass Crash™",
  "vs10bbbnz": "Big Bass Day at the Races",
  "vs10bbfloats": "Big Bass Floats My Boat",
  "vs10bhallbnza2": "Big Bass Halloween 2",
  "vs10bhallbnza3": "Big Bass Halloween 3",
  "vs10bhallbnza": "Big Bass Halloween™",
  "vswaysbbhas": "Big Bass Hold & Spinner Megaways™",
  "vs10bbrcdr": "Big Bass Raceday Repeat",
  "vs10bbrrp": "Big Bass Reel Repeat",
  "vs10bbrttr": "Big Bass Return to the Races",
  "vs10bblotgl": "Big Bass Secrets of the Golden Lake",
  "vs10txbigbass": "Big Bass Splash",
  "vs10bbsplashx": "Big Bass Splash 1000",
  "vs10bbtrphfshn": "Big Bass Trophy Catch",
  "vs10bbdoubled": "Big Bass Vegas Double Down Deluxe",
  "vs10bbxext": "Big Bass Xmas Xtreme",
  "vs10bbhas": "Big Bass – Hold & Spinner",
  "vs10bburger": "Big Burger Load it up with Xtra cheese",
  "vs40bigjuan": "Big Juan™",
  "vswaysbbarnh": "Bigger Barn House Bonanza",
  "vs12bbbxmas": "Bigger Bass Blizzard - Christmas Catch™",
  "vs12bbb": "Bigger Bass Bonanza™",
  "vs12bgrbspl": "Bigger Bass Splash",
  "2890": "Bingo Blast",
  "9999": "Bingo Lobby",
  "vs30bingomania": "Bingo Mania",
  "vs20trswild2": "Black Bull",
  "517": "Blackjack 10 - Azure",
  "791": "Blackjack 100 - Azure",
  "792": "Blackjack 101 - Azure",
  "372": "Blackjack 102 - Emerald",
  "373": "Blackjack 103 - Emerald",
  "374": "Blackjack 104 - Emerald",
  "375": "Blackjack 105 - Emerald",
  "376": "Blackjack 106 - Emerald",
  "689": "Blackjack 107 - Emerald",
  "698": "Blackjack 108 - Emerald",
  "650": "Blackjack 109",
  "651": "Blackjack 110",
  "652": "Blackjack 111",
  "325": "Blackjack 112",
  "326": "Blackjack 113",
  "327": "Blackjack 114",
  "667": "Blackjack 115",
  "668": "Blackjack 116",
  "669": "Blackjack 117",
  "670": "Blackjack 118",
  "726": "Blackjack 119",
  "346": "Blackjack 120",
  "727": "Blackjack 121",
  "728": "Blackjack 122",
  "729": "Blackjack 123",
  "732": "Blackjack 124",
  "733": "Blackjack 125",
  "347": "Blackjack 126",
  "931": "Blackjack 127",
  "932": "Blackjack 128",
  "933": "Blackjack 129",
  "1155": "Blackjack 130",
  "1157": "Blackjack 131",
  "1153": "Blackjack 132",
  "1154": "Blackjack 133",
  "1156": "Blackjack 134",
  "687": "Blackjack 135",
  "684": "Blackjack 136",
  "685": "Blackjack 137",
  "691": "Blackjack 138",
  "692": "Blackjack 139",
  "693": "Blackjack 140",
  "329": "Blackjack 141",
  "331": "Blackjack 142",
  "305": "Blackjack 16 - Green Studio",
  "521": "Blackjack 17 - Azure",
  "522": "Blackjack 18 - Azure",
  "523": "Blackjack 19 - Azure",
  "524": "Blackjack 20 - Azure",
  "525": "Blackjack 21 - Azure",
  "526": "Blackjack 22 - Azure",
  "527": "Blackjack 23 - Azure",
  "528": "Blackjack 24 - Azure",
  "529": "Blackjack 25 - Azure",
  "530": "Blackjack 26 - Azure",
  "539": "Blackjack 27 - Azure",
  "538": "Blackjack 28 - Azure",
  "537": "Blackjack 29 - Azure",
  "536": "Blackjack 30 - Azure",
  "535": "Blackjack 31 - Azure",
  "540": "Blackjack 32 - Azure",
  "541": "Blackjack 33 - The Club",
  "542": "Blackjack 34 - The Club",
  "543": "Blackjack 35 - The Club",
  "544": "Blackjack 36 - The Club",
  "562": "Blackjack 37 - Ruby",
  "563": "Blackjack 38 - Ruby",
  "564": "Blackjack 39 - Ruby",
  "565": "Blackjack 40 - Ruby",
  "555": "Blackjack 41 - Ruby",
  "556": "Blackjack 42 - Ruby",
  "557": "Blackjack 43 - Ruby",
  "558": "Blackjack 44 - Ruby",
  "559": "Blackjack 45 - Ruby",
  "560": "Blackjack 46 - Ruby",
  "561": "Blackjack 47 - Ruby",
  "551": "Blackjack 48 - Ruby",
  "552": "Blackjack 49 - Ruby",
  "553": "Blackjack 50 - Ruby",
  "554": "Blackjack 51 - Ruby",
  "594": "Blackjack 52 - Ruby",
  "595": "Blackjack 53 - Ruby",
  "596": "Blackjack 54 - Ruby",
  "597": "Blackjack 55 - Ruby",
  "593": "Blackjack 56 - Ruby",
  "598": "Blackjack 57 - Azure",
  "599": "Blackjack 58 - Azure",
  "600": "Blackjack 59 - Azure",
  "601": "Blackjack 60 - Azure",
  "602": "Blackjack 61 - Azure",
  "590": "Blackjack 63 - Azure",
  "620": "Blackjack 64 - Ruby",
  "621": "Blackjack 65 - Ruby",
  "626": "Blackjack 70 - Ruby",
  "616": "Blackjack 71 - Ruby",
  "617": "Blackjack 72 - Ruby",
  "618": "Blackjack 73 - Ruby",
  "619": "Blackjack 74 - Ruby",
  "730": "Blackjack 75 - Azure",
  "731": "Blackjack 76 - Azure",
  "569": "Blackjack 77 – Ruby",
  "570": "Blackjack 78 – Ruby",
  "676": "Blackjack 79 - Emerald",
  "677": "Blackjack 80 - Emerald",
  "678": "Blackjack 81 - Emerald",
  "673": "Blackjack 82 - Emerald",
  "674": "Blackjack 83 - Emerald",
  "675": "Blackjack 84 - Emerald",
  "683": "Blackjack 85 - Emerald",
  "369": "Blackjack 86 - Ruby",
  "776": "Blackjack 87 - Emerald",
  "777": "Blackjack 88 - Emerald",
  "778": "Blackjack 89 - Emerald",
  "516": "Blackjack 9 -  Azure",
  "767": "Blackjack 90 - Azure",
  "768": "Blackjack 91 - Azure",
  "769": "Blackjack 92 - Azure",
  "771": "Blackjack 93 - Azure",
  "694": "Blackjack 94 - Emerald",
  "696": "Blackjack 95 - Emerald",
  "697": "Blackjack 96 - Emerald",
  "787": "Blackjack 97 - Azure",
  "789": "Blackjack 98 - Azure",
  "790": "Blackjack 99 - Azure",
  "301": "Blackjack A",
  "511": "Blackjack Azure A",
  "512": "Blackjack Azure B",
  "513": "Blackjack Azure C",
  "514": "Blackjack Azure D",
  "515": "Blackjack Azure E",
  "518": "Blackjack Azure H",
  "519": "Blackjack Azure I",
  "520": "Blackjack Azure J",
  "302": "Blackjack B",
  "303": "Blackjack C",
  "304": "Blackjack D",
  "103": "Blackjack Lobby",
  "3001": "Blackjack X 1 - Azure",
  "3010": "Blackjack X 10 - Ruby",
  "3014": "Blackjack X 14 - Ruby",
  "3015": "Blackjack X 15 - Ruby",
  "3016": "Blackjack X 16 - Azure",
  "3017": "Blackjack X 17 - Azure",
  "3018": "Blackjack X 18 - Azure",
  "3019": "Blackjack X 19 - Ruby",
  "3002": "Blackjack X 2 - Azure",
  "3020": "Blackjack X 20 - Ruby",
  "3021": "Blackjack X 21 - Ruby",
  "3024": "Blackjack X 24 - Azure",
  "3025": "Blackjack X 25 - Azure",
  "3003": "Blackjack X 3 - Azure",
  "3004": "Blackjack X 4 - Ruby",
  "3005": "Blackjack X 5 - Ruby",
  "3006": "Blackjack X 6 - Azure",
  "3007": "Blackjack X 7 - Azure",
  "3008": "Blackjack X 8 - Ruby",
  "3009": "Blackjack X 9 - Ruby",
  "3046": "BlackjackX 11 - Emerald",
  "3047": "BlackjackX 12 - Emerald",
  "3048": "BlackjackX 13 - Emerald",
  "3049": "BlackjackX 22 - Emerald",
  "3050": "BlackjackX 23 - Emerald",
  "3051": "BlackjackX 26 - Emerald",
  "3052": "BlackjackX 27 - Emerald",
  "3053": "BlackjackX 28 - Emerald",
  "3054": "BlackjackX 29 - Emerald",
  "3055": "BlackjackX 30 - Emerald",
  "vs20mergedwndw": "Blade & Fangs",
  "vswaysfirewmw": "Blazing Wilds Megaways",
  "vs20lightblitz": "Blitz Super Wheel",
  "vswayswildb": "Bloody Dawn",
  "vs25bomb": "Bomb Bonanza",
  "vswaysbook": "Book of Golden Sands",
  "vs25bkofkngdm": "Book of Kingdoms",
  "vs20fatbook": "Book of Monsters",
  "vswaystut": "Book of Tut Megaways™",
  "vs10bookviking": "Book of Vikings",
  "vs25btygold": "Bounty Gold",
  "vs20bhunter": "Bounty Hunter",
  "vs20gembondx": "Bow of Artemis",
  "382": "Brazilian Blackjack 1",
  "237": "Brazilian Roulette",
  "vswaysbrickhos": "Brick House Bonanza",
  "vs75bronco": "Bronco Spirit",
  "vs4096bufking": "Buffalo King",
  "vswaysbufking": "Buffalo King Megaways",
  "vs25scolymp": "CULT.",
  "vs5luckydog": "Cachorro Sortudo",
  "vs243caishien": "Caishen's Cash",
  "vs243fortune": "Caishen's Gold",
  "vs20candybltz2": "Candy Blitz Bombs",
  "vs20candyblitz": "Candy Blitz™",
  "vs20fourmc": "Candy Corner",
  "vs20cjcluster": "Candy Jar Cluster™",
  "vswaysstrwild": "Candy Stars™",
  "vswayschilhtwo": "Captain Kraken Megaways",
  "vswaysbankbonz": "Cash Bonanza™",
  "vs20cashmachine": "Cash Box™",
  "vs20maskgame": "Cash Chips™",
  "vs20terrorv": "Cash Elevator",
  "vs25copsrobbers": "Cash Patrol",
  "vswayscashsurg": "Cash Surge",
  "2701": "Casino Hold'em",
  "vswaysexpandng": "Castle of Fire",
  "vswayscfglory": "Chase for Glory™",
  "vs25checaishen": "Chests of Cai Shen",
  "vs25caishen2": "Chests of Cai Shen 2",
  "vs10chkchase": "Chicken Chase",
  "vs20chickdrop": "Chicken Drop",
  "ar1chickrush": "Chicken+",
  "vs25chilli": "Chilli Heat",
  "vswayschilheat": "Chilli Heat Megaways",
  "vs10chillihmr": "Chilli Heat Spicy Spins",
  "481": "Chinese Speed Baccarat 1",
  "482": "Chinese Speed Baccarat 2",
  "vs10bxmasbnza": "Christmas Big Bass Bonanza",
  "vs20xmascarol": "Christmas Carol Megaways",
  "vs20cleocatra": "Cleocatra",
  "vs20mustanggld2": "Clover Gold",
  "vs12tropicana": "Club Tropicana",
  "vs12trpcnhour": "Club Tropicana - Happy Hour",
  "vs5spjokfp": "Code of Cairo",
  "vs20colcashzone": "Colossal Cash Zone™",
  "vs432congocash": "Congo Cash",
  "vswayscongcash": "Congo Cash XL",
  "vs40cosmiccash": "Cosmic Cash",
  "vs20mysteryst": "Country Farming™",
  "vswaysultrcoin": "Cowboy Coins",
  "vs10cowgold": "Cowboys Gold",
  "vs10crownfire": "Crown of Fire",
  "vsprg10cfire": "Crown of Fire",
  "vswayscryscav": "Crystal Caverns Megaways™",
  "2501": "Crystal Roulette",
  "vswayswerewolf": "Curse of the Werewolf Megaways",
  "vswayscyhecity": "Cyberheist City",
  "vs20earthquake": "Cyclops Smash™",
  "vs10djneko": "DJ Neko",
  "vs243dancingpar": "Dance Party",
  "vpdt11": "Darts",
  "vs20daydead": "Day of Dead™",
  "vs40demonpots": "Demon Pots™",
  "vs20devilic": "Devilicious",
  "vs50dmdcascade": "Diamond Cascade™",
  "vs15diamond": "Diamond Strike",
  "scdiamond": "Diamond Strike 100,000",
  "vswayseternity": "Diamonds Of Egypt™",
  "cs3w": "Diamonds are Forever 3 Lines",
  "1401": "Dice City",
  "vs10ddcbells": "Ding Dong Christmas Bells™",
  "vs5tdragresk": "Dino Drop",
  "vs20underground": "Down the Rails",
  "vs1600drago": "Drago - Jewels of Fortune",
  "vs10dgold88": "Dragon Gold 88",
  "vs20drgbless": "Dragon Hero",
  "vs5drhs": "Dragon Hot Hold and Spin",
  "vs10dkinghp": "Dragon King Hot Pots",
  "vs25dragonkingdom": "Dragon Kingdom",
  "vs5drmystery": "Dragon Kingdom - Eyes of Fire",
  "vswaysdragden": "Dragon Pots Megaways",
  "1001": "Dragon Tiger",
  "bndt": "Dragon Tiger",
  "vswayshuffpbh": "Dragon Tiger Fortunes",
  "vs20drtgold": "Drill that Gold",
  "vswaysyinyang": "Duel of Night & Day",
  "3338": "Dutch BlackjackX 5",
  "vswaysspltsym": "Dwarf & Dragon",
  "vs25dwarves": "Dwarven Gold",
  "vs25dwarves_new": "Dwarven Gold Deluxe",
  "vs10dyndigd": "Dynamite Diggin Doug",
  "vs20egypttrs": "Egyptian Fortunes",
  "vswayselements": "Elemental Gems Megaways™",
  "vs20eking": "Emerald King",
  "vs10dublin": "Emerald King - Wheel of Wealth",
  "vs20ekingrr": "Emerald King Rainbow Road",
  "vs10emotiwins": "Emotiwins",
  "vs20emptybank": "Empty the Bank",
  "vs10fireice": "Escape the Pyramid - Fire & Ice",
  "vswaysfreezet": "Eternal Empress – Freeze Time",
  "vs20excalibur": "Excalibur Unleashed™",
  "vs10fruity2": "Extra Juicy",
  "vswaysxjuicy": "Extra Juicy Megaways",
  "vs40cleoeye": "Eye of Cleopatra",
  "vs15eyeofspart": "Eye of Spartacus",
  "vs10eyestorm": "Eye of the Storm",
  "vs15fairytale": "Fairytale Fortune",
  "vs10fangfree": "Fangtastic Freespins",
  "vplfl6": "Fantastic League Football",
  "vs20beefed": "Fat Panda™",
  "vs10gbseries": "Fiesta Fortune",
  "vs10fingerlfs": "Finger Lick’n Free Spins",
  "vs7fire88": "Fire 88",
  "vs25archer": "Fire Archer",
  "vs100firehot": "Fire Hot 100",
  "vs20fh": "Fire Hot 20",
  "vs40firehot": "Fire Hot 40",
  "vs5firehot": "Fire Hot 5",
  "vsprg5firehot": "Fire Hot 5 Jackpot Play",
  "vs20portals": "Fire Portals",
  "vswaysfirest2": "Fire Stampede 2",
  "vswaysfirest3": "Fire Stampede Ultimate",
  "vswaysstampede": "Fire Stampede™",
  "vs10firestrike": "Fire Strike",
  "vs10firestrike2": "Fire Strike 2",
  "vswaysconcoll": "Firebird Spirit",
  "vs10fisheye": "Fish Eye",
  "vs10goldfish": "Fishin' Reels",
  "vpfh3": "Flat Horse Racing",
  "vs10floatdrg": "Floating Dragon",
  "vs10fdrasbf": "Floating Dragon - Dragon Boat Festival™",
  "vs10fdsnake": "Floating Dragon - Year of the Snake",
  "vswaysfltdrg": "Floating Dragon Megaways",
  "vswaysfltdrgny": "Floating Dragon New Year Festival™",
  "vs10fdwhorses": "Floating Dragon Wild Horses",
  "vs10fonzofff": "Fonzo’s Feline Fortunes",
  "4001": "Football Blitz Top Card",
  "vpmr9": "Force 1 Racing",
  "vs20forge": "Forge of Olympus™",
  "vs20forgewilds": "Forging Wilds",
  "434": "Fortune 6 Baccarat",
  "vs40wildrun": "Fortune Hit’n Roll",
  "270": "Fortune Roulette",
  "vswaysaztecgm": "Fortune of Aztec",
  "vs20amuleteg": "Fortune of Giza",
  "vs20olympgcl": "Fortune of Olympus",
  "vswaysstrlght": "Fortunes of Aztec™",
  "980": "Free Bet Blackjack 1",
  "981": "Free Bet Blackjack 2",
  "vs20frankie": "Frightening Frankie",
  "vs10frontrun": "Front Runner Odds On",
  "vswaysftropics": "Frozen Tropics",
  "vs20fruitparty": "Fruit Party",
  "vs20fparty2": "Fruit Party 2",
  "vs40frrainbow": "Fruit Rainbow",
  "vs20fortbon": "Fruity Treats",
  "vswaysfuryodin": "Fury of Odin Megaways",
  "vs20gtsofhades": "Gates of Hades",
  "vs20olympgate": "Gates of Olympus",
  "vs20olympx": "Gates of Olympus 1000™",
  "2244": "Gates of Olympus Roulette",
  "vs20olympgold": "Gates of Olympus Super Scatter",
  "vs20olympxmas": "Gates of Olympus Xmas 1000",
  "vs10runes": "Gates of Valhalla™",
  "vs20clustext": "Gears of Horus",
  "vs20elevclust": "Gem Elevator",
  "vs20gemfirefor": "Gem Fire Fortune",
  "vs9gemtrio": "Gem Trio",
  "vs20goldfever": "Gems Bonanza",
  "vs20lcount": "Gems of Serengeti™",
  "vs20gengembnz": "Genie’s Gem Bonanza",
  "vs20rome": "Glorious Rome",
  "vs20gobnudge": "Goblin Heist Powernudge",
  "vs10gizagods": "Gods of Giza™",
  "vswaysincwnd": "Gold Oasis™",
  "vs25goldparty": "Gold Party",
  "vs25goldpartya": "Gold Party 2 - After Hours",
  "vs25goldrush": "Gold Rush",
  "scgoldrush": "Gold Rush 250,000",
  "vs3train": "Gold Train",
  "vs75empress": "Golden Beauty",
  "vs10luckfort": "Good Luck & Good Fortune",
  "vs1024gmayhem": "Gorilla Mayhem",
  "vs20gravity": "Gravity Bonanza™",
  "vs50grghsts": "Great Ghosts!",
  "vs25sea": "Great Reef",
  "vs20rhino": "Great Rhino",
  "vs20rhinoluxe": "Great Rhino Deluxe",
  "vswaysrhino": "Great Rhino Megaways",
  "vs10fortnpig": "Greedy Fortune Pig",
  "vs20wolfie": "Greedy Wolf",
  "vs243fortseren": "Greek Gods",
  "vpdr7": "Greyhound Racing",
  "vs40hmrstrm": "Hammerstorm",
  "vs20midas2": "Hand of Midas 2",
  "vs10dmreels": "Happy Dragon",
  "vs40mstrwild": "Happy Hooves",
  "vs20fishptrn": "Happy Nets",
  "vs20dhousehm": "Haunted Crypt",
  "vs20heartcleo": "Heart of Cleopatra",
  "vs25rio": "Heart of Rio",
  "vs20hstgldngt": "Heist for the Golden Nugget™",
  "vs243nudge4gold": "Hellvis Wild™",
  "vs50hercules": "Hercules Son of Zeus",
  "vs20hercpeg": "Hercules and Pegasus",
  "vs20shootstars": "Heroic Spins",
  "2201": "High Flyer",
  "vs5himalaw": "Himalayan Wild",
  "vs20hockey": "Hockey League",
  "vs9hockey": "Hockey League Wild Match",
  "vs20honey": "Honey Honey Honey",
  "vs9hotroll": "Hot Chilli",
  "vs25hotfiesta": "Hot Fiesta",
  "vs20dugems": "Hot Pepper",
  "vs25safari": "Hot Safari",
  "scsafari": "Hot Safari 50,000",
  "vs40hotburnx": "Hot To Burn Extreme",
  "vs10hottuna": "Hot Tuna",
  "vs5hotburn": "Hot to Burn",
  "vs10hottb7fs": "Hot to Burn - 7 Deadly Free Spins",
  "vs20hburnhs": "Hot to Burn Hold and Spin",
  "vsprg5hburn": "Hot to Burn Jackpot Play",
  "vs5hotbmult": "Hot to Burn Multiplier",
  "vs100hsandks": "Hundreds and Thousands",
  "vs20stickypos": "Ice Lobster",
  "vs20popbottles": "Ice Mints",
  "vs20slightwdm": "Idol Pop Fever",
  "292": "Immersive Roulette Deluxe",
  "vs20thunder": "Inca Queen",
  "1160": "Indonesian ONE Blackjack",
  "450": "Indonesian Speed Baccarat 1",
  "vs40infwild": "Infective Wild™",
  "cs3irishcharms": "Irish Charms",
  "vs20irishcrown": "Irish Crown",
  "223": "Italian Roulette",
  "vs10jpblaze": "Jackpot Blaze",
  "vs20jhunter": "Jackpot Hunter",
  "vpa": "Jacks or Better",
  "2601": "Jacks or Better Draw Poker",
  "vs1024butterfly": "Jade Butterfly",
  "vs10jnmntzma": "Jane Hunter and the Mask of Montezuma™",
  "488": "Japanese Speed Baccarat 1",
  "489": "Japanese Speed Baccarat 2",
  "490": "Japanese Speed Baccarat 3",
  "vs20mvwild": "Jasmine Dreams",
  "vs5jellyc": "Jelly Candy",
  "vs20payanyvol": "Jelly Express",
  "vs20jewelparty": "Jewel Rush™",
  "vs10booklight": "John Hunter and Galileo's Secrets",
  "vs7776secrets": "John Hunter and the Aztec Treasure",
  "vs10bookoftut": "John Hunter and the Book of Tut",
  "vs10tut": "John Hunter and the Book of Tut Respin™",
  "vs10bookfallen": "John Hunter and the Book of the Fallen",
  "vs10mayangods": "John Hunter and the Mayan Gods",
  "vs20bermuda": "John Hunter and the Quest for Bermuda Riches™",
  "vs25scarabqueen": "John Hunter and the Tomb of the Scarab Queen",
  "vs25davinci": "John Hunter and the secrets of Da Vinci’s Treasure™",
  "vs25jokerking": "Joker King",
  "vs5joker": "Joker's Jewels",
  "vs5jokjewhs": "Joker's Jewels Hold & Spin",
  "vs5jjwild": "Joker's Jewels Wild",
  "vs5jokerjc": "Joker’s Jewels Cash",
  "vs10jokerhot": "Joker’s Jewels Hot",
  "vs25journey": "Journey to the West",
  "vs50juicyfr": "Juicy Fruits",
  "vs50jfmulthold": "Juicy Fruits Multihold™",
  "vs20jjjack": "Jumbo Safari",
  "vs20gorilla": "Jungle Gorilla",
  "vs4096jurassic": "Jurassic Giants",
  "vs10kingofdth": "Kingdom of The Dead™",
  "vs25spotz": "Knight Hot Spotz™",
  "vs10cenrlgdevl": "Knights vs Barbarians",
  "1159": "Korean ONE Blackjack",
  "213": "Korean Roulette",
  "441": "Korean Speed Baccarat 1",
  "449": "Korean Speed Baccarat 2",
  "459": "Korean Speed Baccarat 3",
  "460": "Korean Speed Baccarat 4",
  "476": "Korean Speed Baccarat 5",
  "477": "Korean Turbo Baccarat",
  "vs20godiva": "Lady Godiva",
  "vs13ladyofmoon": "Lady of the Moon",
  "vs20lampinf": "Lamp Of Infinity™",
  "vswayslavabls": "Lava Balls",
  "vs20leprexmas": "Leprechaun Carol",
  "vs20leprechaun": "Leprechaun Song",
  "vs5littlegem": "Little Gem",
  "vs20lobcrab": "Lobster Bob's Crazy Crab Shack™",
  "vs20lobseafd": "Lobster Bob’s Sea Food and Win It",
  "vs20lbstrhouse": "Lobster House",
  "211a1": "Lucky 6 Roulette",
  "vs5luckdce88": "Lucky Dice",
  "vs5luckydogly": "Lucky Dog",
  "vs50chinesecharms": "Lucky Dragons",
  "vs5luckycol": "Lucky Fortune Tree",
  "vs10luckcharm": "Lucky Grace And Charm",
  "vswayslight": "Lucky Lightning",
  "vs5luckymly": "Lucky Monkey",
  "vs10forwildly": "Lucky Mouse",
  "vs25newyear": "Lucky New Year",
  "vs10fortnhsly": "Lucky Ox",
  "vs5lckpnd": "Lucky Panda",
  "vs5luckyphnly": "Lucky Phoenix",
  "vs5luckytigly": "Lucky Tiger",
  "vs5luckyt1kly": "Lucky Tiger 1000",
  "vs5luckytru": "Lucky Tiger Gold",
  "vs25luckpub": "Lucky's Wild Pub 2",
  "vs25luckwildpb": "Lucky’s Wild Pub",
  "vs5luckym": "Macaco Sortudo",
  "vs10madame": "Madame Destiny",
  "vswaysmadame": "Madame Destiny Megaways",
  "vs243crystalcave": "Magic Crystals",
  "vs8magicjourn": "Magic Journey",
  "vs10mmm": "Magic Money Maze",
  "vs4096magician": "Magician Secrets™",
  "vswaysmwss": "Mahjong Wins Super Scatter",
  "vs25goldrexp": "Majestic Express - Gold Run",
  "vs20mammoth": "Mammoth Gold Megaways",
  "vs9chen": "Master Chen's Fortune",
  "vs1mjokfp": "Master Gems",
  "vs1masterjoker": "Master Joker",
  "vs20medusast": "Medusa's Stone",
  "442": "Mega Baccarat",
  "204": "Mega Roulette",
  "2901": "Mega Roulette 3000",
  "2101": "Mega Sic Bac",
  "701": "Mega Sic Bo",
  "801": "Mega Wheel",
  "vs20mmdtres": "Mermaid’s Treasure Trove",
  "vswaysmfreya": "Might of Freya Megaways™",
  "vs50mightra": "Might of Ra",
  "vs50kingkong": "Mighty Kong",
  "vs20mmmelon": "Mighty Munching Melons",
  "ar1minehnt": "Mines+",
  "vs20minerush": "Mining Rush",
  "vs20mochimon": "Mochimon",
  "vs20clreacts": "Moleionaire",
  "vs25mmouse": "Money Mouse",
  "vs20bblitz": "Money Stacks",
  "vswaysbblitz": "Money Stacks Megaways™",
  "2750": "Money Time",
  "vs9madmonkey": "Monkey Madness",
  "vs243mwarrior": "Monkey Warrior",
  "vs20superlanche": "Monster Superlanche",
  "vs20muertos": "Muertos Multiplier Megaways",
  "bjma": "Multihand Blackjack",
  "vswaysmjwl2": "Mummy's Jewels 100",
  "vswaysmjwl": "Mummy`s Jewels",
  "vs25mustang": "Mustang Gold",
  "vswaysgoldcol": "Mustang Gold Megaways",
  "vs10trail": "Mustang Trail™",
  "vs4096mystery": "Mysterious",
  "vs10wildtut": "Mysterious Egypt",
  "vs20powerwild": "Mystery Mice",
  "vswaysmorient": "Mystery of the Orient",
  "vswayswest": "Mystic Chief™",
  "vs7fire88fp": "Mystic Wishes",
  "vs20nilefort": "Nile Fortunes™",
  "vs50northgard": "North Guardians",
  "901": "ONE Blackjack",
  "902": "ONE Blackjack 2 - Ruby",
  "12140": "ONE Blackjack Latino",
  "vs20octobeer": "Octobeer Fortunes",
  "vswaysolwfp": "Olympus Wins",
  "vs10noodles": "Oodles of Noodles",
  "vs20oragold": "Oracle of Gold",
  "vswayspizza": "PIZZA! PIZZA? PIZZA!",
  "scpanda": "Panda Gold 10,000",
  "vs25pandagold": "Panda's Fortune",
  "vs25pandatemple": "Panda's Fortune 2",
  "vs40pdmrsg": "Pandemic Rising",
  "vs25pantherqueen": "Panther Queen",
  "vs10powerlines": "Peak Power",
  "vs20pblinders": "Peaky Blinders",
  "vs25peking": "Peking Luck",
  "vppso4": "Penalty Shootout",
  "vs25xmasparty": "Penguins Christmas Party Time",
  "vswaystonypzz": "Peppe's Pepperoni Pizza Plaza",
  "vs20phoenixf": "Phoenix Forge",
  "vs25pfarmfp": "Pig Farm",
  "vs9piggybank": "Piggy Bank Bills™",
  "vs20piggybank": "Piggy Bankers™",
  "vs20ltng": "Pinup Girls",
  "vs40pirate": "Pirate Gold",
  "vs40pirgold": "Pirate Gold Deluxe",
  "vs20mtreasure": "Pirate Golden Age",
  "vs50pixie": "Pixie Wings",
  "ar10plinko": "Plinko+",
  "vs1dragon888": "Plushie Wins",
  "vswaysmegareel": "Pompeii Megareels Megaways™",
  "vs20stckwldsc": "Pot of Fortune",
  "vswayspowzeus": "Power of Merlin Megaways™",
  "vswayshammthor": "Power of Thor Megaways",
  "240": "PowerUP Roulette",
  "101": "Pragmatic Lobby Live Casino",
  "slotsLobby": "Pragmatic Lobby Slots",
  "454": "Privé Lounge Baccarat 1",
  "455": "Privé Lounge Baccarat 2",
  "456": "Privé Lounge Baccarat 3",
  "457": "Privé Lounge Baccarat 4",
  "458": "Privé Lounge Baccarat 5",
  "466": "Privé Lounge Baccarat 6",
  "467": "Privé Lounge Baccarat 7",
  "468": "Privé Lounge Baccarat 8",
  "4511": "Privé Lounge Baccarat with Squeeze 1",
  "4512": "Privé Lounge Baccarat with Squeeze 2",
  "721": "Privé Lounge Blackjack 1",
  "751": "Privé Lounge Blackjack 10",
  "1146": "Privé Lounge Blackjack 11",
  "1147": "Privé Lounge Blackjack 12",
  "1148": "Privé Lounge Blackjack 13",
  "1149": "Privé Lounge Blackjack 14",
  "722": "Privé Lounge Blackjack 2",
  "723": "Privé Lounge Blackjack 3",
  "724": "Privé Lounge Blackjack 4",
  "725": "Privé Lounge Blackjack 5",
  "747": "Privé Lounge Blackjack 6",
  "748": "Privé Lounge Blackjack 7",
  "749": "Privé Lounge Blackjack 8",
  "750": "Privé Lounge Blackjack 9",
  "28201": "Privé Lounge Roulette",
  "28301": "Privé Lounge Roulette Deluxe",
  "vs20lvlup": "Pub Kings™",
  "vs25pyramid": "Pyramid King",
  "vs1024atlantis": "Queen of Atlantis",
  "vs10egrich": "Queen of Gods",
  "vs25queenofgold": "Queen of Gold",
  "scqog": "Queen of Gold 100,000",
  "vs243queenie": "Queenie",
  "vs20goldclust": "Rabbit Garden",
  "vswaysmltchmgw": "Raging Waterfall Megaways™",
  "vs20rainbowg": "Rainbow Gold",
  "vs40rainbowr": "Rainbow Reels™",
  "vs20powerpays": "Red Hot Luck",
  "vs25rlbank": "Reel Banks",
  "vs20bison": "Release the Bison",
  "vs20kraken": "Release the Kraken",
  "vs20kraken2": "Release the Kraken 2",
  "vswayskrakenmw": "Release the Kraken Megaways™",
  "vswaysresurich": "Resurrecting Riches",
  "vs10returndead": "Return of the Dead",
  "vswaysloki": "Revenge of Loki Megaways",
  "vs9ridelightng": "Ride The Lightning",
  "vs40stckwldlvl": "Ripe Rewards",
  "vs10nudgeit": "Rise of Giza PowerNudge",
  "vswayshexhaus": "Rise of Pyramids",
  "vs20rockvegas": "Rock Vegas Mega Hold & Spin",
  "vswaysrockblst": "Rocket Blast Megaways™",
  "vs20rnriches": "Rolling in Treasures",
  "233": "Romanian Roulette",
  "vs25romeoandjuliet": "Romeo and Juliet",
  "rla": "Roulette",
  "227": "Roulette 1 Azure",
  "230": "Roulette 10 - Ruby",
  "229": "Roulette 8 - Indian",
  "201": "Roulette A",
  "222": "Roulette Germany - Deutsches Roulette",
  "206": "Roulette Macao",
  "vswayscashconv": "Running Sushi",
  "11174": "Russian Blackjack 1",
  "11175": "Russian Blackjack 2",
  "11176": "Russian Blackjack 3",
  "11177": "Russian Blackjack 4",
  "11178": "Russian Blackjack 5",
  "11179": "Russian Blackjack 6",
  "1175": "Russian Privé Lounge Blackjack 1",
  "221": "Russian Roulette",
  "vs50safariking": "Safari King",
  "vs12scode": "Samurai Code",
  "vs20santa": "Santa",
  "vs20porbs": "Santa's Great Gifts™",
  "vs10santasl": "Santa's Slay",
  "vs20santawonder": "Santa's Wonderland™",
  "vs20rainbowrsh": "Santa's Xmas Rush",
  "vswayssavlgnd": "Savannah Legend",
  "vs25spgldways": "Secret City Gold",
  "vs20sparta": "Shield of Sparta™",
  "vs100sh": "Shining Hot 100",
  "vs20sh": "Shining Hot 20",
  "vs40sh": "Shining Hot 40",
  "vs5sh": "Shining Hot 5",
  "711": "Sic Bo",
  "vs50jucier": "Sky Bounty™",
  "vs25sleepdrag": "Sleeping Dragon",
  "vs20smugcove": "Smugglers Cove™",
  "vs10snakeeyes": "Snakes & Ladders 2 – Snake Eyes",
  "1601": "Snakes & Ladders Live",
  "vs10snakeladd": "Snakes and Ladders Megadice™",
  "vs20clustersw": "Snow Party",
  "1301": "Spaceman",
  "234": "Spanish Roulette",
  "vs40spartaking": "Spartan King",
  "226": "Speed Auto Roulette",
  "428": "Speed Baccarat 10",
  "424": "Speed Baccarat 11",
  "421": "Speed Baccarat 12",
  "438": "Speed Baccarat 13",
  "405": "Speed Baccarat 14",
  "427": "Speed Baccarat 15",
  "435": "Speed Baccarat 16",
  "439": "Speed Baccarat 17",
  "415": "Speed Baccarat 6",
  "431": "Speed Baccarat 7",
  "432": "Speed Baccarat 8",
  "430": "Speed Baccarat 9",
  "402": "Speed Baccarat A",
  "403": "Speed Baccarat B",
  "412": "Speed Baccarat C",
  "414": "Speed Baccarat D",
  "566": "Speed Blackjack 1 - Ruby",
  "606": "Speed Blackjack 10 - Ruby",
  "608": "Speed Blackjack 12 - Azure",
  "609": "Speed Blackjack 14 - Azure",
  "612": "Speed Blackjack 15 - Ruby",
  "613": "Speed Blackjack 16 - Ruby",
  "614": "Speed Blackjack 17 - Ruby",
  "615": "Speed Blackjack 18 - Ruby",
  "658": "Speed Blackjack 19 - Emerald",
  "567": "Speed Blackjack 2 - Ruby",
  "659": "Speed Blackjack 20 - Emerald",
  "660": "Speed Blackjack 21 - Emerald",
  "661": "Speed Blackjack 22 - Emerald",
  "641": "Speed Blackjack 24 - Emerald",
  "642": "Speed Blackjack 25 - Emerald",
  "643": "Speed Blackjack 26 - Emerald",
  "644": "Speed Blackjack 27 - Emerald",
  "645": "Speed Blackjack 28 - Emerald",
  "646": "Speed Blackjack 29 - Emerald",
  "568": "Speed Blackjack 3-Ruby",
  "647": "Speed Blackjack 30 - Emerald",
  "681": "Speed Blackjack 31 - Emerald",
  "682": "Speed Blackjack 32 - Emerald",
  "688": "Speed Blackjack 34 - Emerald",
  "686": "Speed Blackjack 35 - Emerald",
  "370": "Speed Blackjack 38 - Ruby",
  "371": "Speed Blackjack 39 - Ruby",
  "779": "Speed Blackjack 40 - Emerald",
  "780": "Speed Blackjack 41 - Emerald",
  "781": "Speed Blackjack 42 - Emerald",
  "770": "Speed Blackjack 43 - Azure",
  "772": "Speed Blackjack 44 - Azure",
  "773": "Speed Blackjack 45 - Azure",
  "774": "Speed Blackjack 46 - Azure",
  "775": "Speed Blackjack 47 - Azure",
  "788": "Speed Blackjack 51 - Azure",
  "784": "Speed Blackjack 52 - Azure",
  "785": "Speed Blackjack 53 - Azure",
  "786": "Speed Blackjack 54 - Azure",
  "377": "Speed Blackjack 55 - Emerald",
  "378": "Speed Blackjack 56 - Emerald",
  "379": "Speed Blackjack 57 - Emerald",
  "380": "Speed Blackjack 58 - Emerald",
  "381": "Speed Blackjack 59 - Emerald",
  "591": "Speed Blackjack 6 - Ruby",
  "690": "Speed Blackjack 60 - Emerald",
  "695": "Speed Blackjack 61 - Emerald",
  "328": "Speed Blackjack 62",
  "330": "Speed Blackjack 64",
  "332": "Speed Blackjack 66",
  "592": "Speed Blackjack 7 - Ruby",
  "604": "Speed Blackjack 8 - Ruby",
  "605": "Speed Blackjack 9 - Ruby",
  "203": "Speed Roulette",
  "205": "Speed Roulette 2",
  "vs20splmystery": "Spellbinding Mystery™",
  "vs10spellmastr": "Spellmaster",
  "vswaysfrywld": "Spin & Score Megaways™",
  "ar1spire": "Spire+",
  "vs10spiritadv": "Spirit of Adventure",
  "851": "Squeeze Baccarat",
  "vswayshive": "Star Bounty",
  "vs10starpirate": "Star Pirates Code™",
  "vs20schristmas": "Starlight Christmas",
  "vs20starlightx": "Starlight Princess 1000™",
  "vswaysjapan": "Starlight Princess Pachi",
  "vs20starprss": "Starlight Princess Super Scatter",
  "vs20starlight": "Starlight Princess™",
  "vswayssw": "Starlight Wins",
  "vs117649starz": "Starz Megaways",
  "vs10stmreels": "Steamin’ Reels",
  "vpsc10": "Steeplechase",
  "vs20clustwild": "Sticky Bees",
  "vs10strawberry": "Strawberry Cocktail",
  "vs40streetracer": "Street Racer",
  "vs5strh": "Striking Hot 5",
  "vs20cm": "Sugar Rush",
  "vs20sugarrush": "Sugar Rush",
  "vs20sugarrushx": "Sugar Rush 1000",
  "vs20sugrushss": "Sugar Rush Super Scatter",
  "vs20sugrux": "Sugar Rush Xmas™",
  "vs20sugarnudge": "Sugar Supreme Powernudge™",
  "vswaysmegwghts": "Sumo Supreme Megaways",
  "vs5super7": "Super 7s",
  "433": "Super 8 Baccarat",
  "vs5supergummy": "Super Gummy Strike",
  "vs5spjoker": "Super Joker",
  "vs5tikistrike": "Super Tiki Strike",
  "vs20superx": "Super X™",
  "vs20fruitsw": "Sweet Bonanza",
  "vs20fruitswx": "Sweet Bonanza 1000",
  "1101": "Sweet Bonanza CandyLand",
  "vs20swbonsup": "Sweet Bonanza Super Scatter",
  "vs20sbxmas": "Sweet Bonanza Xmas",
  "vs10luckybnz": "Sweet Burst",
  "vs20chestcol": "Sweet Craze",
  "vs20clspwrndg": "Sweet Powernudge",
  "vs20swrbon": "Sweet Rush Bonanza",
  "vs20swordofares": "Sword of Ares",
  "vs20egypt": "Tales of Egypt",
  "vs10diamondrgh": "Temple Guardians",
  "vs1024temuj": "Temujin Treasures",
  "453": "Thai Baccarat 1",
  "261": "Thai Roulette",
  "451": "Thai Speed Baccarat 1",
  "vswaysalterego": "The Alter Ego",
  "vs10amm": "The Amazing Money Machine",
  "vs20bigdawgs": "The Big Dawgs",
  "1501": "The Bingo Spot",
  "vs9catz": "The Catfather",
  "vs30catz": "The Catfather II",
  "vs25champ": "The Champions",
  "vs20doghouse": "The Dog House",
  "vs20doghouse2": "The Dog House - Dog or Alive",
  "vs20dhcluster2": "The Dog House - Muttley Crew",
  "vs20dhdice": "The Dog House Dice Show™",
  "vswaysdogs": "The Dog House Megaways",
  "vs20doghousemh": "The Dog House Multihold",
  "vs20dhsuper": "The Dog House – Royal Hunt",
  "vs1024dtiger": "The Dragon Tiger",
  "vs20chicken": "The Great Chicken Escape",
  "vs20stickysymbol": "The Great Stick-Up",
  "vs20midas": "The Hand of Midas",
  "vs20sknights": "The Knight King",
  "vs20magicpot": "The Magic Cauldron - Enchanted Brew",
  "vswaysmoneyman": "The Money Man Megaways™",
  "vswaysredqueen": "The Red Queen",
  "vs20ultim5": "The Ultimate 5",
  "vswayswildgang": "The Wild Gang™",
  "vs40madwheel": "The Wild Machine",
  "vs10threestar": "Three Star Fortune",
  "vs10tictac": "Tic Tac Take",
  "vs5luckytig": "Tigre Sortudo",
  "vswaystimber": "Timber Stacks™",
  "vs50fatfrogs": "Tiny Toads",
  "vs20theights": "Towering Fortunes™",
  "vs18mashang": "Treasure Horse",
  "1701": "Treasure Island",
  "vs20trsbox": "Treasure Wild™",
  "vs25tripleps": "Treasures of Osiris",
  "vs1fortunetree": "Tree of Riches",
  "vs20treesot": "Trees of Treasure",
  "vs5trdragons": "Triple Dragons",
  "vs5trjokers": "Triple Jokers",
  "vswaystrpgug": "Triple Pot Diamond",
  "vswaysasiatrzn": "Triple Pot Gold",
  "vs1tigers": "Triple Tigers",
  "vswaysjkrdrop": "Tropical Tiki",
  "vswaysraghex": "Tundra’s Fortune™",
  "426": "Turbo Baccarat",
  "322": "Turkish Blackjack 1",
  "11136": "Turkish Blackjack 12",
  "11137": "Turkish Blackjack 13",
  "11138": "Turkish Blackjack 14",
  "11139": "Turkish Blackjack 15",
  "11140": "Turkish Blackjack 16",
  "208": "Turkish Mega Roulette",
  "904": "Turkish ONE Blackjack",
  "1152": "Turkish Privé Lounge Blackjack",
  "224": "Turkish Roulette",
  "321": "Turkish Speed Blackjack 1",
  "323": "Turkish VIP Blackjack 1",
  "vs5luckytwr": "Tut's Treasure Tower",
  "vs20dhcluster": "Twilight Princess™",
  "vs5ultrab": "Ultra Burn",
  "vs5ultra": "Ultra Hold and Spin",
  "266": "VIP Auto Roulette",
  "546": "VIP Blackjack 1 - Ruby",
  "623": "VIP Blackjack 10 - Ruby",
  "624": "VIP Blackjack 11 - Ruby",
  "625": "VIP Blackjack 12 - Ruby",
  "671": "VIP Blackjack 13 - Emerald",
  "672": "VIP Blackjack 14 - Emerald",
  "547": "VIP Blackjack 2 - Ruby",
  "548": "VIP Blackjack 3 - Ruby",
  "549": "VIP Blackjack 4 - Ruby",
  "550": "VIP Blackjack 5 - Ruby",
  "662": "VIP Blackjack 6 - Emerald",
  "663": "VIP Blackjack 7 - Emerald",
  "664": "VIP Blackjack 8 - Emerald",
  "622": "VIP Blackjack 9 - Ruby",
  "545": "VIP Roulette - The Club",
  "vs10vampwolf": "Vampires vs Wolves",
  "vswayswbounty": "Vampy Party",
  "vs20vegasmagic": "Vegas Magic",
  "vs25vegas": "Vegas Nights",
  "262": "Vietnamese Roulette",
  "vs20sugarcoins": "Viking Forge™",
  "vswaysvlcgds": "Volcano Goddess",
  "vs40voodoo": "Voodoo Magic",
  "vs20bigmass": "Waves of Poseidon",
  "vs5wfrog": "Wealthy Frog",
  "vs20multiup": "Wheel O’ Gold",
  "vswayswildeq": "Wheel of Happiness",
  "vs20bchprty": "Wild Beach Party",
  "vs20stickywild": "Wild Bison Charge™",
  "vs20wildboost": "Wild Booster",
  "vswaysrsm": "Wild Celebrity Bus Megaways™",
  "vs40wanderw": "Wild Depths™",
  "vs25gladiator": "Wild Gladiators",
  "vs20mparty": "Wild Hop&Drop",
  "vs20wildpix": "Wild Pixies",
  "vswayscyclop": "Wild Skullz",
  "vs25wildspells": "Wild Spells",
  "vs25walker": "Wild Walker",
  "vs20pistols": "Wild West Duels",
  "vs40wildwest": "Wild West Gold",
  "vs20wwgcluster": "Wild West Gold Blazing Bounty",
  "vswayswildwest": "Wild West Gold Megaways",
  "vswayswwhex": "Wild Wild Bananas",
  "vswayswwjoker": "Wild Wild Joker",
  "vswayspearls": "Wild Wild Pearls",
  "vs576treasures": "Wild Wild Riches",
  "vswayswwriches": "Wild Wild Riches Megaways",
  "vswayswwrichr": "Wild Wild Riches Returns",
  "vswaysbufstamp": "Wild Wildebeest Wins",
  "vs25wildies": "Wildies",
  "vs20procountx": "Wisdom of Athena 1000",
  "vs20procountxm": "Wisdom of Athena 1000 Xmas",
  "vs20procount": "Wisdom of Athena™",
  "vswayswildbrst": "Witch Heart Megaways",
  "vs25wolfgold": "Wolf Gold",
  "scwolfgold": "Wolf Gold 1,000,000",
  "vs25quadwolf": "Wolf Gold 4 Pack",
  "vs25wolfjpt": "Wolf Gold Power Jackpot",
  "vs25ultwolgol": "Wolf Gold Ultimate",
  "vs20yotdk": "Year of the Dragon King",
  "vs20mesmult": "Yeti Quest",
  "vs10piggybank": "You Can Piggy Bank On It",
  "vswaysyumyum": "Yum Yum Powerways",
  "vs15godsofwar": "Zeus vs Hades - Gods of War™",
  "vs15zeushadseq": "Zeus vs Hades – Gods of War 250",
  "vswaysreelbtl": "Zeus vs Typhon",
  "vswayszombcarn": "Zombie Carnival",
  "vswayspompmr2": "Zombie School Megaways",
  "100JW": "100 Jewels",
  "TGANG": "30's Gangster",
  "3DFAL": "3D Farm HD",
  "50PUL": "50s PinUp HD",
  "7FIRE": "7 on Fire",
  "ASTRO": "ASTROMAYA",
  "ABUSB": "Abu's Bazaar",
  "VPAAF": "Aces And Faces HD",
  "AAPES": "Age of Apes",
  "ALCTZ": "Alcatraz",
  "ALCHE": "Alchemist",
  "ALIEN": "Alien Domination",
  "VPALL": "All American HD",
  "ALLFL": "All Fruits HD",
  "AMRST": "American Roulette",
  "GOEGY": "Ancient Gold Of Egypt",
  "AED25": "Angeli e Demoni25 HD",
  "AQUAL": "Aquarium HD",
  "ARCHA": "Archibald Africa HD",
  "ARCHM": "Archibald Maya HD",
  "ARCHO": "Archibald Orient HD",
  "ADETL": "Arena de Toros HD",
  "AGOLD": "Athens Gold",
  "ALUXY": "Athens Luxury",
  "ATLAN": "Atlantis",
  "AZTXP": "Aztec's Golden Wheel",
  "BBSTH": "B-Boys Street HD",
  "BACCS": "Baccarat Slider",
  "SANTA": "Baking for Santa",
  "BANKH": "Banana King HD",
  "BKMAX": "Banana King MAX",
  "BNDTB": "Bandits Bounty HD",
  "BEECL": "Bee Crazy HD",
  "BSLOT": "Bee Slot",
  "BIGGZ": "Big Grizzly",
  "BJSTD": "Black Jack",
  "BJPRV": "Black Jack Privee",
  "BJPRO": "Black Jack Pro",
  "BJSST": "Black Jack Single",
  "BJSPV": "Black Jack Single Privee",
  "BJSPR": "Black Jack Single Pro",
  "BWEST": "Bloody West",
  "BBTMW": "Boo Beat MegaWays",
  "BOSHA": "Book Of Shadows",
  "BPDLX": "Book of Pharaon Deluxe",
  "BOPHA": "Book of Pharaon HD",
  "BSHNL": "Book of Shenlong",
  "BTREA": "Botticelli Treasure",
  "BCLAN": "Buffalo Clan",
  "BSQUE": "Burlesque",
  "BURLL": "Burlesque HD",
  "BCASH": "Burning Cash",
  "BURNF": "Burning Fruits",
  "CKIDD": "CAPTAIN KIDD",
  "CAESR": "Caesar's Arena",
  "CBARS": "Candy Bar Slider",
  "CARNB": "Carnival Bonus HD",
  "CASAN": "Casanovas Romance HD",
  "CHAOS": "Chaos & Dragons",
  "CHATW": "Chat&Win",
  "CHINA": "China Long HD",
  "CEVOL": "Circus Evolution HD",
  "COCKC": "Cock Combat",
  "CEGY2": "Comic Egypt 2",
  "CONGO": "Congo The Kong Quest",
  "CLIFL": "Country Life HD",
  "CBGWL": "Cowboys Go West HD",
  "CFARM": "Crazy Farm",
  "CRIML": "Crime Records HD",
  "CUORE": "Cuore dell'Oceano",
  "CSHES": "Cyber She Slider",
  "DHELL": "Dante Hell HD",
  "DPARA": "Dante Paradise HD",
  "DPURG": "Dante Purgatory HD",
  "DORXP": "Dead Or Revenge",
  "DJELL": "DeeJelly",
  "VPDWD": "Deuces Wild HD",
  "DEVLD": "Devil Dice",
  "DEVIL": "Devil Girl",
  "DIABL": "Diablo",
  "DIAMB": "Diamond Bonus",
  "DIAML": "Diamond Croupier HD",
  "DS80L": "Disco 80 HD",
  "DBABY": "Disco Baby",
  "DIVAS": "Divas",
  "DIWIN": "Diwinity",
  "VPDJP": "Double Joker Poker HD",
  "DRSMR": "Dr. Santa & Mr. Claus",
  "DRAGN": "Dragon",
  "DRGNL": "Dragon Legions",
  "DHLLW": "Dragon's Hollow",
  "DRAGQ": "Dragons Queen",
  "DRAGR": "Dragons Reels HD",
  "DRIVE": "Driver",
  "DJACK": "Dynamite Jack",
  "ESCPE": "Egyptian Escape",
  "EGYWH": "Egyptian WILD HD",
  "SUENO": "El Sueño de Antonio y Erandi",
  "ELFJO": "Elf Jo",
  "ECOMH": "Elite Commandos HD",
  "RISER": "Empire Rise of Rome",
  "EXNDG": "Explosive Nudge",
  "FAFAM": "Fa Fa Mahjong",
  "FAFAS": "Fa Fa Spin",
  "FFSMW": "Fa Fa Spin Megaways",
  "FARST": "Fair Roulette",
  "FARPV": "Fair Roulette Privee",
  "FARPR": "Fair Roulette Pro",
  "EGYPT": "Fantastic Egypt",
  "FANTL": "Fantasy Island HD",
  "FARMA": "Farm Adventures HD",
  "FNIGH": "Fight Night HD",
  "FHERO": "Fire Heroes",
  "FSTGO": "FirstGo",
  "FDEEP": "Fish Game Single Player",
  "FISHW": "Fish Wishes",
  "FELXR": "Fortune Elixir",
  "FORTN": "Fortunella",
  "4GODB": "Four God Beasts",
  "FRRST": "French Roulette",
  "FRRPV": "French Roulette Privee",
  "FRRPR": "French Roulette Pro",
  "FHITS": "FruHits",
  "MANGA": "Fruit Manga",
  "PUNCH": "Fruit Punch",
  "FJLLY": "FruitJolly",
  "WLTFW": "Fruitful Wheel",
  "FDIML": "Fruits Dimension HD",
  "FEVOL": "Fruits Evolution HD",
  "FR4JP": "Fruits4Jackpot HD",
  "FUNNY": "Funny Monkey",
  "GENGH": "Genghis' reel",
  "GENTL": "Gentleman Thief HD",
  "GERON": "Geronimo",
  "GNIGL": "Ghosts Night HD",
  "GLAML": "Glamour Hills HD",
  "GOWLD": "Go Wild HD",
  "GOBLN": "Goblin's Tavern",
  "GOLAZ": "Golazo HD",
  "GOFRA": "Gold Of Ra",
  "GRICH": "Gold Riches",
  "GROME": "Gold of Rome",
  "GOLDP": "Golden Pig",
  "GOLDT": "Golden Tree",
  "GHPOT": "Goodluck Hot Pot",
  "VISIR": "Gran Visir",
  "JOKER": "Grande Joker",
  "HNJOY": "HENjoy",
  "HVAMP": "Hard Vampire",
  "HHTEL": "Haunted Hotel",
  "HVNNC": "Havana Nights Cuba",
  "HAWLD": "Hawild Island",
  "HMAJE": "Heart Majesty",
  "HERCL": "Hercules HD",
  "HEROL": "Hero War HD",
  "HILOS": "Hi-Lo Slider",
  "HOLWL": "Hollywood HD",
  "HORRL": "Horror Castle HD",
  "HBURL": "Hot Burlesque",
  "BOSSL": "Il Boss",
  "ILPAS": "Il Pasticciere",
  "INFLU": "Influencer",
  "ITWMW": "Into The Wilds Megaways",
  "INTWL": "Into The Woods HD",
  "WILDS": "Into The Wilds",
  "VPJOB": "Jacks Or Better HD",
  "JAMBO": "Jambo Reels",
  "JBAND": "Jazz Band",
  "VPJPA": "Joker Poker Aces HD",
  "VPJPK": "Joker Poker Kings HD",
  "JOLLY": "Jolly Roger",
  "JOLYM": "Jungle Olympics",
  "JUSTH": "Just Hot",
  "KINGM": "King Midas",
  "KINGN": "King Neptun",
  "KTUTL": "King Tuts Chamber HD",
  "KVALL": "Kings Valley",
  "LARCA": "LArca",
  "TROLL": "LOT Land Of Trolls",
  "LOTUS": "LOTUS LUCK",
  "LGAMB": "LUCKY GAMBLINK",
  "LGLAL": "Lady Glamour",
  "LADYS": "Lady Sheriff",
  "LTNLV": "Latin Lover",
  "NORTH": "Lord Of North",
  "LOVEL": "Love Lab HD",
  "LOVER": "Love Reaction",
  "LCKDR": "Lucky Dragon",
  "MFROG": "Magic Frog",
  "MMPAL": "Magic Moon Palace",
  "MQUEL": "Magic Quest HD",
  "MATOG": "Mato Grosso Adventures",
  "MAXML": "Maximum HD",
  "MAYAN": "Mayan Solar Eclipses",
  "VPMGJ": "Mega Jack HD",
  "MXMAS": "Mellow Christmas",
  "MDASR": "Midas' Realm",
  "MDLDY": "Million Dollar Lady",
  "MISSJ": "Miss Jones",
  "MVSSL": "Monkeys Vs Sharks HD",
  "MOONS": "Moon Fligth Slider",
  "MOONW": "Moonlit Waltz",
  "MRMML": "Mr Moneymake HD",
  "MCAFE": "MrFirstCafé",
  "MUERT": "Muertos Locos",
  "MYTHL": "Mythos HD",
  "NSPIN": "Need For Spin HD",
  "NEPTN": "Neptune's Secrets",
  "NYGNG": "New York Gangs",
  "NYREL": "New York Real Estate HD",
  "NVAMP": "Night Vampire HD",
  "WLTNJ": "Nile Jewel",
  "NILEM": "Nile's Mystery",
  "ODISS": "Odissea",
  "OLYMR": "Olympus Reels",
  "PFUXP": "Panda Fury",
  "PANDA": "Panda Paradise",
  "PARAD": "Paradise Beach",
  "PATSP": "Patrick's Party",
  "PRENO": "Pela el reno",
  "PTALE": "Pharaoh's Tale",
  "PHNXW": "Phoenix Wheel",
  "PGEES": "Pig Gees - Disco Farm",
  "P7SEA": "Pirates of the Seven Seas",
  "PROUT": "Pirates' Route",
  "PADVL": "Polar Adventure HD",
  "POLAR": "Polar Angler",
  "PREST": "Prestige",
  "PNTOG": "Punto G",
  "PURPL": "Purple Win",
  "PCATS": "Pussycats' Valley",
  "QUEEN": "Queen of Oceans HD",
  "CROWN": "Queen's Crown",
  "RLOOT": "ROBIN'S LOOT",
  "RAINB": "Rainbow HD",
  "REWLD": "Re-Wild",
  "REIDC": "Rei do Carnaval",
  "REYDT": "Rey de Toros",
  "ROBOT": "Robotika HD",
  "ROMAH": "Romantic Holidays",
  "ROWBF": "RowBotic Fruits",
  "ROYAL": "Royal Key",
  "SCLUE": "SUPER CLUE",
  "SAHAR": "Sahara",
  "SCARL": "Scary Fruits HD",
  "SOSCX": "Secret Of ScarabX",
  "SOSPH": "Secret Of Sphinx",
  "SHARK": "Shark Go",
  "SHERL": "Sherlock",
  "SLOTC": "Slot Cup",
  "SONGK": "Songkran Holidays",
  "SPACE": "Space Bar",
  "SBARS": "Space Bar Slider",
  "BLAST": "Space Blast",
  "SMONH": "Space Monsters HD",
  "SFSQD": "Starforce Squad",
  "SGRXP": "Steel Greezly",
  "STVKL": "Striking Viking HD",
  "SRUSH": "Sugarush HD",
  "SULTA": "Sultan",
  "CLSSC": "Super Classic",
  "CREEP": "Super Creeps",
  "VPSLV": "Super Las Vegas HD",
  "SPRHH": "SuperHeroes HD",
  "TLPUB": "THE LUCKY PUB",
  "VPTOB": "Tens Or Better HD",
  "ARENA": "The Arena",
  "CLOWN": "The Clown",
  "TCLUB": "The Club",
  "FORBL": "The Forbidden City HD",
  "GSHOW": "The Greatest Show",
  "LASTL": "The Last Crusade HD",
  "PINGL": "The Pinguizz HD",
  "PTAVL": "The Pirates Tavern HD",
  "VPTSN": "The Saloon HD",
  "TYRAZ": "The Tyragnez",
  "TOMAH": "Tomahawk",
  "TRIXL": "Trixel",
  "TROPT": "Tropical Talisman",
  "TRUEA": "True American",
  "TYPAN": "Tuan Yuan Panda",
  "20KLS": "Twenty Thousand Leagues Under The Sea",
  "UAGEL": "Uga Age HD",
  "VALKW": "Valkyries Warrior",
  "VAMPH": "Vampire Killer HD",
  "WLTVT": "Vampire Touch",
  "VKEEP": "Vault Keeper",
  "VKLGL": "Viking Legend HD",
  "WCKED": "Wicked Reels",
  "WBUFF": "Wild West Buffalo",
  "WILYF": "Wily Fox",
  "WOLFD": "Wolf's Den",
  "XCALL": "Xcalibur HD",
  "ZENBL": "Zen Blade HD",
  "ZEUSS": "Zeus Strike",
  "ZOMBL": "Zombie Lab",
  "ZOMBN": "Zombie Nation",
  "100_joker_staxx": "100 Joker Staxx",
  "25_cookies": "25 Cookies: Hit the Bonus",
  "3carts_of_gold": "3 Carts of Gold: Hold and Win",
  "3_chillies_and_joker": "3 Chillies & Joker: Hold and Win",
  "3_fruits_win_10": "3 Fruits Win: 10 Lines",
  "3_luxor_pots": "3 Luxor Pots: Hold and Win",
  "3_magic_lamps": "3 Magic Lamps: Hold and Win",
  "3_pirate_barrels": "3 Pirate Barrels: Hold and Win",
  "3pots_extra": "3 Pots Riches Extra: Hold and Win",
  "3pots_riches": "3 Pots Riches: Hold and Win",
  "3_royal_coins": "3 Royal Coins: Hold & Win",
  "3xcatch": "3x Catch",
  "4_pots_riches": "4 Pots Riches: Hold and Win",
  "4_scarab_coins": "4 Scarab Coins: Hold and Win",
  "4_supercharged_clovers": "4 Supercharged Clovers: Hold and Win",
  "5_fortunator": "5 Fortunator",
  "5_super_sevens_n_fruits": "5 Super Sevens and Fruits",
  "777sizzling_wins": "777 Sizzling Wins: 5 lines",
  "9_happy_pharaohs": "9 Happy Pharaohs",
  "arizona_heist": "Arizona Heist: Hold and Win",
  "blazing_wins": "Blazing Wins: 5 lines",
  "book_of_parimatch": "Book Of Parimatch: Double Chance",
  "book_del_sol": "Book del Sol: Multiplier",
  "book_of_gold_classic": "Book of Gold: Classic",
  "book_of_gold": "Book of Gold: Double Chance",
  "book_of_gold_multichance": "Book of Gold: Multichance",
  "bozo_cats": "Bozo Cats",
  "buffalo_power_2": "Buffalo Power 2: Hold and Win",
  "buffalo_megaways": "Buffalo Power Megaways",
  "buffalo_xmas": "Buffalo Power: Christmas",
  "buffalo_power": "Buffalo Power: Hold and Win",
  "burning_fort": "Burning Fortunator",
  "burning_wins_x2": "Burning Wins x2",
  "burning_wins": "Burning Wins: classic 5 lines",
  "charge_clovers": "Charge the Clovers: Hit The Bonus™",
  "clover_charm": "Clover Charm: Hit the Bonus",
  "clover_strike": "Clover Strike: Hold and Win",
  "coin_strike_2": "Coin Strike 2: Hold and Win",
  "coin_strike_xxl": "Coin Strike XXL: Hold and Win",
  "coin_strike": "Coin Strike: Hold and Win",
  "crown_strike": "Crown Strike: Hold and Win",
  "crown_n_diamonds": "Crown and Diamonds: Hold and Win",
  "crystal_land": "Crystal Land",
  "crystal_land_2": "Crystal Land 2",
  "diamond_fort": "Diamond Fortunator: Hold and Win",
  "diamond_wins": "Diamond Wins: Hold and Win",
  "diamonds_power_xxl": "Diamonds Power XXL: Hold and Win",
  "diamonds_power": "Diamonds Power: Hold and Win",
  "divine_dragon": "Divine Dragon: Hold and Win",
  "eagle_power": "Eagle Power: Hold and Win",
  "empire_gold": "Empire Gold: Hold and Win",
  "energy_coins": "Energy Coins: Hold and Win",
  "energy_joker": "Energy Joker: Hold and Win",
  "fire_coins": "Fire Coins: Hold and Win",
  "fire_temple": "Fire Temple: Hold and Win",
  "flaming_bells": "Flaming Bells: Hold and Win",
  "fruits_and_jokers_100": "Fruits & Jokers: 100 Lines",
  "fruits_and_jokers_20": "Fruits & Jokers: 20 lines",
  "fruits_and_jokers_40": "Fruits & Jokers: 40 Lines",
  "fruits_n_stars_c": "Fruits'n'Stars",
  "giza_nights": "Giza Nights: Hold and Win",
  "golden_penny": "Golden Penny x1000",
  "hit_the_bank": "Hit the Bank: Hold and Win",
  "hot_burning_wins": "Hot Burning Wins",
  "hot_coins": "Hot Coins: Hold and Win",
  "imperial_fruits_100": "Imperial Fruits: 100 Lines",
  "imperial_fruits_40": "Imperial Fruits: 40 Lines",
  "imperial_fruits_5": "Imperial Fruits: 5 Lines",
  "jelly_valley": "Jelly Valley",
  "jingle_coins": "Jingle Coins: Hold and Win",
  "joker_expand": "Joker Expand: 5 Lines",
  "jokers_coins": "Joker's Coins: Hold and Win",
  "juice_inc": "Juice Inc",
  "juice_and_fruits_c": "Juice and Fruits",
  "king_of_the_sky": "King of the Sky: Hit the Bonus™",
  "legend_of_cleopatra": "Legend of Cleopatra",
  "legend_of_cleopatra_megaways": "Legend of Cleopatra Megaways",
  "light_clovers": "Lightning Clovers - Hit the Bonus™",
  "lion_gems_3pots": "Lion Gems 3 Pots: Hold and Win",
  "lion_gems": "Lion Gems: Hold and Win",
  "luxor_gold": "Luxor Gold: Hold and Win",
  "mammoth_peak": "Mammoth Peak: Hold and Win",
  "merry_giftmas": "Merry Giftmas: Hold and Win",
  "moreenergycoins": "More Energy Coins: Hold and Win",
  "paddy_star": "Paddy Star: Smash and Win",
  "pearl_beauty": "Pearl Beauty: Hold and Win",
  "pearl_ocean": "Pearl Ocean Hold and Win",
  "piggy_power": "Piggy Power: Hit the Bonus™",
  "pink_joker": "Pink Joker: Hold and Win",
  "pirate_chest": "Pirate Chest: Hold and Win",
  "pirate_sharky": "Pirate Sharky",
  "power_crown": "Power Crown: Hold and Win",
  "rhino_coins": "Rhino Coins: Hit the Bonus™",
  "rich_diamonds": "Rich Diamonds: Hold and Win",
  "rise_of_egypt": "Rise of Egypt",
  "rockin_joker": "Rockin'Joker: Hold and Win",
  "rome_caesars_glory": "Rome: Caesar's Glory",
  "royal_coins_2": "Royal Coins 2: Hold and Win",
  "royal_coins": "Royal Coins: Hold and Win",
  "royal_express": "Royal Express: Hold and Win",
  "royal_fort": "Royal Fortunator: Hold and Win",
  "royal_joker": "Royal Joker: Hold and Win",
  "ruby_hit": "Ruby Hit: Hold and Win",
  "sevens_n_fruits": "Sevens&Fruits",
  "sevens_n_fruits_20": "Sevens&Fruits: 20 Lines",
  "sherwood_coins": "Sherwood Coins: Hold and Win",
  "solar_king": "Solar King",
  "solar_queen": "Solar Queen",
  "solar_queen_mega": "Solar Queen Megaways™",
  "solar_temple": "Solar Temple",
  "spirit_of_egypt": "Spirit of Egypt",
  "sugar_teddy": "Sugar Teddy",
  "sunny_fruits": "Sunny Fruits",
  "sunny_fruits_2": "Sunny Fruits 2: Hold and Win",
  "super_burning_wins": "Super Burning Wins",
  "super_pink_joker": "Super Pink Joker: Hold and Win",
  "super_sunny_fruits": "Super Sunny Fruits",
  "scharged_clovers": "Supercharged Clovers: Hold and Win",
  "thunder_coins_xxl": "Thunder Coins XXL: Hold & Win",
  "thunder_coins_xxl_multicoin": "Thunder Coins XXL: Multicoin",
  "thunder_coins": "Thunder Coins: Hold and Win",
  "timeless_diamonds": "Timeless Diamonds: Hold and Win",
  "tornado_power": "Tornado Power: Hold and Win",
  "treasures_fire": "Treasures of Fire: Scatter Pays",
  "ultra_fort": "Ultra Fortunator: Hold and Win",
  "vegas_glitz": "Vegas Glitz",
  "wolf_land": "Wolf Land: Hold and Win",
  "wolf_power_mega": "Wolf Power Megaways™",
  "wolf_power": "Wolf Power: Hold and Win",
  "golden_penny_2": "x1000 Golden Penny 2",
  "65fc125ffe5d030001c07a34": "64 Gold Coins Hold and Win",
  "6810e1a13d8c0d045acf2330": "64 Gold Coins Hold and Win 20,000",
  "69088eae2aa8dc41a265c247": "64 Nuggets Hold and Win",
  "6881f15b0c302a31e498b865": "64 Presents Hold and Win",
  "5de6616dfc94b4001af9e08e": "Arabian Spins",
  "5a37d2585397390020000013": "Asia Wins",
  "5ce681bb55e49c00148a86a5": "Aztec Palace",
  "63b450475e59b8000118d58f": "Bamboo Wilds",
  "602a6703efcba9001485f940": "Bang Bang",
  "5a032814ed1496000800000f": "Big Apple Wins",
  "63e21a63f78c9900017af6d6": "Billy Bob Boom",
  "68cbc635236322d0c183168d": "Black Friday Cart Craze",
  "6818bdf22a8d4da85b5622e3": "Blazin' Bonus",
  "61787bffbefa370011538086": "Blockchain Megaways",
  "67a22baf2b5971443f2b31ea": "Bonza Bucks Hold and Win Extreme 10000",
  "64abe7a9d5cc48000110f878": "Boogie Boom",
  "61616851befa370018538076": "Book of Poseidon",
  "5f48c770f2a091001423728c": "Book of Tombs",
  "594791455f97bf001b00000d": "Booming Bananas",
  "58231b3d381e0c00c400000d": "Booming Seven Deluxe",
  "67bc3a043517d4ed1b6fb7e8": "Booming Seven Deluxe Legacy",
  "5bc6f2806b226f000e0000ab": "Boomshakalaka",
  "5fca4cf5efcba9001685f940": "Buffalo Hold and Win",
  "6543a3fd913ea90001287dd5": "Buffalo Hold and Win Extreme",
  "5e732986ba03bd00171b05bb": "Burning Classics",
  "671f52698f989457247885a7": "Burning Classics 2",
  "672b2de882e7d48e70ecb764": "Burning Classics 5000",
  "6256ba20584e2d001065a312": "Burning Classics go Wild",
  "673b4b1bcb5a1ea5fc2f1eb2": "Burning Love",
  "63a053373e9ac9000187c16e": "Butterfly Charms",
  "5f3510b5737b43001a2e8ff2": "Cash Pig",
  "66cdb5175f4476fc0cee0e21": "Cash Pig 2",
  "68b958149efb62feafccc345": "Cash Pig 2 15,000",
  "655f1a057e7fb7000159a75c": "Chief Hawk Spirit Walk",
  "656dd80ef909530001a0d273": "Classic Coins",
  "637cf755a784e30001057f18": "Classic Fantastic",
  "580dc69068712a00a9000018": "Classico",
  "666810433dce1f0001d73561": "Coin Crusher",
  "62738aa3a81ac8000e974472": "Crack the Bank Hold and Win",
  "6087befc9e1ee6001afdf220": "Crystal Classics",
  "5d7a278f0b32f4001923b215": "Danger Zone",
  "65085b6f95281c0001dc7d92": "Diamond Hits",
  "6870da2227ed74cf4d6a9ab8": "Diamond Hits Trio: InstaStrike",
  "5fbb633befcba9001c85f940": "Diamond Riches",
  "68543e7f263be371f3c65909": "Diamonds Diamonds Diamonds Hold and Win",
  "683d70508bcef6b5fd932625": "Diamonds of Liberty",
  "62e1137c76d612000c06bb20": "Dice Dice Baby",
  "5b558e83ad47ec000d000066": "Disco Bar 7s",
  "63bd9c96673cf800018438d4": "Dog Heist Shift 'N' Win",
  "633184d763e1660001d289b3": "Dog Squard",
  "660ffac279ed5a0001047f10": "Dynamite Trio",
  "667a99b7139a36000132d94b": "Easter Classics",
  "68d66e1ec088c226e586644d": "Fish Tales Colossal Catch: Link & Loot",
  "66f2d9852599ad4e15913099": "Fish Tales Double Catch",
  "685a8812099b3683b14a0312": "Fish Tales Halloween",
  "667133e6f3f52500011444a6": "Fish Tales Monster Bass",
  "6915f901009b9ae1b8af7618": "Fish Tales Monster Bass 10000",
  "61787a29befa370016538076": "Flaming Chilies",
  "67531a5ad8ec30449a6dc308": "Fly On!",
  "6718ce97c14f81aa5290aaa3": "Forbidden Temple Power Hit",
  "616168aabefa370018538081": "Fortune & Finery",
  "5f3153ec737b43008ed75bb6": "Freezing Classics",
  "64ec56ada2e36a0001d2ee75": "Fruit Heaven Hold and Win",
  "6202363cbefa370016538086": "Gamblelicious Hold and Win",
  "6346e6fb33c14000011d2f4b": "Go Bananza",
  "68b6baf139c3041a9d1e68e2": "Gold & Glamour Hold and Win",
  "63566b0c26625500019175d7": "Gold Gold Gold",
  "655f5e7fd43c7c0001c603de": "Gold Gold Gold 5000",
  "67d9503160b217f36e5855de": "Gold Gold Gold Hold and Win",
  "6025058defcba9001885f942": "Gold Hunter",
  "5c811b24362176000fa6a2e2": "Gold Vein",
  "594780d85f97bf001b000001": "Golden Profits",
  "6304806e5f550b000e4eeaf1": "Golden Strawberries",
  "678a2f0c80afaeaeee5b0387": "Greedy for Gold Power Hit",
  "606d52719e1ee6001cfdf21e": "Greek Legends",
  "5e4b02abe711300015eb83e6": "Gunspinner",
  "6458c00b2e01ff00010a2090": "Holly Jolly Bonanza",
  "662b507981dbda0001ee7846": "Holly Jolly Bonanza 2",
  "66617b17f054fe00010634d0": "Holly Jolly Cash Pig",
  "5dee2eb29db4d9001cd9ee9c": "Hooked",
  "64a65ea0252178000174d0dc": "Hoop Kings",
  "65956a0d18441c00017de7a0": "Hot Charge",
  "5e9dab9cd04d620016b4906e": "Howling Wolves",
  "6093eb819e1ee60017fdf21e": "Howling Wolves Megaways",
  "662119d2de7d350001478c47": "Howling for Gold",
  "669e56d3e752ad00018998c8": "Inferno Fortune Power Hit",
  "6578466fc9215b0001208f66": "Jam Bonanza",
  "6603bfab33d346000153bddb": "Jester's Bells Bonanza",
  "61787b5dbefa370019538076": "Jester's Riches",
  "5f0440d7737b43008ed75bab": "Jesters Joy",
  "61debc32befa370011538096": "Khan's Wild Quest",
  "61787b92befa370019538086": "Kim's Wild Journey",
  "633c437186f7f10001c8f847": "King Cobra",
  "623dbc6a90e1870012b59236": "Legendary Diamonds",
  "62bde4e756dc080014ae001e": "Let it Spin",
  "67a22bda2b5971443f2b31ed": "Liberty and Freedom Hold and Win Extreme 10000",
  "63bbf0b15e59b8000118d595": "Light of Ra",
  "690db8e2c13324b79c4ea61e": "Lucky Charms Trio",
  "61787b78befa370012538076": "Lucky Oasis",
  "5ec22e4ad04d620015b4906e": "Lucky Scarabs",
  "5ff41d50efcba9001a85f940": "Majestic Safari",
  "6411815816f2ad00018e7426": "Mammoth Tundra",
  "6294abf79b2d00000e180197": "Megahops Megaways",
  "60c8728fdbc1440017518e05": "Mighty Gorilla",
  "63f38e5fe2ef820001bcf29f": "Money Inc",
  "6139c9740cc9a00015ece6fb": "Money Moose",
  "623f4cee90e187000eb59236": "Monster Truck Madness",
  "696a5d0769fdac342f000016": "Mr. Oinkster's Power Hit",
  "670ce57dff59bf05b690d898": "Mr. Oinksters Hold and Win",
  "6698dd16ecd7af0001346c1c": "Mustang Hold and Win",
  "66cc696134835104191dacd0": "Mustang and Stallions",
  "612776dfe58605001ac445e9": "Ocean Drive",
  "5a37d2355397390011000013": "Paris Nights",
  "6357e1bf23ea5a000133a3fe": "Payday Pig",
  "6358de4723ea5a000133a404": "Pinata Wildz",
  "68773dc449726e55df72f3a3": "Polar Buffalo Extreme Hold and Win 25,000",
  "66cc202ea49fd83508929fa1": "Power of Atlantis Trio",
  "68da7b277e388c9b5562d0d4": "Power of Hercules Bonanza",
  "634807c733c14000011d2f51": "Power of Olympus",
  "64a3e7c0afc503000168761e": "Power of Rome",
  "63fdd6b8428e5b0001dd7ca6": "Power of the Vikings",
  "6718c5b2c14f81aa5290aaa0": "Ra’s Relics Bonanza",
  "60ae48669e1ee60015fdf22a": "Red Hot Volcano",
  "65685714d77b6f0001c3315b": "Reels Paradise",
  "60faa3b0589d2900175cb98e": "Rhino Hold and Win",
  "6261c2b227d185001376cc68": "Roll the Dice",
  "66436d3fc069e700017e663e": "Ronaldinho Scores Shott & Win",
  "657c5fe0a8abcd000146d9ab": "Ronaldinho Spins",
  "5a007c32ed1496001100000d": "Royal Wins",
  "68b0395c0435c9f76a27e36a": "Santa In Vegas",
  "66c58a5d358353045c48eceb": "Santa's Snowball Smash Instant Win",
  "645b98d8abe4c600013e1998": "Secret Book of Amun-Ra",
  "6759cb78be63a13793c2bad8": "Shields of Gold Valkyrie Hold and Win",
  "6436be6c9268640001b42dd5": "Smoking Pistols",
  "641b253ef3cb4b00016f5224": "Space Cows to the Moo'n",
  "643d6f119268640001b42ddb": "Space Sam Walk & Win™",
  "5f7ec229f7447a0018f91ae4": "Sphinx Fortune",
  "669a38106d03fa00012f310c": "Spooktacular Bonanza",
  "648c55128eec0c0001c688b2": "Stampede Bonanza",
  "627384b0a81ac80010974472": "Starlight Riches",
  "61787ba0befa370011538076": "Sticky Bombs",
  "5b8f8fc5408b77001600015d": "Sugar Skulls",
  "63205f57313c900016e560dd": "Super Duper",
  "62fe444a6db4f70014a6342d": "TNT Bonanza",
  "659fbf8378185700011a2b2b": "TNT Bonanza 2",
  "662b862c81dbda0001ee7849": "Tasty Bonanza",
  "68b705d3800528273b1057c8": "Tasty Bonanza 10,000",
  "64ba7fc8ef3f980001fbab96": "The Chillies",
  "6272e427a81ac80014974472": "The Jungle Empire",
  "630dc4a95f550b000f4eeaf1": "The Mighty Toro",
  "62bde50056dc080011ae001e": "The Rodfather Megaways",
  "628215226698440014bd3bd9": "The Wild Wings of Phoenix",
  "660d1e866b579800019456d7": "The Wild Wings of Phoenix Deluxe",
  "66b083e7e149c6e19f3d4a1d": "Thunder Eagle Hold and Win Extreme 10,000",
  "62053097befa3700135380a1": "Treasure Vault",
  "691d74854c16cffe9c8d7701": "Trollfufu Bonanza",
  "68ece9ba61a58d61d01b9f9e": "Twin Buffalo: Hold & Win",
  "652504bcf33db2000161cfd3": "Ultimate Hold 'N' Win",
  "68773fa149726e55df72f3a6": "Ultra Buffalo Hold and Win",
  "5bd80c17b4d3b9000f00001b": "VIP Filthy Riches",
  "59316ea1f54229000900000c": "Valley of Pharaohs",
  "59677eea7d5d7c002400001c": "Vegas Wins",
  "60e58c90dbc14400186d67d4": "Wild Bonus Re-Spins",
  "5ac73df903726f000e000190": "Wild Diamond 7x",
  "5dba8c3e57fc8c001af595f7": "Wild Energy",
  "59b9221dbc5a81001700000a": "Wild Pride",
  "604b38b89e1ee60016fdf21e": "Wild Wild Vegas",
  "5d2c76dfa15bc900160c6a30": "Witches' Wild Brew",
  "5f9ad932f7447a001df72349": "Wizarding Wins",
  "5efc87eb737b430014d75bac": "Wombaroo",
  "10k_dice": "10K Dice",
  "243_fruity_zen": "243 Fruity Zen",
  "3_corsairs": "3 Corsairs",
  "across_the_universe_keno": "ACROSS THE UNIVERSE: KENO",
  "across_the_universe": "Across the Universe",
  "aloha_tiki_bar": "Aloha! Tiki bar",
  "amaterasu_keno": "Amaterasu Keno",
  "anksunamun_deluxe": "Anksunamun Deluxe",
  "anksunamun_tqoe": "Anksunamun: the queen of Egypt",
  "baccarat_mg": "Baccarat",
  "bamboo_bear": "Bamboo Bear",
  "bamboo_bear_deluxe": "Bamboo Bear Deluxe",
  "bastet_and_cats_deluxe": "Bastet & Cats Deluxe",
  "bastet_and_cats": "Bastet and Cats",
  "ben_gunn_robinson": "Ben Gunn Robinson",
  "bennys_the_biggest_game": "Benny's the Biggest game",
  "big_win_x25": "Big Win x25",
  "blackjack_mg": "Black Jack",
  "book_of_anksunamun_rockways": "Book Of Anksunamun Rockways",
  "book_of_amaterasu": "Book of Amaterasu",
  "booming_fruity_boom": "Booming Fruity Boom",
  "crash_hamster_crash": "CRASH, HAMSTER, CRASH",
  "cancan_saloon": "CanCan Saloon",
  "cancan_saloon_deluxe": "Cancan Saloon Deluxe",
  "candy_crush": "Candy Crush",
  "the_candy_keno": "Candy Keno",
  "holdem_mg": "Casino Hold'em",
  "catch_the_win": "Catch the Win",
  "christmas_infinite_gifts": "Christmas Infinite Gifts",
  "cleopatras_gems_rockways": "Cleopatra's Gems Rockways",
  "deepsea_riches": "Deepsea Riches",
  "double_roulette": "Double Roulette",
  "dragons_lucky_25": "Dragon's Lucky 25",
  "dragons_nest": "Dragon’s Nest",
  "dreamshock_jackpot_x": "Dreamshock: Jackpot X",
  "easter_luck": "Easter Luck",
  "european_roulette": "European Roulette",
  "evil_bet_shoot_them_all": "Evil Bet: Shoot Them All",
  "fabulous_farm_slot": "Fabulous Farm Slot",
  "fairytale_coven": "Fairytale Coven",
  "for_the_realm": "For The Realm",
  "for_the_realm_deluxe": "For the Realm Deluxe",
  "friar_tucks_inn": "Friar Truck’s Inn",
  "fruit_disco_ms": "Fruit Disco: Mega Stacks",
  "fruit_macau": "Fruit Macau",
  "fruit_machine_megabonus": "Fruit Machine Megabonus",
  "fruit_machine_x25": "Fruit Machine x25",
  "fruit_machine_mega_x": "Fruit Machine: Mega X",
  "fruit_monaco": "Fruit Monaco",
  "fruit_vegas": "Fruit Vegas",
  "fruit_vegas_extreme_x125": "Fruit Vegas Extreme x125",
  "fruits_of_luxor": "Fruits of Luxor",
  "fruity_x125": "Fruity X125",
  "gemz_grow": "Gemz Grow",
  "greedy_greenskins_rockways": "Greedy Greenskins Rockways",
  "gryphons_castle": "Gryphon's Castle",
  "gryphons_castle_rush25": "Gryphon's Castle Rush 25",
  "gryphons_castle_deluxe": "Gryphon’s Castle Deluxe",
  "gunman_crash": "Gunman Crash",
  "hellsing": "Hell'Sing",
  "hello_win": "HelloWin",
  "hot_fruit_x15": "Hot Fruit x15",
  "hydras_lair": "Hydras Lair",
  "ice_number_one": "Ice Number One",
  "icy_rockfall_x25": "Icy Rockfall x25",
  "jewel_boost_reels": "Jewel Boost Reels",
  "jimms_treasure": "Jimm's Treasure",
  "keno_party": "Keno Party",
  "kite_festival_crash_game": "Kite Festival",
  "la_fiesta_de_muertos": "La Fiesta de Muertos",
  "legioner": "Legioner",
  "lightning_path": "Lightning Path",
  "lions_pride": "Lion's Pride",
  "loot_the_train": "Loot the Train",
  "lucky_fruity_coin": "Lucky Fruity Coin",
  "lucky_year_25": "Lucky Year 25",
  "mayan_riches_bingo": "MAYAN RICHES: BINGO!",
  "marble_bounce": "Marble Bounce",
  "mayan_riches_rockways": "Mayan Riches Rockways",
  "merlins_tower": "Merlin's Tower",
  "mermaids_bay": "Mermaid's Bay",
  "merry_scary_christmas": "Merry Scary Christmas",
  "metal_frontiers": "Metal Frontiers",
  "mines_blast": "Mines Blast",
  "minotaurs_wilds": "Minotaurs Wilds",
  "mist": "Mist",
  "northern_heat": "Northern Heat",
  "ouija_secrets": "Ouija Secrets!",
  "overheat": "Overheat",
  "paper_lanterns_crash_game": "Paper Lanterns Crash Game",
  "pin_plinko": "Pin Plinko",
  "pinup_dolls": "Pinup Dolls",
  "plinball_machine": "Plinball Machine",
  "plinko_builder": "Plinko Builder",
  "plinko_pop": "Plinko Pop",
  "primal_bet_rockways": "Primal Bet.Rockways",
  "prince_of_persia_tgop": "Prince of Persia: the Gems of Persia",
  "princess_and_dwarfs_deluxe": "Princess and Dwarfs Deluxe",
  "purple_pills": "Purple Pills",
  "queen_of_spades": "Queen of Spades",
  "re_kill_ultimate": "RE KILL ULTIMATE",
  "re_kill": "Re Kill",
  "red_horde": "Red Horde",
  "reel_eldorado": "Reel Eldorado",
  "reveal_the_kraken": "Reveal The Kraken",
  "rice_and_riches": "Rice & Riches Hold & Win",
  "riot": "Riot",
  "riot_2_bnb": "Riot 2: Blow And Burn",
  "riot_brutalskis_revenge": "Riot Brutalski’s Revenge",
  "riot_ultimate": "Riot Ultimate",
  "riot_urban_wilds": "Riot: Urban Wilds",
  "robin_of_loxley": "Robin of Loxley",
  "rocket_chimp_jackpot": "Rocket Chimp Jackpot",
  "rooster_run": "Rooster Run",
  "sticky_fruit_madness": "STICKY FRUIT MADNESS",
  "scratch_the_bank": "Scratch the Bank",
  "secrets_of_papyrus": "Secrets of Papyrus",
  "shining_wilds": "Shining Wilds",
  "shooting_galaxy": "Shooting Galaxy",
  "skyrocket": "Sky rocket",
  "space_blaze": "Space Blaze",
  "space_gems_rockblocks": "Space Gems Rockblocks",
  "spicy_candies_rockblocks": "Spicy Candies Rockblocks",
  "th_and_the_mission_monte_carlo": "Tessa Hunt and the Mission Monte Carlo",
  "tessa_hunt_and_the_eye_of_horus": "Tessa Hunt and the Temple of Horus",
  "tessa_hunt_and_the_warrior_tomb": "Tessa Hunt and the Warrior Tomb",
  "the_biggest_win_x50": "The Biggest Win x50",
  "the_candy_slot_deluxe": "The Candy Slot Deluxe",
  "the_dawn_is_coming": "The Dawn is Coming",
  "the_epic_win_x125": "The Epic Win x125",
  "the_evil_bet": "The Evil Bet",
  "incredible_xfu_hero": "The Incredible X Fu Hero",
  "the_myth": "The Myth",
  "the_myth_deluxe": "The Myth Deluxe",
  "the_pendragon_legend": "The Pendragon Legend",
  "princess_and_dwarfs_rockways": "The Princess & Dwarfs: Rockways",
  "the_rite": "The Rite",
  "the_tomb_det": "The Tomb",
  "trump_card_queen": "Trump Card Green",
  "twin_fruits_of_olympus": "Twin Fruits of Olympus",
  "twin_fruits_of_santa": "Twin Fruits of Santa",
  "venetian_magic": "Venetian Magic",
  "videopoker_3in1": "Videopoker 3in1",
  "wood_luck": "WOOD LUCK!",
  "wasteland_riches": "Wasteland Riches",
  "wild_phoenix_rises": "Wild Phoenix Rises",
  "wild_spirit": "Wild Spirit",
  "wild_spirit_deluxe": "Wild Spirit Deluxe",
  "wild_wild_bet": "Wild Wild Bet",
  "wildlife_riches": "WildLife Riches",
  "yukon_fever": "Yukon Fever",
  "zeus_the_invincible": "Zeus The Invincible",
  "zeus_the_thunderer": "Zeus the Thunderer",
  "zeus_the_thunderer_deluxe": "Zeus the Thunderer Deluxe",
  "37992": "Atlantis",
  "62519": "Aviashow",
  "37238": "Bingo Star",
  "11289": "BlackJack",
  "20786": "Cash Show",
  "59619": "Chicken Crash",
  "35760": "Coin Flip",
  "42205": "Cosmo Saga",
  "2014": "Crash",
  "34139": "Crasher",
  "64793": "Deep Sea Wild",
  "41446": "Dr. Shocker",
  "32727": "F Mines",
  "47006": "Figoal",
  "55898": "Fruity Wilds",
  "53072": "Funny Faces: Hoglet-Mogle",
  "60138": "Gangsta Piggy: Hold and Win",
  "54061": "Gates of Asgard: Nine Realms",
  "27201": "Golden RA",
  "59424": "Guardians of Glory",
  "5236": "Hilo",
  "55358": "Hungry Wolf",
  "34829": "Jungle Wheel",
  "2010": "Keno 10 (1 Minute)",
  "15543": "Keno 10 (2 Minute)",
  "19": "Keno 8 (1 Minute)",
  "15542": "Keno 8 (2 Minute)",
  "10512": "Keno Express",
  "56127": "King of Ocean",
  "53831": "Knife Drop",
  "37236": "Lotto Boom",
  "38081": "Maestro",
  "36024": "Magic Dice",
  "32724": "Mr. Thimble",
  "34184": "NinjaCrash",
  "53055": "Olympian Legends",
  "6492": "Penalty",
  "50942": "Play Me",
  "54430": "Plinko Dice",
  "32725": "Plinkoman",
  "5935": "Rocketon",
  "34554": "Roulette X",
  "35838": "Scratch Map",
  "5339": "SicBo",
  "35956": "Totem",
  "39386": "Tower Rush",
  "37237": "Turbo Mines",
  "happy-seven-40": "40 Happy Seven",
  "adamant-bang-20": "Adamant Bang 20",
  "adamant-bang-40": "Adamant Bang 40",
  "adamant-bang-50": "Adamant Bang 50",
  "attractive-flirt-30": "Attractive Flirt 30",
  "attractive-flirt-50": "Attractive Flirt 50",
  "auto-dynamic-live-roulette-120": "Auto Dynamic Live Roulette 120",
  "auto-dynamic-live-roulette-500": "Auto Dynamic Live Roulette 500",
  "auto-dynamic-live-roulette-72": "Auto Dynamic Live Roulette 72",
  "auto-dynamic-live-roulette-deluxe-120": "Auto Dynamic Live Roulette Deluxe 120",
  "auto-dynamic-live-roulette-deluxe-500": "Auto Dynamic Live Roulette Deluxe 500",
  "auto-dynamic-live-roulette-deluxe-72": "Auto Dynamic Live Roulette Deluxe 72",
  "auto-live-roulette-deluxe": "Auto Live Roulette Deluxe",
  "auto-live-roulette-deluxe-vip": "Auto Live Roulette Deluxe Vip",
  "auto-live-roulette-vip": "Auto Live Roulette Vip",
  "auto-live-roulette": "Auto Roulette",
  "beasts-joy-30": "Beasts Joy 30",
  "beasts-joy-50": "Beasts Joy 50",
  "bivol-beasts": "Bivol Beasts",
  "bonbon-pop-1000": "Bonbon Pop 1000",
  "bonbon-pop": "Bonbon pop",
  "bounty-expand-25": "Bounty Expand 25",
  "lady-chance-10": "Bufona Alegre 10",
  "bufona-alegre-sun-link-10": "Bufona Alegre 10 Sun Link",
  "lady-chance-20": "Bufona Alegre 20",
  "lady-chance-40": "Bufona Alegre 40",
  "lady-chance-5": "Bufona Alegre 5",
  "celtic-bless": "Celtic Bless",
  "chica-alegre-10": "Chica Alegre 10",
  "chica-alegre-20": "Chica Alegre 20",
  "chica-alegre-5": "Chica Alegre 5",
  "devils-feast": "Devil's Feast",
  "dreamwood-40": "Dreamwood",
  "fruit-boom-20": "Dynamite Splash 20",
  "fruit-boom-5": "Dynamite Splash 5",
  "manual-live-roulette-emerald": "Emerald Roulette",
  "enigma-of-ellada": "Enigma Of Ellada",
  "festive-eve": "Festive Eve",
  "forever-gold": "Forever Golden",
  "fruit-boom-10": "Fruit Boom 10",
  "golden-fate": "Golden Fate",
  "golden-fate-1000": "Golden Fate 1000",
  "gummy-rain-100": "Gummy Rain",
  "gummy-rain-1000": "Gummy Rain 1000",
  "happy-seven-100": "Happy Seven 100",
  "happy-seven-20": "Happy Seven 20",
  "jade-dancer": "Jade Dancer",
  "jade-dancer-1000": "Jade Dancer 1000",
  "jester-bags-5-3": "Jester Bags",
  "jester-bags-10-5": "Jester Bags 10",
  "lost-in-giza-20": "Lost in Giza 20",
  "lost-in-giza-40": "Lost in Giza 40",
  "luz-de-draco-10": "Luz de Draco 10",
  "luz-de-draco-100": "Luz de Draco 100",
  "luz-de-draco-100-6": "Luz de Draco 100/6 reels",
  "luz-de-draco-20": "Luz de Draco 20",
  "luz-de-draco-40": "Luz de Draco 40",
  "luz-de-draco-40-6": "Luz de Draco 40/6 reels",
  "luz-de-draco-5": "Luz de Draco 5",
  "mjolnir-splash-10": "Mjölnir Splash",
  "mr-first": "Mr First",
  "mr-first-10": "Mr. First 10",
  "mr-money-bunny-10-5": "Mr. Money Bunny",
  "noble-fate-10": "Noble Fate 10",
  "noble-fate-20": "Noble Fate 20",
  "noble-fate-5": "Noble Fate 5",
  "octowins": "Octowins",
  "panda-manda": "Panda Manda",
  "fruit-chase-10": "Pome Race 10",
  "fruit-chase-20": "Pome Race 20",
  "fruit-chase-5": "Pome Race 5",
  "pome-race-sun-link-5": "Pome Race 5 Sun Link",
  "pome-race-sun-link-10": "Pome Race Sun Link 10",
  "pome-splash-5": "Pome Splash 5",
  "pome-splash-sun-link-5": "Pome Splash 5 Sun Link",
  "pure-ecstasy": "Pure Ecstasy",
  "quack-squad": "Quack Squad",
  "red-27": "Red 27",
  "redfate-pate-link-5": "Red Fate 5 Pate Link",
  "redfate-sun-link-5": "Red Fate 5 Sun Link",
  "redfate-10": "Redfate 10",
  "redfate-100": "Redfate 100",
  "redfate-100-6": "Redfate 100/6 Reels",
  "redfate-20": "Redfate 20",
  "redfate-40": "Redfate 40",
  "redfate-40-6": "Redfate 40/6",
  "redfate-5": "Redfate 5",
  "regal-spins-sun-link-20": "Regal Spin 20 Sunlink",
  "regal-spins-10": "Regal Spins 10",
  "regal-spins-pate-link-10": "Regal Spins 10 Pate Link",
  "regal-spins-sun-link-10": "Regal Spins 10 Sun Link",
  "regal-spins-10-xmas": "Regal Spins 10 Xmas",
  "regal-spins-100": "Regal Spins 100",
  "regal-spins-100-6": "Regal Spins 100/6 reels",
  "regal-spins-20": "Regal Spins 20",
  "regal-spins-40": "Regal Spins 40",
  "regal-spins-sun-link-40": "Regal Spins 40 Sun Link",
  "regal-spins-40-6": "Regal Spins 40/6 reels",
  "regal-spins-5": "Regal Spins 5",
  "sams-play": "Sam's Play",
  "scorching-reels-100": "Scorching Reels 100",
  "scorching-reels-40": "Scorching Reels 40",
  "sevens-heat-10": "Sevens Heat 10",
  "sevens-heat-100": "Sevens Heat 100",
  "sevens-heat-20": "Sevens Heat 20",
  "sevens-heat-40": "Sevens Heat 40",
  "sevens-heat-5": "Sevens Heat 5",
  "sevens-heat-sun-link-20": "Sevens Heat Sun Link 20",
  "sevens-heat-sun-link-40": "Sevens Heat Sun Link 40",
  "sevens-joy": "Sevens Joy",
  "sevens-play": "Sevens Play",
  "skeleton-shuffle": "Skeleton Shuffle",
  "skeleton-shuffle-1000": "Skeleton Shuffle 1000",
  "splash-cascade-25": "Splash Cascade 25",
  "vamphunt": "Vamp Hunt",
  "Redstone10CloverFire": "10 Clover Fire",
  "Redstone10ExtraBank": "10 Extra Bank",
  "Unicorn10JingleFruits": "10 Jingle Fruits",
  "WildCrown10": "10 Wild Crown",
  "Redstone10WildCrownHalloween": "10 Wild Crown Halloween",
  "WildDiamond10": "10 Wild Diamond",
  "WildDice10": "10 Wild Dice",
  "Redstone10WildHeart": "10 Wild Heart",
  "WildPumpkin10": "10 Wild Pumpkin",
  "WildSanta10": "10 Wild Santa",
  "Redstone100CloverFire": "100 Clover Fire",
  "Unicorn20DiceFlames": "20 Dice Flames",
  "FireCash20": "20 Fire Cash",
  "Redstone20FruitFrenzy": "20 Fruit Frenzy",
  "Unicorn20HotStrike": "20 Hot Strike",
  "Unicorn20HotStrikeDice": "20 Hot Strike Dice",
  "Unicorn20HotStrikeDiceJackpot": "20 Hot Strike Dice Jackpot",
  "Unicorn20HotStrikeJackpot": "20 Hot Strike Jackpot",
  "Unicorn20MegaFlames": "20 Mega Flames",
  "Unicorn20SuperFlames": "20 Super Flames",
  "Redstone27DoubleFruit": "27 Double Fruits",
  "PlayNet27LuckyFruits": "27 Lucky Fruits",
  "PlayNet27WildStacks": "27 Wild Stacks",
  "PlayNet27WildStacksXmas": "27 Wild Stacks Xmas",
  "CashBells40": "40 Cash Bells",
  "FireClover40": "40 Clover Fire",
  "FireDice40": "40 Dice Fire",
  "Unicorn40DiceFlames": "40 Dice Flames",
  "FireCash40": "40 Fire Cash",
  "Redstone40FruitFrenzy": "40 Fruit Frenzy",
  "Unicorn40FruitReels": "40 Fruit Reels",
  "Redstone40HotJoker": "40 Hot Joker",
  "Unicorn40HotStrike": "40 Hot Strike",
  "Unicorn40HotStrikeDice": "40 Hot Strike Dice",
  "Redstone40JokerFire": "40 Joker Fire",
  "Unicorn40MegaFlames": "40 Mega Flames",
  "WildClover40": "40 Wild Clover",
  "Redstone40WildCrown": "40 Wild Crown",
  "WildCloverDice40": "40 Wild Dice",
  "Redstone5BellFire": "5 Bell Fire",
  "FireClover5": "5 Clover Fire",
  "Redstone5CloverFireBlast": "5 Clover Fire Blast",
  "Redstone5CloverFireHalloween": "5 Clover Fire Halloween",
  "RedstoneClover5LockAndCash": "5 Clover Fire Lock & Cash",
  "CrownFire5": "5 Crown Fire",
  "FireCloverDice5": "5 Dice Fire",
  "FluoDice5": "5 Fluo Dice",
  "FluoHot5": "5 Fluo Hot",
  "Redstone5HeartDeluxe": "5 Heart Deluxe",
  "Unicorn5HotStrike": "5 Hot Strike",
  "Unicorn5HotStrikeDice": "5 Hot Strike Dice",
  "Redstone5StarFire": "5 Star Fire",
  "Redstone5WildFire": "5 Wild Fire",
  "WildHeart5": "5 Wild Heart",
  "WildClover506": "50 Wild Cash",
  "Redstone777ExtraChance": "777: Extra Chance",
  "Redstone81DoubleMagic": "81 Magic Double",
  "PlayNet81MagicStars": "81 Magic Stars",
  "Redstone81VegasCrown": "81 Vegas Crown",
  "ActionHot20": "Action Hot 20",
  "ActionHot40": "Action Hot 40",
  "AfricanTreasure": "African Treasure",
  "AgeOfRome": "Age of Rome",
  "AlohaCharm": "Aloha Charm",
  "AmazingJoker": "Amazing Joker",
  "RedstoneApollo27Classic": "Apollo 27 Classic",
  "AquaFlame": "Aqua Flame",
  "BellasWorld": "Bella's World",
  "UnicornBigHitSevens": "Big Hit Sevens",
  "UnicornBigSpinDice": "Big Spin Dice",
  "UnicornBigSpinDragons": "Big Spin Dragons",
  "UnicornBigSpinSevens": "Big Spin Sevens",
  "UnicornBikiniDice": "Bikini Dice",
  "UnicornBikiniFruits": "Bikini Fruits",
  "PlayNetBitSlot": "Bit Slot",
  "BlazingHeat": "Blazing Heat",
  "BlowFruits40": "Blow Fruits 40",
  "bluff-and-bite": "Bluff and Bite",
  "BonusBells": "Bonus Bells",
  "BonusCrown": "Bonus Crown",
  "BonusEpicCrown": "Bonus Epic Crown",
  "BonusEpicCrownDice": "Bonus Epic Crown Dice",
  "RedstoneBonusStars": "Bonus Stars",
  "PlayNetBookOfAmun": "Book of Amun",
  "BookOfBruno": "Book of Bruno",
  "BookOfDread": "Book of Dread",
  "BookOfIbis": "Book of Ibis",
  "BookOfLuxorDouble": "Book of Luxor Double",
  "RedstoneBookOfScorpio": "Book of Scorpio",
  "BookOfSpells": "Book of Spells",
  "BookOfSpells2": "Book of Spells 2",
  "BookOfSpellsDeluxe": "Book of Spells Deluxe",
  "PlayNetBrewmastersBank": "Brewmaster's Bank",
  "BrilliantHeart": "Brilliant Heart",
  "UnicornBuffaloSevens": "Buffallo Sevens",
  "UnicornBuffaloDice": "Buffalo Dice",
  "BuffaloFortune": "Buffalo Fortune",
  "UnicornBuffaloSevensJackpot": "Buffalo Sevens Jackpot",
  "UnicornBunnyDice": "Bunny Dice",
  "UnicornByeBouse": "Bye Bouse",
  "RedstoneCapsAndCrowns": "Caps and Crowns",
  "UnicornCasinoFruits": "Casino Fruits",
  "RedstoneChilliDouble": "Chilli Double",
  "RedstoneChilliHot5": "Chilli Hot 5",
  "ChilliRespin": "Chilli Respin",
  "RedstoneChristmasDelight": "Christmas Delight",
  "UnicornChristmasPresents": "Christmas Presents",
  "ClassicLuckySpin": "Classic Lucky Spin",
  "CloverBlast5": "Clover Blast 5",
  "CloverCoin": "Clover Coin",
  "RedstoneCloverDeluxe2X": "Clover Deluxe 2X",
  "RedstoneCloverDrop": "Clover Drop",
  "Redstone40CloverField": "Clover Field 40",
  "RedstoneCloverRoyale": "Clover Royale",
  "RedstoneCloverRush5": "Clover Rush 5",
  "PlayNetCloverSpread40": "Clover Spread 40",
  "CloversAndStars": "Clovers & Stars",
  "CloversAndDiamonds5": "Clovers and Didamonds",
  "CoinSplash": "Coin Splash",
  "CoinSplashDice": "Coin Splash Dice",
  "CoinSplashExtreme": "Coin Splash Extreme",
  "UnicornCollectCall": "Collect Call",
  "cosmic-comet-chase": "Cosmic Comet Chase",
  "RedstoneCosmicSevens": "Cosmic Sevens",
  "UnicornCoyoteDice": "Coyote Dice",
  "UnicornCoyoteGems": "Coyote Gems",
  "UnicornCoyoteSevens": "Coyote Sevens",
  "RedstoneCrownDrop": "Crown Drop",
  "PlayNetCrownSpread40": "Crown Spread 40",
  "PlayNetCrownStacks40": "Crown Stacks 40",
  "CrownOfSecret": "Crown of Secret",
  "CrownsAndStars": "Crowns and Stars",
  "CrystalHot100": "Crystal Hot 100",
  "CrystalHot40": "Crystal Hot 40",
  "CrystalHot40Christmas": "Crystal Hot 40 Christmas",
  "CrystalHot40Deluxe": "Crystal Hot 40 Deluxe",
  "CrystalHot40Free": "Crystal Hot 40 Free Spins",
  "CrystalHot40Halloween": "Crystal Hot 40 Halloween",
  "CrystalHot40Max": "Crystal Hot 40 MAX",
  "CrystalHot80": "Crystal Hot 80",
  "CrystalJewels": "Crystal Jewels",
  "CrystalJokerHot": "Crystal Joker Hot",
  "CrystalsOfMagic": "Crystals of Magic",
  "CubesAndStars": "Cubes and Stars",
  "RedstoneCupidsWildHearts": "Cupid's Wild Hearts",
  "UnicornDaVincisDice": "Da Vinci Dice",
  "UnicornDaVincisFruits": "Da Vinci's Fruits",
  "PlayNetDarkTemptress": "Dark Temptress",
  "PlayNetDashingHot20": "Dashing Hot 20",
  "PlayNetDashingHot5": "Dashing Hot 5",
  "DeadNight": "Dead Night",
  "DeepJungle": "Deep Jungle",
  "PlayNetDiamondHeart10": "Diamond Heart 10",
  "PlayNetDiamondHeart100": "Diamond Heart 100",
  "PlayNetDiamondHeart40": "Diamond Heart 40",
  "PlayNetDiamondHeart5": "Diamond Heart 5",
  "PlayNetDiamondHeartX2": "Diamond Heart x2",
  "RedstoneDiceDouble": "Dice Double",
  "RedstoneDiceDrop10": "Dice Drop 10",
  "UnicornDiceMachine": "Dice Machine",
  "UnicornDiceMegaCash": "Dice Mega Cash",
  "UnicornDiceWildLines": "Dice Wild Lines",
  "DiceOfSpells": "Dice of Spells",
  "RedstoneDivineStrike": "Divine Strike",
  "DolphinsShine": "Dolphin's Shine",
  "RedstoneDoubleFireClover": "Double Clover Fire",
  "RedstoneDoubleCloverFireChristmas": "Double Clover Fire Christmas",
  "RedstoneDoubleCrown5": "Double Crown 5",
  "RedstoneDoubleWildCrown": "Double Wild Crown",
  "UnicornDoubleWildDice": "Double Wild Dice",
  "UnicornDynamiteBoom": "Dynamite Boom",
  "UnicornDynamiteEscape": "Dynamite Escape",
  "UnicornDynamiteRun": "Dynamite Run",
  "UnicornDynamiteRunDice": "Dynamite Run Dice",
  "UnicornDynamiteRunPlatinum": "Dynamite Run Platinum",
  "EggspandingRush": "Eggspanding Rush",
  "ElGrandeToro": "El Grande Toro",
  "PlayNetEmpressOfFlame": "Empress of Flame",
  "UnicornEnchantedGems": "Enchanted Gems",
  "EpicClover100": "Epic Clover 100",
  "EpicClover100Booster": "Epic Clover 100 Booster",
  "EpicClover40": "Epic Clover 40",
  "EpicClover40Booster": "Epic Clover 40 Booster",
  "EpicCrown10": "Epic Crown 10",
  "EpicCrown10Booster": "Epic Crown 10 Booster",
  "GoldenCrown40Booster": "Epic Crown 40 Booster",
  "EpicCrown5": "Epic Crown 5",
  "EpicCrown5Booster": "Epic Crown 5 Booster",
  "EpicDice100": "Epic Dice 100",
  "EpicFire40": "Epic Fire 40",
  "UnicornEpicMegaCash": "Epic Mega Cash",
  "RedstoneEternalHearts10": "Eternal Hearts 10",
  "EyeOfTut": "Eye of Tut",
  "RedstoneFarmFiesta": "Farm Fiesta",
  "FashionNight": "Fashion Night",
  "UnicornFastFruits": "Fast Fruits",
  "UnicornFastPay": "Fast Pay",
  "RedstoneFearOfDark": "Fear Of Dark",
  "UnicornFireStars": "Fire Stars",
  "FootballVictory": "Football Victory",
  "ForestFruits": "Forest Fruits",
  "PlayNetFortuneClover10": "Fortune Clover 10",
  "PlayNetFortuneClover100": "Fortune Clover 100",
  "PlayNetFortuneClover20": "Fortune Clover 20",
  "PlayNetFortuneClover40": "Fortune Clover 40",
  "FortuneClover5": "Fortune Clover 5",
  "PlayNetFortuneCloverX2": "Fortune Clover X2",
  "FortuneParrot": "Fortune Parrot",
  "UnicornFrootClassic": "Froot Classic",
  "UnicornFrootMachine": "Froot Machine",
  "RedstoneFruitFire": "Fruit Fire",
  "UnicornFruitIsland": "Fruit Island",
  "UnicornFruitIslandChristmas": "Fruit Island Christmas",
  "UnicornFruitIslandDice": "Fruit Island Dice",
  "UnicornFruitIslandGems": "Fruit Island Gems",
  "UnicornFruitIslandJackpot": "Fruit Island Jackpot",
  "PlayNetFruitJackPotx10000": "Fruit Jackpot x10.000",
  "FruitLock7": "Fruit Lock 7",
  "UnicornFruitMagic": "Fruit Magic",
  "UnicornFruitPlay": "Fruit Play",
  "UnicornFruitWildLines": "Fruit Wild Lines",
  "FruitsAndStars": "Fruits and Stars",
  "FruitsAndStars20Deluxe": "Fruits and Stars 20 Deluxe",
  "FruitsAndStars40": "Fruits and Stars 40",
  "FruitsAndStars40Christmas": "Fruits and Stars 40 Christmas",
  "FruitsAndStarsChristmas": "Fruits and Stars Christmas",
  "FruityFace": "Fruity Face",
  "FruityForce40": "Fruity Force 40",
  "FruityHot": "Fruity Hot",
  "FruityHot5": "Fruity Hot 5",
  "FruityJokerHot": "Fruity Joker Hot",
  "FruityWin20": "Fruity Win 20",
  "FruityWin40": "Fruity Win 40",
  "RedstoneFunkyFruits": "Funky Fruits",
  "GigaHot40": "Giga Hot 40",
  "GigaHot40FreeSpins": "Giga Hot 40 Free Spins",
  "UnicornGoldLine": "Gold Line",
  "UnicornGoldLineDice": "Gold Line Dice",
  "GoldenCrown": "Golden Crown",
  "GoldenCrown40": "Golden Crown 40",
  "GoldenCrownBooster": "Golden Crown Booster",
  "GoldenCrownChristmas": "Golden Crown Christmas",
  "GoldenCrownChristmasBooster": "Golden Crown Christmas Booster",
  "GoldenCrownExtreme": "Golden Crown Extreme",
  "GoldenCrownHalloween": "Golden Crown Halloween",
  "GoldenCrownHoldAndWin": "Golden Crown Hold and Win",
  "GoldenCrownMax": "Golden Crown Max",
  "GoldenCrownMaxBooster": "Golden Crown Max Booster",
  "GoldenDiamonds20Extreme": "Golden Diamonds 20 Extreme",
  "GoldenDiamonds5Extreme": "Golden Diamonds 5 Extreme",
  "GoldenExplosion": "Golden Explosion",
  "UnicornGoldenGateFruit": "Golden Gate Fruit",
  "PlayNetGoldenGetsby": "Golden Getsby",
  "UnicornGreatWhale": "Great Whale",
  "HeatClassic5": "HEAT Classic 5",
  "RedstoneHotRushFruitLines": "HOT RUSH Fruit Lines",
  "RedstoneHotRushCrownBurst": "HOT RUSH: Crown Burst",
  "UnicornHavanaDice": "Havana Dice",
  "RedstoneHeartRoyale": "Heart Royale",
  "HeartsAndStars": "Hearts & Stars",
  "HeatDouble": "Heat Double",
  "HeatingDice": "Heating Dice",
  "HeatingFruits": "Heating Fruits",
  "HeatingIce": "Heating Ice",
  "HeatingIceDeluxe": "Heating Ice Deluxe",
  "UnicornHitLine": "Hit Line",
  "UnicornHitLineDice": "Hit Line Dice",
  "HotClock": "Hot Clock",
  "UnicornHotFireballs": "Hot Fireballs",
  "HotHotStereoWin": "Hot Hot Stereo Win",
  "RedstoneHotRushBothWays": "Hot Rush - Both Ways",
  "RedstoneHotRushStarsDeluxe": "Hot Rush Stars Deluxe",
  "RedstoneHotRushTripleStar": "Hot Rush Triple Star",
  "HotStars": "Hot Stars",
  "HotStarsChristmas": "Hot Stars Christmas",
  "RedstoneInfernoHot40": "Inferno Hot 40",
  "UnicornIslandRespins": "Island Respins",
  "Redstone40JokersFreeGames": "JACKPOT CHANCE - 40 Jokers Free Games",
  "Redstone20WildCrown": "Jackpot Chance - 20 Wild Crown",
  "RedstoneMoonDog": "Jackpot Chance - Moon Dog",
  "JazzyFruits": "Jazzy Fruits",
  "JewelsBeat": "Jewels Beat",
  "JokerTripleDouble": "Joker Triple Double",
  "JollyPoker": "Jolly Poker",
  "RedstoneJollyPresents": "Jolly Presents",
  "RedstoneJuicyHeat20": "Juicy Heat 20",
  "JuicyHot": "Juicy Hot",
  "KatanasOfTime": "Katanas of Time",
  "KettysFashionWorld": "Ketty's Fashion World",
  "KingOfThunder": "King of Thunder",
  "RedstoneLadyTripleFortune": "Lady Triple Fortune",
  "UnicornLavaDiamonds": "Lava Diamonds",
  "UnicornLavaDiamondsChristmas": "Lava Diamonds Christmas",
  "UnicornLavaDice": "Lava Dice",
  "UnicornLavaGems": "Lava Gems",
  "PlayNetLeprechaunsFortuneClover": "Leprechaun's Fortune Clover",
  "LockedHearts10": "Locked Hearts 10",
  "LockedHearts20": "Locked Hearts 20",
  "LockedHearts5": "Locked Hearts 5",
  "LollasWorld": "Lolla's World",
  "LollasWorldChristmas": "Lolla's World Christmas",
  "LostBook": "Lost Book",
  "LuckyBrilliants": "Lucky Brilliants",
  "UnicornLuckyGinger": "Lucky Ginger",
  "LuckySheriff": "Lucky Sheriff",
  "LuckyTwister": "Lucky Twister",
  "LuxRoulette": "Lux Roulette",
  "MacacoDaFortuna": "Macaco Da Fortuna",
  "MajesticCrown10": "Majestic Crown 10",
  "PlayNetMajesticCrown100": "Majestic Crown 100",
  "PlayNetMajesticCrown20": "Majestic Crown 20",
  "PlayNetMajesticCrown20Xmas": "Majestic Crown 20 Xmas",
  "PlayNetMajesticCrown40": "Majestic Crown 40",
  "PlayNetMajesticCrown5": "Majestic Crown 5",
  "PlayNetMajesticCrownEaster": "Majestic Crown Easter",
  "PlayNetMajesticCrownX2": "Majestic Crown x2",
  "MayanCoins": "Mayan coins Lock & Cash",
  "MayansBattle": "Mayan's Battle",
  "MegaCubesDeluxe": "Mega Cubes Deluxe",
  "MegaHot": "Mega Hot",
  "MegaHot10": "Mega Hot 10",
  "MegaHot20": "Mega Hot 20",
  "UnicornMiniMegaCash": "Mini Mega Cash",
  "UnicornMisterDice": "Mister Dice",
  "UnicornMisterLuck": "Mister Luck",
  "Money5": "Money 5",
  "Money5Booster": "Money 5 Booster",
  "UnicornMoneyStandard": "Money Standard",
  "UnicornMoneyStandardDice": "Money Standard Dice",
  "UnicornMoneyStandardWild": "Money Standard Wild",
  "Monsters": "Monsters",
  "MrFirstCryptonium": "Mr First Cryptonium",
  "RedstoneMultiClover10": "Multi Clover 10",
  "RedstoneMultiCrown10": "Multi Crown 10",
  "RedstoneMultiHeart5": "Multi Heart 5",
  "MysteryJokerHot": "Mystery Joker Hot",
  "MysticJungle": "Mystic Jungle",
  "neon-fruits": "Neon Fruits",
  "PlayNetNeptunesJewels": "Neptune's Jewels",
  "RedstoneOnlyAnime": "Only Anime",
  "PariHot40": "Pari Hot 40",
  "Pirates": "Pirates",
  "PixelHot40": "Pixel Hot 40",
  "planet-dice-escape": "Planet Dice Escape",
  "Postman": "Postman",
  "PowerOfTheGreat": "Power of the Great",
  "UnicornPumpkinHorror": "Pumpkin Horror",
  "Pyramid": "Pyramid",
  "UnicornRainbowSevens": "Rainbow Sevens",
  "UnicornReelDice": "Reel Dice",
  "RedstoneReelX527Ways": "Reel X5: 27 Ways",
  "RedstoneReelX5": "Reel x5",
  "UnicornReelyWildReels": "Reely Wild Reels",
  "Retro27": "Retro 27",
  "Retro7Hot": "Retro 7 Hot",
  "Retro7HotChristmas": "Retro 7 Hot Christmas",
  "RetroFire": "Retro Fire",
  "rocket-roll": "Rock@Roll",
  "RedstoneRollingHearts10": "Rolling Hearts 10",
  "Roulette": "Roulette",
  "royal-crown-delight": "Royal Crown Delight",
  "PlayNetRoyalFlame": "Royal Flame",
  "PlayNetRoyalFlame40": "Royal Flame 40",
  "royal-jewels-fortune": "Royal Jewels Fortune",
  "SantasPresents": "Santa's Presents",
  "UnicornSavanaFruits": "Savana Fruits",
  "UnicornScatterKaChing": "Scatter Kaching",
  "SevenClassicHot": "Seven Classic Slot",
  "ShiningRush": "Shining Rush",
  "UnicornSimplySevens": "Simply Sevens",
  "UnicornSimplySevensDice": "Simply Sevens Dice",
  "UnicornSimplySevensDiceEaster": "Simply Sevens Dice Easter",
  "UnicornSimplySevensGems": "Simply Sevens Gems",
  "RedstoneSlotRoyale": "Slot Royale",
  "SpaceGuardians": "Space Guardians",
  "SpecialFruits": "Special Fruits",
  "SpinCards": "Spin Cards",
  "RedstoneSpinUp": "Spin Up",
  "RedstoneSpookySpins": "Spooky Spins",
  "RedstoneStarChaser": "Star Chaser",
  "StarGems": "Star Gems",
  "StarHeat40": "Star Heat 40",
  "StarRunner": "Star Runner",
  "Starlight": "Starlight",
  "UnicornStickyHot": "Sticky Hot",
  "RedstoneStickyTiki": "Sticky Tiki",
  "sugar-luck": "Sugar Luck",
  "SummerRush": "Summer Rush",
  "UnicornSuperDiceRunner": "Super Dice Runner",
  "UnicornSuperFireDiceJackpot": "Super Fire Dice Jackpot",
  "UnicornSuperFireJackpot": "Super Fire Jackpot",
  "UnicornSuperHighRunner": "Super High Runner",
  "SuperLucky": "Super Lucky",
  "UnicornSupremeSevens": "Supreme Sevens",
  "UnicornSupremeSevensDice": "Supreme Sevens Dice",
  "RedstoneSweetRespins": "Sweet Respins",
  "TaxiRush": "Taxi Rush",
  "TemplarsQuest": "Templars Quest",
  "UnicornTheCrownFruit": "The Crown Fruit",
  "UnicornTheKingsHalloween": "The Kings Halloween",
  "UnicornThreeReelDice": "Three Reel Dice",
  "UnicornThreeReelTripleFruit": "Three Reel Triple Fruit",
  "UnicornThunderFruits": "Thunder Fruits",
  "TopHot5": "Top Hot 5",
  "ToxicHaze": "Toxic Haze",
  "TripleDice": "Triple Dice",
  "TripleFieldsOfLuck": "Triple Fields of Luck",
  "TripleHot": "Triple Hot",
  "UnicornTripleRoyalWilds": "Triple Royal Wilds",
  "UnicornTripleStackedDiamondJackpot": "Triple Stacked Diamond Jackpot",
  "UnicornTripleStackedDiamonds": "Triple Stacked Diamonds",
  "PlayNetTropicTwist": "Tropic Twist",
  "TropicalHot": "Tropical Hot",
  "UnicornTropicalTreasure": "Tropical Treasure",
  "TurboDice40": "Turbo Dice 40",
  "TurboFire": "Turbo Fire",
  "TurboHot100": "Turbo Hot 100",
  "TurboHot40": "Turbo Hot 40",
  "TurboHot40Christmas": "Turbo Hot 40 Christmas",
  "TurboHot80": "Turbo Hot 80",
  "TurboStars10": "Turbo Stars 10",
  "TurboStars20": "Turbo Stars 20",
  "TurboStars40": "Turbo Stars 40",
  "UnicornTwentyDice": "Twenty Dice",
  "UnicornTwentyFruits": "Twenty Fruits",
  "TwinklingHot40": "Twinkling Hot 40",
  "TwinklingHot40Christmas": "Twinkling Hot 40 Christmas",
  "TwinklingHot5": "Twinkling Hot 5",
  "TwinklingHot80": "Twinkling Hot 80",
  "VipRoulette": "VIP Roulette",
  "UnicornVegasDice": "Vegas Dice",
  "VeryHot20": "Very Hot 20",
  "VeryHot40": "Very Hot 40",
  "VeryHot40Booster": "Very Hot 40 Booster",
  "VeryHot40Christmas": "Very Hot 40 Christmas",
  "VeryHot40Dice": "Very Hot 40 Dice",
  "VeryHot40Extreme": "Very Hot 40 Extreme",
  "VeryHot40Respin": "Very Hot 40 Respin",
  "VeryHot5": "Very Hot 5",
  "VeryHot5Booster": "Very Hot 5 Booster",
  "VeryHot5Christmas": "Very Hot 5 Christmas",
  "VeryHot5ChristmasBooster": "Very Hot 5 Christmas Booster",
  "VeryHot5Extreme": "Very Hot 5 Extreme",
  "VeryHot5ExtremeBooster": "Very Hot 5 Extreme Booster",
  "VikingGold": "Viking Gold",
  "VintageFruits40": "Vintage Fruits 40",
  "RedstoneVolcanoCrown": "Volcano Crown",
  "RedstoneVolcanoHot": "Volcano Hot",
  "NovaPixelWheelOfJoker": "Wheel of Joker",
  "Wild27": "Wild 27",
  "Wild27Extreme": "Wild 27 Extreme",
  "Wild27Halloween": "Wild 27 Halloween",
  "Wild5": "Wild 5",
  "Wild81": "Wild 81",
  "WildCraps": "Wild Craps",
  "PlayNetWildForties": "Wild Forties",
  "PlayNetWildFortiesXmas": "Wild Forties Xmas",
  "RedstoneWildHeartBeat": "Wild HEART Beat",
  "WildHeat40": "Wild Heat 40",
  "UnicornWildHoppers": "Wild Hoppers",
  "WildHot40": "Wild Hot 40",
  "WildHot40Blow": "Wild Hot 40 Blow",
  "WildHot40BlowBooster": "Wild Hot 40 Blow Booster",
  "WildHot40BlowDice": "Wild Hot 40 Blow Dice",
  "WildHot40Christmas": "Wild Hot 40 Christmas",
  "WildHot40Dice": "Wild Hot 40 Dice",
  "WildHot40FreeSpins": "Wild Hot 40 Free Spins",
  "WildHot40Halloween": "Wild Hot 40 Halloween",
  "WildHot40HoldAndWin": "Wild Hot 40 Hold & Win",
  "WildJokerHot": "Wild Joker Hot",
  "WildKingdom": "Wild Kingdom",
  "WildLuckyClover": "Wild Lucky Clover",
  "WildLuckyClover2": "Wild Lucky Clover 2",
  "UnicornWildParadise": "Wild ParaDice",
  "PlayNetWildSpread40": "Wild Spread 40",
  "WildSunburst": "Wild Sunburst",
  "WildSunflower": "Wild Sunflower",
  "RedstoneWildTrail": "Wild Trail",
  "WildWest": "Wild West",
  "WinningClover5": "Winning Clover 5",
  "WinningClover5Extreme": "Winning Clover 5 Extreme",
  "WinningStars": "Winning Stars",
  "WinningClover5HoldAndWin": "Winning clover 5 Hold & WIn",
  "UnicornWinterFruits": "Winter Fruits",
  "Wizard": "Wizard",
  "RedstoneXCloverFire": "X Clover Fire",
  "10001nights00000": "10,001 Nights",
  "10001nightsmegaw": "10,001 Nights MegaWays",
  "1942skywarrior00": "1942 Sky Warrior",
  "24hourgrandprix0": "24 Hour Grand Prix",
  "4squad0000000000": "4Squad",
  "5families0000000": "5 Families",
  "777diamondstrike": "777 Diamond Strike",
  "777strike0000000": "777 Strike",
  "777superstrike00": "777 Super Strike",
  "7sluck0000000000": "7’s Luck",
  "80sspins00000000": "80s Spins",
  "ageofakkadia0000": "Age Of Akkadia",
  "agentroyale00000": "Agent Royale",
  "alexanderthegrea": "Alexander The Great",
  "alibabasluck0000": "Ali Baba's Luck",
  "alibabasluckmega": "Ali Baba's Luck Megaways",
  "alibabasluckpowe": "Ali Baba's Luck Power Reels",
  "amazonislandmega": "Amazon Island Megaways",
  "ancientdisco0000": "Ancient Disco",
  "ancientscript000": "Ancient Script",
  "ancientsblessing": "Ancients Blessing",
  "apacheway0000000": "Apache Way",
  "arcadebomb000000": "Arcade Bomb",
  "archdragonking00": "Archdragon King",
  "asianfortune0000": "Asian Fortune",
  "astronaut0000000": "Astronaut",
  "astros0000000000": "Astros",
  "athensmegaways00": "Athens MegaWays",
  "atlantis00000000": "Atlantis",
  "aurumcodex000000": "Aurum Codex",
  "aztecspins000000": "Aztec Spins",
  "bassboss00000000": "Bass Boss",
  "bassbossmegaways": "Bass Boss Megaways™",
  "beriched00000000": "Beriched",
  "bettyborisandboo": "Betty, Boris and Boo",
  "bigcatrescuemega": "Big Cat Rescue Megaways",
  "biggains00000000": "Big Gains",
  "bigrichturkeys00": "Big Rich Turkeys",
  "biggestvault0000": "Biggest Vault",
  "blazingclusters0": "Blazing Clusters",
  "blobsterscluster": "Blobsters Clusterbuster",
  "bloodsuckersmega": "Blood Suckers Megaways",
  "bloodymurder0000": "Bloody Murder",
  "bluediamond00000": "Blue Diamond",
  "bombuster0000000": "Bombuster",
  "bountyraid000000": "Bounty Raid",
  "bountyraid200000": "Bounty Raid 2",
  "buffalocollector": "Buffalo Collector",
  "buffalomaniamega": "Buffalo Mania Megaways",
  "bugsysbar0000000": "Bugsy's Bar",
  "bullsrunwild0000": "Bulls Run Wild",
  "caishen168000000": "Cai Shen 168",
  "cakeandicecream0": "Cake and Ice Cream",
  "cannonballcash00": "Cannonball Cash",
  "caseclosed000000": "Case Closed",
  "cashexplorer0000": "Cash Explorer",
  "cashgoddess00000": "Cash Goddess",
  "cashornothing000": "Cash Or Nothing",
  "cashultimate0000": "Cash Ultimate",
  "cashvolt00000000": "Cash Volt",
  "cashvoltsupercha": "Cash Volt Supercharged",
  "casinospin000000": "Casino Spin",
  "chinesetreasures": "Chinese Treasures",
  "chinesewilds0000": "Chinese Wilds",
  "christmasmorning": "Christmas Morning",
  "christmasmultiho": "Christmas Multihops",
  "cinderella000000": "Cinderella's Ball",
  "cirquedelafortun": "Cirque de la Fortune",
  "clashofthebeasts": "Clash of the Beasts",
  "classicblackjack": "Classic Blackjack",
  "clovercraze00000": "Clover Craze",
  "cobraqueen000000": "Cobra Queen",
  "cottongangaffair": "Cotton Gang Affair",
  "crazygenie000000": "Crazy Genie",
  "crystalmirror000": "Crystal Mirror",
  "cyberattack00000": "Cyber Attack",
  "davincismystery0": "Da Vinci's Mystery",
  "dearsanta0000000": "Dear Santa",
  "desertlegendsspi": "Desert Legends Spin",
  "devilsnumber0000": "Devil's Number",
  "diamondblitz0000": "Diamond Blitz",
  "diamondblitz2000": "Diamond Blitz 2",
  "diamonddoggies00": "Diamond Doggies",
  "diamondroyale000": "Diamond Royale",
  "diamondsup000000": "Diamonds Up",
  "dicedicedice0000": "Dice Dice Dice",
  "diggingforwilds0": "Digging for Wilds",
  "divineways000000": "Divine Ways",
  "doggyrichesmegaw": "Doggy Riches Megaways",
  "drfrancashstein0": "Dr.Francashstein",
  "draculaawakening": "Dracula Awakening",
  "dragonboyz000000": "Dragon Boyz",
  "dragonkinglegend": "Dragon King: Legend Of The Seas",
  "dragonpearl00000": "Dragon Pearl",
  "dragonsfire00000": "Dragon's Fire",
  "dragonsfireinfin": "Dragon's Fire Infinireels",
  "dragonsfiremegaw": "Dragon's Fire Megaways",
  "dragonsluck00000": "Dragon's Luck",
  "dragonslckdeluxe": "Dragon's Luck Deluxe",
  "dragonsluckmegaw": "Dragon's Luck Megaways",
  "dragonslckstacks": "Dragon's Luck Power Reels",
  "dragonsmirror000": "Dragon's Mirror",
  "dragonsclusterbu": "DragonsClusterbuster",
  "dragonslock00000": "Dragons’ Lock",
  "dreamdestiny0000": "Dream Destiny",
  "dynamiteriches00": "Dynamite Riches",
  "dynamiterichesme": "Dynamite Riches Megaways",
  "eagleriches00000": "Eagle Riches",
  "egyptclusterbust": "Egypt Clusterbuster",
  "egyptmegaways000": "Egypt Megaways",
  "elephanttreasure": "Elephant Treasure",
  "elvenmagic000000": "Elven Magic",
  "emeralddiamond00": "Emerald Diamond",
  "emperorofindia00": "Emperor of India",
  "epicjourney00000": "Epic Journey",
  "epictreasure0000": "Epic Treasure",
  "epictreasure2000": "Epic Treasure 2",
  "esqueletomariach": "Esqueleto Mariachi",
  "europeanroulette": "European Roulette",
  "fafababies000000": "Fa Fa Babies",
  "fafababies200000": "Fa Fa Babies 2",
  "farmtastic000000": "Farmtastic™",
  "fishtastic000000": "Fishtastic",
  "fivestar00000000": "Five Star",
  "fivestarpowerree": "Five Star Power Reels",
  "flamingfox000000": "Flaming Fox",
  "flodder000000000": "Flodder",
  "forever7s0000000": "Forever 7s",
  "fortunecharm0000": "Fortune Charm",
  "fortunefest00000": "Fortune Fest",
  "fortunehouse0000": "Fortune House",
  "fortunehousepowe": "Fortune House Power Reels",
  "fruitblox0000000": "Fruit Blox",
  "fruitflash000000": "Fruit Flash",
  "fruitsnap0000000": "Fruit Snap",
  "gemsgonewild0000": "Gems Gone Wild",
  "gemsgonewildpowe": "Gems Gone Wild Power Reels",
  "gemsinfernomegaw": "Gems Inferno Megaways™",
  "gemtastic0000000": "Gemtastic",
  "genienights00000": "Genie Nights",
  "getthegoldinfini": "Get The Gold InfiniReels",
  "gigablast0000000": "Giga Blast",
  "gladiatorways000": "Gladiator Ways",
  "glowdig000000000": "Glow Dig",
  "godofwealth00000": "God Of Wealth",
  "godsoftroy000000": "Gods of Troy",
  "godsoftroymegawa": "Gods of Troy Megaways™",
  "goldminemistress": "Gold Mine Mistress",
  "goldstar00000000": "Gold Star",
  "goldencryptex000": "Golden Cryptex",
  "goldenlamps00000": "Golden Lamps",
  "goldenleprechaun": "Golden Leprechaun Megaways",
  "goldenlotus00000": "Golden Lotus",
  "goldenoffer00000": "Golden Offer",
  "templeofgold0000": "Golden Temple",
  "goldentoad000000": "Golden Toad",
  "goldentsar000000": "Golden Tsar",
  "gonzitasquest000": "Gonzita's Quest",
  "gonzosqumegaways": "Gonzo's Quest Megaways",
  "goodluckclusterb": "Good Luck Clusterbuster",
  "grandwheel000000": "Grand Wheel",
  "greatgold0000000": "Great Gold",
  "hammergods000000": "Hammer Gods",
  "hanselandgretelc": "Hansel & Gretel Candyhouse",
  "happyapples00000": "Happy Apples",
  "harlecoin0000000": "Harle Coin",
  "herekittykitty00": "Here Kitty Kitty",
  "hoardofposeidon0": "Hoard of Poseidon",
  "hothotchillipot0": "Hot Hot Chilli Pot",
  "hustling00000000": "Hustling",
  "imperialpalace00": "Imperial Palace",
  "intherabbithole0": "In the Rabbit Hole",
  "jackinapot000000": "Jack in a Pot",
  "jackpotquest0000": "Jackpot Quest",
  "jackrabbitjackpo": "Jackrabbit Jackpots",
  "jadecharms000000": "Jade Charms",
  "jellymultihops00": "Jelly MULTIHOPS",
  "jesterspins00000": "Jester Spins",
  "jewelscarabs0000": "Jewel Scarabs",
  "jinglebells00000": "Jingle Bells",
  "jinglebellsbona2": "Jingle Bells Bonanza 2",
  "jinglebellspower": "Jingle Bells Power Reels",
  "jinglewaysmegawa": "Jingle Ways Megaways",
  "joeexotic0000000": "Joe Exotic",
  "knightsofavalon0": "Knights of Avalon",
  "landofriches0000": "Land of Riches",
  "laserfruit000000": "Laser Fruit",
  "lastchancesaloon": "Last Chance Saloon",
  "legendofathena00": "Legend of Athena",
  "legendaryexcalib": "Legendary Excalibur",
  "leprechaunsmagic": "Leprechaun's Magic",
  "leprechaunsmagmw": "Leprechauns Magic Megaways",
  "leprechaunsmagpr": "Leprechauns Magic Power Reels",
  "liondance0000000": "Lion Dance",
  "lionshoard000000": "Lion's Hoard",
  "lockandpopr96f10": "Lock and Pop",
  "londontube000000": "London Tube",
  "losmuertoslocos0": "Los Muertos Locos",
  "luckycarnival000": "Lucky Carnival",
  "luckyeaster00000": "Lucky Easter",
  "luckyfortunecat0": "Lucky Fortune Cat",
  "luckyfridays0000": "Lucky Fridays",
  "luckyhalloween00": "Lucky Halloween",
  "luckydevil000000": "Lucky Little Devil",
  "luckyoktoberfest": "Lucky Oktoberfest",
  "luckyvalentine00": "Lucky Valentine",
  "luckywizard00000": "Lucky Wizard",
  "macauracing00000": "Macau Racing",
  "magicgate0000000": "Magic Gate",
  "magicpowersmegaw": "Magic Powers Megaways",
  "magictricks00000": "Magic Tricks",
  "majesticmysterie": "Majestic Mysteries Power Reels",
  "masquerade000000": "Masquerade",
  "mayangods0000000": "Mayan Gods",
  "mayhem0000000000": "Mayhem",
  "megadragon000000": "Mega Dragon",
  "megajade00000000": "Mega Jade",
  "megapyramid00000": "Mega Pyramid",
  "megarise00000000": "Mega Rise",
  "midasgold0000000": "Midas Gold",
  "midnightromance0": "Midnight Romance",
  "midnightthirst00": "Midnight Thirst",
  "monopolycashiski": "Monopoly Cash is King",
  "monopolymoneymag": "Monopoly Money Magnate",
  "monopolyrentrush": "Monopoly Rent Rush",
  "monstersunchaine": "Monsters Unchained",
  "moonspell0000000": "Moon Spell",
  "multiplierriches": "Multiplier Riches",
  "mysteryfruit0000": "Mystery Reels",
  "mysteryreelsdelu": "Mystery Reels Deluxe",
  "mysteryreelsmega": "Mystery Reels Megaways",
  "mysteryreelspowe": "Mystery Reels Power Reels",
  "mysticstaxx00000": "Mystic Staxx",
  "mysticwheel00000": "Mystic Wheel",
  "nftmegaways00000": "NFT Megaways",
  "narcosmexico0000": "Narcos Mexico",
  "neonlinks0000000": "Neon Links",
  "nightroller00000": "Night roller",
  "nightmarefamilym": "Nightmares Family Megaways",
  "ninjaways0000000": "Ninja Ways",
  "oceanfortune0000": "Ocean Fortune",
  "pathofdestiny000": "Path of Destiny",
  "peggysweets00000": "Peggy Sweets",
  "persianfortune00": "Persian Fortune",
  "redphoenixrising": "Phoenix",
  "phoenixfwerreels": "Phoenix Fire Power Reels",
  "piggypirates0000": "Piggy Pirates",
  "piggyriches2mega": "Piggy Riches 2 Megaways",
  "piggyrichesbegin": "Piggy Riches Begins",
  "piggyrichesmegaw": "Piggy Riches Megaways",
  "pinatasandponies": "Pinatas & Ponies",
  "piratesplentytre": "Pirates Plenty: Treasures of the Seas",
  "piratesplenty000": "Pirates' Plenty",
  "piratespeforgold": "Pirates' Plenty Battle for Gold",
  "piratesplentymeg": "Pirates' Plenty MegaWays",
  "platinumsidebets": "Platinum Blackjack SideBets",
  "playwiththedevmw": "Play With the Devil Megaways",
  "playwiththedevil": "Play with the Devil",
  "primateking00000": "Primate King",
  "primatekingmegaw": "Primate King Megaways™",
  "puntobanco000000": "Punto Banco",
  "purrpower0000000": "Purr Power",
  "pussnboots000000": "Puss 'N Boots",
  "raslegend0000000": "RA's Legend",
  "rainbowjackpotsm": "Rainbow Jackpot Megaways",
  "rainbowjackpots0": "Rainbow Jackpots",
  "rainbowjackpotsp": "Rainbow Jackpots Power Lines",
  "reactor000000000": "Reactor",
  "reddiamond000000": "Red Diamond",
  "redhotbbq0000000": "Red Hot BBQ",
  "redhotslot000000": "Red Hot Slot",
  "redlinerush00000": "Redline Rush",
  "reelheist0000000": "Reel Heist",
  "reelkeeper000000": "Reel Keeper",
  "reelkeeperpowerr": "Reel Keeper Power Reels",
  "reelkingmega0000": "Reel King Mega",
  "regalbeasts00000": "Regal Beasts",
  "regalstreak00000": "Regal Streak",
  "reptizillionspow": "Reptizillions Power Reels",
  "revolvero0000000": "Revolvero",
  "riddleofthesphin": "Riddle Of The Sphinx",
  "riostars00000000": "Rio Stars",
  "riseofcleopatra0": "Rise of Cleopatra",
  "risquemegaways00": "Risque Megaways",
  "robinhoodswildfo": "Robin Hoods Wild Forest",
  "rocknlock0000000": "Rock'n'Lock",
  "rocketmen0000000": "Rocket Men",
  "romanemperors000": "Roman Emperors",
  "royalgems0000000": "Royal Gems",
  "sakuramasks00000": "Sakura Masks",
  "santaspins000000": "Santa Spins",
  "savannahpride000": "Savannah Pride",
  "seaboatadventure": "Sea Boat Adventure",
  "serpentking00000": "Serpent King",
  "shadowsociety000": "Shadow Society",
  "shahmat000000000": "Shah Mat",
  "sharkboss0000000": "Shark Boss",
  "sheepgonewild000": "Sheep Gone Wild",
  "sirensriches0000": "Sirens’ Riches",
  "snowwildandthe7f": "Snow Wild And The 7 Features",
  "spintown00000000": "Spin Town",
  "spookycarnival00": "Spooky Carnival",
  "stage88800000000": "Stage 888",
  "steamsquad000000": "Steam Squad",
  "stolentreasures0": "Stolen Treasures",
  "sugarliciousever": "Sugarlicious EveryWay",
  "sumospins0000000": "Sumo Spins",
  "swordstomp000000": "Sword Stomp",
  "sylvanspirits000": "Sylvan Spirits",
  "takethemoney0000": "Take the Money",
  "tenelements00000": "Ten Elements",
  "theequalizer0000": "The Equalizer",
  "thegoodthebadand": "The Good, The Bad and The Rich",
  "thegreatesttrain": "The Greatest Train Robbery",
  "thewildhatter000": "The Wild Hatter",
  "thewildkiss00000": "The Wild Kiss",
  "thewisecrackerli": "The Wisecracker Lightning",
  "thorslightning00": "Thor's Lightning",
  "thorsrage0000000": "Thor's Rage",
  "thorsvengeance00": "Thor's Vengeance",
  "threekingdoms000": "Three Kingdoms",
  "threemusketeers0": "Three Musketeers",
  "tikifruits000000": "Tiki Fruits",
  "tikifruitstotemf": "Tiki Fruits Totem Frenzy",
  "totemlightning00": "Totem Lightning",
  "totemlightningpo": "Totem Lightning Power Reels",
  "transylvanianigh": "Transylvania: Night of Blood",
  "treasuremine0000": "Treasure Mine",
  "treasureminepowe": "Treasure Mine Power Reels",
  "tricksandtreats0": "Tricks and Treats",
  "trillionaire0000": "Trillionaire",
  "trillionairemega": "Trillionaire Megaways™",
  "trophyfish000000": "Trophy Fish",
  "turtleparadise00": "Turtle Paradise",
  "ultrarich0000000": "Ultra Rich",
  "vaultcracker0000": "Vault Cracker",
  "vaultcrackermega": "Vault Cracker Megaways",
  "vaultofanubis000": "Vault of Anubis",
  "vickyventura0000": "Vicky Ventura",
  "vikingslegacyeve": "Viking's Legacy Everyway",
  "viralspiral00000": "Viral Spiral",
  "wantedwildz00000": "Wanted Wildz",
  "wantedwildzextre": "Wanted Wildz Extreme",
  "warofgods0000000": "War Of Gods",
  "wellofwishes0000": "Well Of Wishes",
  "wellofwildsmegaw": "Well of Wilds Megaways",
  "whatthefoxmegawa": "What the Fox MegaWays",
  "wildcatsmultilin": "Wild Cats Multiline",
  "wildcircus000000": "Wild Circus",
  "wildelements0000": "Wild Elements",
  "wildexpedition00": "Wild Expedition",
  "wildfight0000000": "Wild Fight",
  "wildhotchilliree": "Wild Hot Chilli Reels",
  "wildhotchillire2": "Wild Hot Chilli Reels 2",
  "wildnords0000000": "Wild Nords",
  "wildoclock000000": "Wild O'Clock",
  "wildspartans0000": "Wild Spartans",
  "wildtundra000000": "Wild Tundra",
  "wildwildchest000": "Wild Wild Chest",
  "winescalator0000": "Win Escalator",
  "wingsofra0000000": "Wings of Ra",
  "wingsoframegaway": "Wings of Ra Megaways™",
  "winterwonders000": "Winter Wonders",
  "wolfstacksmegawa": "Wolf Stacks Megaways",
  "wolfkin000000000": "Wolfkin",
  "wrigleysworld000": "Wrigley's World",
  "yearroundrichesc": "Year-Round Riches Clusterbuster",
  "yucatansmystery0": "Yucatan's Mystery",
  "zaidasfortune000": "Zaida's Fortune",
  "zeuslightningmeg": "Zeus Lightning Megaways",
  "zeuslightningpow": "Zeus Lightning Power Reels",
  "zillardking00000": "Zillard King",
  "zillardkingmegaw": "Zillard King Megaways",
  "DHPTable00000001": "2 Hand Casino Hold'em",
  "Always8baccarat0": "Always 8 Baccarat",
  "mkvhbciosnfqhat7": "Arabic Roulette",
  "k37tle5hfceqacik": "Auto Lightning Roulette",
  "48z5pjps3ntvqc1b": "Auto-Roulette",
  "01rb77cq1gtenhmo": "Auto-Roulette VIP",
  "BacBo00000000001": "Bac Bo",
  "PorBacBo00000001": "Bac Bo Ao Vivo",
  "oytmvb9m1zysmc44": "Baccarat A",
  "60i0lcfx5wkkv3sy": "Baccarat B",
  "ndgvs3tqhfuaadyg": "Baccarat C",
  "k2oswnib7jjaaznw": "Baccarat Control Squeeze",
  "category:baccarat_sicbo": "Baccarat Lobby",
  "zixzea8nrf1675oh": "Baccarat Squeeze",
  "BalloonRace00001": "Balloon Race",
  "clabetstack00001": "Bet Stacker Blackjack 1",
  "clabetstack00003": "Bet Stacker Blackjack 3",
  "clabetstack00004": "Bet Stacker Blackjack 4",
  "uwd2bl2khwcikjlz": "Blackjack A",
  "xphpcthv8e6ivc16": "Blackjack B",
  "jhs44mm0v3fi3aux": "Blackjack C",
  "mwplyh47theqikvo": "Blackjack Classic 20",
  "m4lp7ndztmdqqk3z": "Blackjack Classic 24",
  "m4lqa3pvtmdqqk5b": "Blackjack Classic 25",
  "m6wz34ftxyladk4d": "Blackjack Classic 29",
  "ndefnmxrofgqoayl": "Blackjack Classic 35",
  "nhrld2edzggqejgp": "Blackjack Classic 43",
  "njmogybuwxuad46n": "Blackjack Classic 44",
  "njmog24wwxuad46r": "Blackjack Classic 45",
  "njmoztxtwxuad5mg": "Blackjack Classic 46",
  "njmozz5iwxuad5mn": "Blackjack Classic 47",
  "njmoz6m3wxuad5mv": "Blackjack Classic 49",
  "nl7mhbyly4xar32v": "Blackjack Classic 51",
  "nl7mgk3hy4xar3ji": "Blackjack Classic 52",
  "nohedgkjiypk7zja": "Blackjack Classic 54",
  "nohej3hriypk75yk": "Blackjack Classic 56",
  "nohenl2miyplaad3": "Blackjack Classic 57",
  "nrgrpgppsbsdh2s6": "Blackjack Classic 58",
  "nrgrpjyysbsdh2vg": "Blackjack Classic 59",
  "nrgrpmxusbsdh2wt": "Blackjack Classic 60",
  "nu4r55nnmn6jgrco": "Blackjack Classic 62",
  "nu4sd7vqmn6jguk4": "Blackjack Classic 63",
  "nu4sfh6imn6jgvah": "Blackjack Classic 64",
  "ob34b36gdmtjx42e": "Blackjack Classic 70",
  "ob34b7mbdmtjx456": "Blackjack Classic 72",
  "phgckiysbreteord": "Blackjack Classic 74",
  "phgcobenbretetnj": "Blackjack Classic 77",
  "phgcqqn7p4et4frg": "Blackjack Classic 79",
  "mfvu6r2jvibqbxax": "Blackjack Classic 8",
  "phgcvlmwp4et4mfe": "Blackjack Classic 81",
  "q2jpoyqxsgfd6cz7": "Blackjack Classic 88",
  "rauqbm55tdcfnisg": "Blackjack Classic 89",
  "mfvvadncvibqbxbt": "Blackjack Classic 9",
  "rauqeqhmtdcfnrvv": "Blackjack Classic 90",
  "sewhjrwsfjlroeog": "Blackjack Classic 91",
  "seyv42ttu7msgrcq": "Blackjack Classic 92",
  "seywioztu7msjbxi": "Blackjack Classic 93",
  "seywr5stu7mslebq": "Blackjack Classic 94",
  "seywwrl3u7msmgcc": "Blackjack Classic 95",
  "seywzqsju7msm4mh": "Blackjack Classic 96",
  "seyw446du7msnvou": "Blackjack Classic 97",
  "seyw76wdu7msomp2": "Blackjack Classic 98",
  "PorBJ00000000001": "Blackjack Clássico em Português 1",
  "PorBJ00000000010": "Blackjack Clássico em Português 10",
  "PorBJ00000000011": "Blackjack Clássico em Português 11",
  "PorBJ00000000012": "Blackjack Clássico em Português 12",
  "PorBJ00000000013": "Blackjack Clássico em Português 13",
  "PorBJ00000000014": "Blackjack Clássico em Português 14",
  "PorBJ00000000015": "Blackjack Clássico em Português 15",
  "PorBJ00000000016": "Blackjack Clássico em Português 16",
  "PorBJ00000000017": "Blackjack Clássico em Português 17",
  "PorBJ00000000018": "Blackjack Clássico em Português 18",
  "PorBJ00000000019": "Blackjack Clássico em Português 19",
  "PorBJ00000000002": "Blackjack Clássico em Português 2",
  "PorBJ00000000020": "Blackjack Clássico em Português 20",
  "PorBJ00000000021": "Blackjack Clássico em Português 21",
  "PorBJ00000000022": "Blackjack Clássico em Português 22",
  "PorBJ00000000023": "Blackjack Clássico em Português 23",
  "PorBJ00000000004": "Blackjack Clássico em Português 4",
  "PorBJ00000000005": "Blackjack Clássico em Português 5",
  "PorBJ00000000006": "Blackjack Clássico em Português 6",
  "PorBJ00000000007": "Blackjack Clássico em Português 7",
  "PorBJ00000000008": "Blackjack Clássico em Português 8",
  "PorBJ00000000009": "Blackjack Clássico em Português 9",
  "rdefcn4sffgo39l7": "Blackjack Diamond VIP",
  "ejx1a04w4ben0mou": "Blackjack Fortune VIP",
  "gfzrqe4hqv24kukc": "Blackjack Grand VIP",
  "InfinAoVi0000001": "Blackjack Ilimitado Ao Vivo",
  "category:blackjack": "Blackjack Lobby",
  "sni5cza6d1vvl50i": "Blackjack Party",
  "h463tlq1rhl1lfr2": "Blackjack Platinum VIP",
  "gkmq0o2hryjyqu30": "Blackjack Silver A",
  "9f4xhuhdd005xlbl": "Blackjack Silver B",
  "qlrc3fq3v7p6awm4": "Blackjack Silver C",
  "qckwjf2o52r9ikeb": "Blackjack Silver D",
  "gazgtkid9h1b0dn9": "Blackjack Silver E",
  "lnofoyxv756qaezy": "Blackjack Silver F",
  "lnofpmm3756qae2c": "Blackjack Silver G",
  "o7347okwaeasvy2y": "Blackjack VIP 1",
  "pdk5yexcz4iepelq": "Blackjack VIP 10",
  "pdk5yzyfjkgepoml": "Blackjack VIP 11",
  "pdk5zo7cey6upxlm": "Blackjack VIP 12",
  "pdk52e3rey6upyie": "Blackjack VIP 13",
  "pdk523jney6upzft": "Blackjack VIP 14",
  "pdk53n4bjkgepr5u": "Blackjack VIP 15",
  "pdk54i3vey6up3dg": "Blackjack VIP 16",
  "ps3t7j4ykfe2fhdw": "Blackjack VIP 17",
  "ps3t7nhskfe2fhkj": "Blackjack VIP 18",
  "ps3t7qv2teskeg4w": "Blackjack VIP 19",
  "o735azzsaeasv2pr": "Blackjack VIP 2",
  "p2fzwauitc2msrik": "Blackjack VIP 20",
  "p2f2lphftc2muaql": "Blackjack VIP 21",
  "p2f2ootrm2tmvk6h": "Blackjack VIP 22",
  "qfyw6u63rixe3foz": "Blackjack VIP 25",
  "qfyxcoqlrcfe44nj": "Blackjack VIP 26",
  "qfyxgwwsrcfe5lq3": "Blackjack VIP 27",
  "q6wo6fjprnlhuf36": "Blackjack VIP 28",
  "q6wo7mqrrnlhuj6b": "Blackjack VIP 29",
  "o735cjzyaeasv4o6": "Blackjack VIP 3",
  "rctfyut2btsmfyyt": "Blackjack VIP 30",
  "rctf2h7wbtsmf7rs": "Blackjack VIP 31",
  "rctf4gu6btsmghbt": "Blackjack VIP 32",
  "rpju2x53mruw4otv": "Blackjack VIP 33",
  "rpju6q5dmruw45u5": "Blackjack VIP 34",
  "rpjvbpsmmruw5jza": "Blackjack VIP 35",
  "rpjvlz76mruw6uj3": "Blackjack VIP 36",
  "rpjvp2tbmruw7dke": "Blackjack VIP 37",
  "rpjvjgoamruw6jvl": "Blackjack VIP 38",
  "o735di2eiwssv7eu": "Blackjack VIP 4",
  "rpjvgpapmruw56qy": "Blackjack VIP 40",
  "rpjvse45mruw7nbx": "Blackjack VIP 41",
  "rpo2h5irxfneqjnj": "Blackjack VIP 44",
  "rpo2takvxfnervo2": "Blackjack VIP 47",
  "rpo2u4duxfner55b": "Blackjack VIP 48",
  "rpo2x4pyxfneskcf": "Blackjack VIP 49",
  "o735efxfaeasv666": "Blackjack VIP 5",
  "rtkntgzxtdhrbq5r": "Blackjack VIP 52",
  "rtknwheptdhrb7i4": "Blackjack VIP 53",
  "rtknzl3ktdhrcn6w": "Blackjack VIP 54",
  "rtkn3mywtdhrcyih": "Blackjack VIP 55",
  "rtkn5n3itdhrdcug": "Blackjack VIP 56",
  "rtkn7soztdhrdnu7": "Blackjack VIP 57",
  "rtkobqo7tdhrdxv7": "Blackjack VIP 58",
  "rtkoephutdhrefsp": "Blackjack VIP 59",
  "o735fhvsaeaswamh": "Blackjack VIP 6",
  "rtkohacstdhrer7g": "Blackjack VIP 60",
  "rtkokwaxtdhrfc3o": "Blackjack VIP 61",
  "rtkonqfitdhrfqm6": "Blackjack VIP 62",
  "rtkopvvktdhrf3ge": "Blackjack VIP 63",
  "rtkorq7stdhrge4q": "Blackjack VIP 64",
  "rtkouphqtdhrgsyt": "Blackjack VIP 65",
  "rtkow2bltdhrg6tr": "Blackjack VIP 66",
  "rtkoyqhctdhrhhr5": "Blackjack VIP 67",
  "rtko2e6jtdhrhqez": "Blackjack VIP 68",
  "rtko32b2tdhrhy6e": "Blackjack VIP 69",
  "o735ggd5iwsswcz7": "Blackjack VIP 7",
  "rtko5szetdhricf4": "Blackjack VIP 70",
  "o735hfcqauecwjxp": "Blackjack VIP 8",
  "pdk5xfrkjkgepmlq": "Blackjack VIP 9",
  "0mvn914lkmo9vaq8": "Blackjack VIP A",
  "oqicznoauwbl46am": "Blackjack VIP Alpha",
  "cpxl81x0rgi34cmo": "Blackjack VIP B",
  "oqic5sqbt25322zm": "Blackjack VIP Beta",
  "l5aug44hhzr3qvxs": "Blackjack VIP C",
  "o3d9tx3u8kd0yawc": "Blackjack VIP D",
  "psm2um7k4da8zwc2": "Blackjack VIP E",
  "ehw2fvl831m5n2km": "Blackjack VIP F",
  "z5pf5pichcsw3d2o": "Blackjack VIP G",
  "oqidcfpsuwbl5cqd": "Blackjack VIP Gamma",
  "s63nx2mpdomgjagb": "Blackjack VIP H",
  "lnofn2yl756qaezm": "Blackjack VIP I",
  "m6mfo66sb7eafnzz": "Blackjack VIP J",
  "m6mfsirtb7eafn5c": "Blackjack VIP K",
  "nbjettfehawanhes": "Blackjack VIP L",
  "nbjetztthawanhey": "Blackjack VIP M",
  "nkyiswhd2jpbw4i4": "Blackjack VIP N",
  "nkyivihc2jpbw4uy": "Blackjack VIP O",
  "nsxqkywul2nzcwwh": "Blackjack VIP P",
  "oa7fvyaiqfueq5ob": "Blackjack VIP Q",
  "nsxqpyiol2nzcz6t": "Blackjack VIP R",
  "nveq65dtmn6n4mnd": "Blackjack VIP S",
  "nveq66tfmn6n4moi": "Blackjack VIP T",
  "bciewncrf5ijneys": "Blackjack VIP U",
  "2uxabtm1rwaxcmdm": "Blackjack VIP V",
  "bghflgi59db7d7r2": "Blackjack VIP X",
  "oa7fpshyqfueqxuj": "Blackjack VIP Z",
  "CSPTable00000001": "Caribbean Stud Poker",
  "CashOrCrash00001": "Cash or Crash",
  "HoldemTable00001": "Casino Hold'em",
  "mvrcophqscoqosd6": "Casino Malta Roulette",
  "bj6eu00000000001": "Classic Always 6 Blackjack 1",
  "bj6eu00000000002": "Classic Always 6 Blackjack 2",
  "bj6eu00000000003": "Classic Always 6 Blackjack 3",
  "bj6eu00000000004": "Classic Always 6 Blackjack 4",
  "tveiynm2dlyabcgh": "Classic Ukrainian Blackjack 1",
  "tvek6bckdlyabcse": "Classic Ukrainian Blackjack 2",
  "tvemrm3vdlyabc4m": "Classic Ukrainian Blackjack 3",
  "Craps00000000001": "Craps",
  "CrazyBalls000001": "Crazy Balls",
  "CrazyCoinFlip001": "Crazy Coin Flip",
  "CrazyPachinko001": "Crazy Pachinko",
  "CrazyTime0000001": "Crazy Time",
  "CrazyTime0000002": "Crazy Time A",
  "doasaloon0000001": "Dead or Alive: Saloon",
  "DealOrNoDeal0001": "Deal or No Deal",
  "DoubleBallRou001": "Double Ball Roulette",
  "DragonDragon0001": "Dragon Dragon",
  "DragonTiger00001": "Dragon Tiger",
  "DTP0000000000001": "Dragon Tiger Phoenix",
  "pnkk4iuchw7blb2p": "Dragonara Roulette",
  "MOWDream00000001": "Dream Catcher",
  "topz1m7k4sdddx5q": "Dynasty Blackjack 5",
  "toxp9w3a6tdddn6m": "Dynasty Blackjack 6",
  "toxj6x8f2qdddk7a": "Dynasty Blackjack 7",
  "toxk4m9q7xddd2a8": "Dynasty Blackjack 8",
  "toxa8f2w0jdddr9c": "Dynasty Blackjack 9",
  "tpc4727ijhddd7p2": "Dynasty Classic Blackjack 1",
  "tpc8m4zqk9ddd2a7": "Dynasty Classic Blackjack 2",
  "tpc0fjr7xwdddq9c": "Dynasty Classic Blackjack 3",
  "tpcl9s2a5uddd84m": "Dynasty Classic Blackjack 4",
  "rfbo6mhpdgyqbpay": "Emperor Bac Bo",
  "puu47n7mic3rfd7y": "Emperor Dragon Tiger",
  "Empgwbaccarat001": "Emperor Golden Wealth Baccarat",
  "pv5q45yjhasyt46y": "Emperor Roulette",
  "EmperorSB0000001": "Emperor Sic Bo",
  "EmperorSB0000002": "Emperor Sic Bo A",
  "puu4yfymic3reudn": "Emperor Speed Baccarat A",
  "puu43e6c5uvrfikr": "Emperor Speed Baccarat B",
  "pwsaqk24fcz5qpcr": "Emperor Speed Baccarat C",
  "q6ardco6opnfwes4": "Emperor Speed Baccarat D",
  "ExChEpicSpins001": "Extra Chilli Epic Spins",
  "ETHTable00000001": "Extreme Texas Hold'em",
  "FanTan0000000001": "Fan Tan",
  "fireballrou00001": "Fireball Roulette",
  "category:rng": "First Person",
  "rng-rt-american0": "First Person American Roulette",
  "RngBacBo00000001": "First Person Bac Bo",
  "rngbaccarat00000": "First Person Baccarat",
  "rng-bj-standard0": "First Person Blackjack",
  "RngCraps00000001": "First Person Craps",
  "RngDealNoDeal001": "First Person Deal or No Deal",
  "rng-dragontiger0": "First Person Dragon Tiger",
  "rng-dreamcatcher": "First Person Dream Catcher",
  "rng-gwbaccarat00": "First Person Golden Wealth Baccarat",
  "rnghilo000000001": "First Person HiLo",
  "rng-lbaccarat000": "First Person Lightning Baccarat",
  "rng-rt-lightning": "First Person Lightning Roulette",
  "RngMegaBall00001": "First Person Mega Ball",
  "rng-ptbaccarat01": "First Person Prosperity Tree Baccarat",
  "rng-rt-european0": "First Person Roulette",
  "rng-topcard00001": "First Person Top Card",
  "FPVP000000000001": "First Person Video Poker",
  "rng-rt-xxxtreme1": "First Person XXXtreme Lightning Roulette",
  "TopCard000000001": "Football Studio",
  "TopDice000000001": "Football Studio Dice",
  "7nyiaws9tgqrzaz3": "Football Studio Roulette",
  "CFreeBetBj000001": "Free Bet Blackjack 1",
  "CFreeBetBj000010": "Free Bet Blackjack 10",
  "CFreeBetBj000011": "Free Bet Blackjack 11",
  "CFreeBetBj000012": "Free Bet Blackjack 12",
  "CFreeBetBj000013": "Free Bet Blackjack 13",
  "CFreeBetBj000014": "Free Bet Blackjack 14",
  "CFreeBetBj000015": "Free Bet Blackjack 15",
  "CFreeBetBj000016": "Free Bet Blackjack 16",
  "CFreeBetBj000017": "Free Bet Blackjack 17",
  "CFreeBetBj000018": "Free Bet Blackjack 18",
  "CFreeBetBj000019": "Free Bet Blackjack 19",
  "CFreeBetBj000002": "Free Bet Blackjack 2",
  "CFreeBetBj000020": "Free Bet Blackjack 20",
  "CFreeBetBj000021": "Free Bet Blackjack 21",
  "CFreeBetBj000022": "Free Bet Blackjack 22",
  "CFreeBetBj000023": "Free Bet Blackjack 23",
  "CFreeBetBj000003": "Free Bet Blackjack 3",
  "CFreeBetBj000004": "Free Bet Blackjack 4",
  "CFreeBetBj000005": "Free Bet Blackjack 5",
  "CFreeBetBj000006": "Free Bet Blackjack 6",
  "CFreeBetBj000007": "Free Bet Blackjack 7",
  "CFreeBetBj000008": "Free Bet Blackjack 8",
  "CFreeBetBj000009": "Free Bet Blackjack 9",
  "PorCFreeBetBj002": "Free Bet Blackjack Clássico em Português 2",
  "CFreeBetBjVIP003": "Free Bet VIP Blackjack A",
  "CFreeBetBjVIP002": "Free Bet VIP Blackjack B",
  "CFreeBetBjVIP001": "Free Bet VIP Blackjack C",
  "CFreeBetBjVIP004": "Free Bet VIP Blackjack D",
  "CFreeBetBjVIP005": "Free Bet VIP Blackjack E",
  "CFreeBetBjVIP006": "Free Bet VIP Blackjack F",
  "CFreeBetBjVIP007": "Free Bet VIP Blackjack G",
  "CFreeBetBjVIP008": "Free Bet VIP Blackjack H",
  "CFreeBetBjVIP009": "Free Bet VIP Blackjack I",
  "CFreeBetBjVIP010": "Free Bet VIP Blackjack J",
  "CFreeBetBjVIP011": "Free Bet VIP Blackjack K",
  "CFreeBetBjVIP012": "Free Bet VIP Blackjack L",
  "CFreeBetBjVIP013": "Free Bet VIP Blackjack M",
  "CFreeBetBjVIP014": "Free Bet VIP Blackjack N",
  "CFreeBetBjVIP015": "Free Bet VIP Blackjack O",
  "CFreeBetBjVIP016": "Free Bet VIP Blackjack P",
  "se3fdvrygplpu44b": "French Roulette Gold",
  "FunkyTime0000001": "Funky Time",
  "TopCard000000004": "Futebol Studio Ao Vivo",
  "category:game_shows": "Games Show Lobby",
  "GoldVaultRo00001": "Gold Vault Roulette",
  "gwbaccarat000001": "Golden Wealth Baccarat",
  "GonzoTM000000001": "Gonzo's Treasure Map",
  "lr6t4k3lcd4qgyrk": "Grand Casino Roulette",
  "LightningHindi01": "Hindi Lightning Roulette",
  "otctxzr5fjyggijz": "Hindi Roulette",
  "qhhjdnovai4a3a6k": "Hindi Speed Baccarat A",
  "HSpeedBac0000002": "Hindi Speed Baccarat B",
  "mrpuiwhx5slaurcy": "Hippodrome Grand Casino",
  "IceFishing000001": "Ice Fishing",
  "7x0b1tgh7agmf6hv": "Immersive Roulette",
  "ImperialQuest001": "Imperial Quest",
  "scabetstack00001": "Infinite Bet Stacker Blackjack",
  "mrfykemt5slanyi5": "Infinite Blackjack",
  "FreeBet000000001": "Infinite Free Bet Blackjack",
  "InstantRo0000001": "Instant Roulette",
  "InsuranceBac0001": "Insurance Baccarat",
  "tmjiirpvxgcqai7u": "Klasik Bet Stacker Blackjack 1",
  "tmjuovlhxgcqaj7b": "Klasik Bet Stacker Blackjack 2",
  "nohpvzcpiyplihvb": "Klasik Blackjack",
  "tlnfakxkp5naafrv": "Klasik Blackjack 10",
  "tlne7hj4nhsftm2c": "Klasik Blackjack 11",
  "qwvbdjpaptq7bzl2": "Klasik Blackjack 12",
  "rvkkugxae7zgus3g": "Klasik Blackjack 13",
  "rvklp5kee7zgxhwn": "Klasik Blackjack 14",
  "rvklr74ze7zgxpjq": "Klasik Blackjack 15",
  "rvkluakpe7zgxw2p": "Klasik Blackjack 16",
  "nwtjw5z76teu6bid": "Klasik Blackjack 2",
  "nwtrhft76teveefu": "Klasik Blackjack 3",
  "oxtepb7sccjxmqvg": "Klasik Blackjack 4",
  "oxter2nwhkbhmv2n": "Klasik Blackjack 5",
  "oy6sjyyti7umzwz4": "Klasik Blackjack 8",
  "oy6skn72ejg6imxf": "Klasik Blackjack 9",
  "tmgjvybyqbdqaoy4": "Klasik Freebet Blackjack 1",
  "tmgosntsqbdqappa": "Klasik Freebet Blackjack 2",
  "oy6sgdcui7umzsn7": "Klasik Speed Blackjack 1",
  "rymhgpnxfnccuaas": "Klasik Speed Blackjack 10",
  "rymhjcjifnccumgx": "Klasik Speed Blackjack 11",
  "rymhlflefnccuwma": "Klasik Speed Blackjack 12",
  "rymhm2ctfnccu6kn": "Klasik Speed Blackjack 13",
  "rymhoch4fnccvepj": "Klasik Speed Blackjack 14",
  "rymhpvtnfnccvmdo": "Klasik Speed Blackjack 15",
  "rymhrabxfnccvssh": "Klasik Speed Blackjack 16",
  "oy6sg75pejg6iivq": "Klasik Speed Blackjack 2",
  "rc7fdbmuiebmfhvi": "Klasik Speed Blackjack 3",
  "rllpfusm64nict46": "Klasik Speed Blackjack 4",
  "rln6fndmuma35vle": "Klasik Speed Blackjack 5",
  "rln6iq7huma3567s": "Klasik Speed Blackjack 6",
  "rln6m26ruma36l3v": "Klasik Speed Blackjack 7",
  "rymgd2enfnccpmox": "Klasik Speed Blackjack 8",
  "rymhfemmfncctzre": "Klasik Speed Blackjack 9",
  "LightningBacBo01": "Lightning Bac Bo",
  "LightningBac0001": "Lightning Baccarat",
  "LightningBall001": "Lightning Ball",
  "LightningSbj0001": "Lightning Blackjack",
  "LightningDice001": "Lightning Dice",
  "LightningDT00001": "Lightning Dragon Tiger",
  "LightningTable01": "Lightning Roulette",
  "lightningsb00001": "Lightning Sic Bo",
  "LightningStorm01": "Lightning Storm",
  "livespins2000000": "Livespins - Bet With Streamers 2",
  "livespins3000000": "Livespins - Bet With Streamers 3",
  "livespins0000000": "Livespins – Bet With Streamers",
  "pv2zgy42anvdwk3l": "Lotus Roulette",
  "LotusSicBo000001": "Lotus Sic Bo",
  "pv2y4kmsanvdvwgy": "Lotus Speed Baccarat A",
  "srsnxlybuz4rrqr6": "Lotus Speed Baccarat B",
  "srsp4ai6uz4sfq4z": "Lotus Speed Baccarat C",
  "MarbleRace000001": "Marble Race",
  "MegaBall00000001": "Mega Ball",
  "MBDaSorte0000002": "Mega Bola Da Sorte",
  "MonBigBaller0001": "Monopoly Big Baller",
  "Monopoly00000001": "Monopoly Live",
  "NoCommBac0000001": "No Commission Baccarat",
  "ndgv76kehfuaaeec": "No Commission Speed Baccarat A",
  "ocye5hmxbsoyrcii": "No Commission Speed Baccarat B",
  "ovu5h6b3ujb4y53w": "No Commission Speed Baccarat C",
  "peekbaccarat0001": "Peek Baccarat",
  "PeryaLightnRo001": "Perya Lightning Roulette",
  "PlatPrivBJ000001": "Platinum Privé Blackjack 1",
  "PlatPrivBJ000002": "Platinum Privé Blackjack 2",
  "PlatPrivBJ000004": "Platinum Privé Blackjack 4",
  "PlatPrivBJ000005": "Platinum Privé Blackjack 5",
  "PlatPrivBJ000006": "Platinum Privé Blackjack 6",
  "PlatPrivBJ000007": "Platinum Privé Blackjack 7",
  "PlatPrivBJ000008": "Platinum Privé Blackjack 8",
  "PlatPrivBJ000009": "Platinum Privé Blackjack 9",
  "PowerInfiniteBJ1": "Power Blackjack",
  "PTBaccarat000001": "Prosperity Tree Baccarat",
  "RaceTrack0000001": "Race Track",
  "RaceTrack0000002": "Race Track A",
  "RedBaron00000001": "Red Baron",
  "RedDoorRoulette1": "Red Door Roulette",
  "PorROULigh000001": "Roleta Relâmpago",
  "PorROU0000000001": "Roleta ao Vivo",
  "category:roulette": "Roulette Lobby",
  "RedDoorRouES0001": "Ruleta Puerta Roja En Vivo",
  "tsfb2rkelrtqayy2": "Ruleta Relámpago XXXtreme",
  "SalPrivBac000001": "Salon Prive Baccarat A",
  "n7ltqx5j25sr7xbe": "Salon Prive Baccarat B",
  "ok37hvy3g7bofp4l": "Salon Prive Baccarat C",
  "SalPrivBac000004": "Salon Prive Baccarat D",
  "pctte34dt6bqbtps": "Salon Prive Baccarat E",
  "p34gzl44usw74wks": "Salon Prive Baccarat F",
  "p34i6wgax7bqb5cg": "Salon Prive Baccarat G",
  "SalPrivBac000008": "Salon Prive Baccarat H",
  "SalPrivBac000009": "Salon Prive Baccarat I",
  "SalPrivBac000010": "Salon Prive Baccarat J",
  "SalPrivBac000011": "Salon Prive Baccarat K",
  "SalPrivBac000012": "Salon Prive Baccarat L",
  "mdkqdxtkdctrhnsx": "Salon Prive Blackjack A",
  "olbibp3fylzaxvhb": "Salon Prive Blackjack B",
  "mdkqfe74dctrhntj": "Salon Prive Blackjack C",
  "olbinkuoylzayeoj": "Salon Prive Blackjack D",
  "SalPrivBJ0000005": "Salon Prive Blackjack E",
  "SalPrivBJ0000006": "Salon Prive Blackjack F",
  "p36n5jvdx7bugh2g": "Salon Prive Blackjack G",
  "SalPrivBJ0000008": "Salon Prive Blackjack H",
  "SalPrivBJ0000009": "Salon Prive Blackjack I",
  "SalPrivBJ0000010": "Salon Prive Blackjack J",
  "SalPrivBJ0000011": "Salon Prive Blackjack K",
  "SalPrivBJ0000012": "Salon Prive Blackjack L",
  "SalPrivBJ0000013": "Salon Prive Blackjack M",
  "SalPrivBJ0000014": "Salon Prive Blackjack N",
  "SalPrivBJ0000015": "Salon Prive Blackjack O",
  "mdkqijp3dctrhnuv": "Salon Prive Roulette",
  "SalPrivBJ0000016": "Salon Privé Blackjack",
  "SpeedAutoRo00001": "Speed Auto Roulette",
  "qsf65xtoyvbqoaop": "Speed Baccarat 1",
  "rep5iuhinyjmalz4": "Speed Baccarat 10",
  "rep5kwmdnyjmasxi": "Speed Baccarat 11",
  "rep5m2cdnyjmazzo": "Speed Baccarat 12",
  "rep6d5n2nyjmcv7d": "Speed Baccarat 13",
  "rep6e5znnyjmc2pz": "Speed Baccarat 14",
  "rep6g26enyjmdbdk": "Speed Baccarat 15",
  "qsf7alptyvbqohva": "Speed Baccarat 2",
  "qsf7bpfvyvbqolwp": "Speed Baccarat 3",
  "rdjda6zq7jdyo6cs": "Speed Baccarat 4",
  "rep45wbxnyjl7hr2": "Speed Baccarat 5",
  "rep5aor7nyjl7qli": "Speed Baccarat 6",
  "rep5ca4ynyjl7wdw": "Speed Baccarat 7",
  "rep5eiecnyjl75lq": "Speed Baccarat 8",
  "rep5gu47nyjmafgt": "Speed Baccarat 9",
  "leqhceumaq6qfoug": "Speed Baccarat A",
  "lv2kzclunt2qnxo5": "Speed Baccarat B",
  "ndgvwvgthfuaad3q": "Speed Baccarat C",
  "ndgvz5mlhfuaad6e": "Speed Baccarat D",
  "ndgv45bghfuaaebf": "Speed Baccarat E",
  "nmwde3fd7hvqhq43": "Speed Baccarat F",
  "nmwdzhbg7hvqh6a7": "Speed Baccarat G",
  "nxpj4wumgclak2lx": "Speed Baccarat H",
  "nxpkul2hgclallno": "Speed Baccarat I",
  "obj64qcnqfunjelj": "Speed Baccarat J",
  "ocye2ju2bsoyq6vv": "Speed Baccarat K",
  "ovu5cwp54ccmymck": "Speed Baccarat L",
  "ovu5dsly4ccmynil": "Speed Baccarat M",
  "ovu5eja74ccmyoiq": "Speed Baccarat N",
  "ovu5fbxm4ccmypmb": "Speed Baccarat O",
  "ovu5fzje4ccmyqnr": "Speed Baccarat P",
  "o4kyj7tgpwqqy4m4": "Speed Baccarat Q",
  "o4kylkahpwqqy57w": "Speed Baccarat R",
  "o4kymodby2fa2c7g": "Speed Baccarat S",
  "qgonc7t4ucdiel4o": "Speed Baccarat T",
  "qgqrhfvsvltnueqf": "Speed Baccarat U",
  "qgqrrnuqvltnvejx": "Speed Baccarat V",
  "qgqrucipvltnvnvq": "Speed Baccarat W",
  "qgqrv4asvltnvuty": "Speed Baccarat X",
  "qsf63ownyvbqnz33": "Speed Baccarat Z",
  "xqyb2u7fqkexxpa0": "Speed Blackjack D",
  "ylq4gmw8yl22u5dj": "Speed Blackjack E",
  "1xwfnktjybsolkn6": "Speed Blackjack G",
  "nc3u2l6y0khszjv7": "Speed Blackjack H",
  "xstnlyzrm345ev95": "Speed Blackjack I",
  "i5j1cyqhrypkih23": "Speed Blackjack J",
  "SpeedBlackjack29": "Speed Blackjack K",
  "k4r2hyhw4eqqb6us": "Speed Blackjack L",
  "k4r2kvd34eqqb6vh": "Speed Blackjack M",
  "lkcbrbdckjxajdol": "Speed Roulette",
  "SpeedBlackjack01": "Speed VIP Blackjack A",
  "SpeedBlackjack02": "Speed VIP Blackjack B",
  "SpeedBlackjack03": "Speed VIP Blackjack C",
  "SpeedBlackjack04": "Speed VIP Blackjack D",
  "ps3ufteekfe2fu24": "Speed VIP Blackjack E",
  "ps3uijuskfe2f3cj": "Speed VIP Blackjack G",
  "p2f2zs26tc2mu7r5": "Speed VIP Blackjack I",
  "p2f25gsom2tmwmpn": "Speed VIP Blackjack J",
  "qfyyxolocjhfau7y": "Speed VIP Blackjack K",
  "qfyy4jm6rixfbllh": "Speed VIP Blackjack L",
  "qfyzapjqrixfb3bx": "Speed VIP Blackjack M",
  "SpeedBlackjack14": "Speed VIP Blackjack N",
  "SpeedBlackjack15": "Speed VIP Blackjack O",
  "SpeedBlackjack16": "Speed VIP Blackjack P",
  "SpeedBlackjack17": "Speed VIP Blackjack Q",
  "SpeedBlackjack18": "Speed VIP Blackjack R",
  "SpeedBlackjack20": "Speed VIP Blackjack T",
  "SpeedBlackjack21": "Speed VIP Blackjack U",
  "SpeedBlackjack22": "Speed VIP Blackjack V",
  "StockMarket00001": "Stock Market",
  "AndarBahar000001": "Super Andar Bahar",
  "supercolorgame01": "Super Color Game",
  "SuperSicBo000001": "Super Sic Bo",
  "SuperSpeedDT0001": "Super Speed Dragon Tiger",
  "teenpattitable01": "Teen Patti",
  "THBTable00000001": "Texas Hold'em Bonus Poker",
  "pezjou3ltf6hvzjk": "Thai Speed Baccarat A",
  "suropcmnbqpabwko": "Thai Speed Baccarat B",
  "surtfpwgbqpab4ur": "Thai Speed Baccarat C",
  "TRPTable00000001": "Triple Card Poker",
  "TRLRou0000000001": "Turkish Lightning Roulette",
  "TRCrazyTime00001": "Türkçe Crazy Time",
  "nifyytz35m2qcevw": "Türkçe Futbol Stüdyosu",
  "r5aw9yumyaxgnd90": "Türkçe Rulet",
  "bj6euvip00000001": "VIP Always 6 Blackjack 1",
  "bj6euvip00000002": "VIP Always 6 Blackjack 2",
  "bj6euvip00000003": "VIP Always 6 Blackjack 3",
  "PorBJVIP00000001": "VIP Blackjack em Português",
  "PorBJVIP00000002": "VIP Blackjack em Português 2",
  "PorBJVIP00000003": "VIP Blackjack em Português 3",
  "PorBJVIP00000004": "VIP Blackjack em Português 4",
  "PorBJVIP00000005": "VIP Blackjack em Português 5",
  "PorBJVIP00000006": "VIP Blackjack em Português 6",
  "PorBJVIP00000007": "VIP Blackjack em Português 7",
  "wzg6kdkad1oe7m5k": "VIP Roulette",
  "VPTable000000001": "Video Poker",
  "War0000000000001": "War",
  "XXXtremeLB000001": "XXXtreme Lightning Baccarat",
  "XxxtremeLigh0001": "XXXtreme Lightning Roulette",
  "101candiesr96f10": "101 Candies",
  "alohaxmas0000000": "Aloha! Christmas",
  "aloha00000000000": "Aloha! Cluster Pays",
  "ameriroulette3ne": "American Roulette",
  "arabian000000000": "Arabian Nights",
  "asgardianstones0": "Asgardian Stones",
  "babylonriches000": "Babylon Riches",
  "beachinvaders000": "Beach Invaders",
  "beehivebonanza00": "Bee Hive Bonanza",
  "berryburst000000": "Berryburst",
  "bigbangboomr96f1": "Big Bang Boom",
  "bigmoneywher96f1": "Big Money Wheel",
  "blackjack3ne0000": "Blackjack",
  "blackjack0h0i0j0": "Blackjack Classic",
  "blackjack31hne00": "Blackjack Touch - Single Deck",
  "bloodsuckersj0r2": "Blood Suckers",
  "bloodsuckers2000": "Blood Suckers II",
  "buckshotwilr96f1": "Buckshot Wilds",
  "bustersboesr96f1": "Buster's Bones",
  "butterflystaxx00": "Butterfly Staxx",
  "butterflystaxx20": "Butterfly Staxx 2",
  "cashnoire0000000": "Cash Noire",
  "cashomatic000000": "Cash-o-Matic",
  "casinoholdemne00": "Casino Hold'em",
  "casinonight00000": "Casino Night",
  "codexoffortune00": "Codex of Fortune",
  "conan00000000000": "Conan",
  "corneliusf100000": "Cornelius",
  "corneliusmir96f1": "Cornelius Milk Hunter Megaways",
  "crabtrapr96f1000": "Crab Trap",
  "blacklagoon00000": "Creature from the Black Lagoon",
  "cupcakesf1000000": "Cupcakes",
  "cursedtreasr96f1": "Cursed Treasure",
  "darkking00000000": "Dark King: Forbidden Riches",
  "dazzle0000000000": "Dazzle Me",
  "dazzlemechrr96f1": "Dazzle Me Christmas",
  "dazzlemwr3000000": "Dazzle Me Megaways",
  "deadwestr96f1000": "Dead West",
  "deadoralive00000": "Dead or Alive",
  "deadoralive20000": "Dead or Alive 2",
  "deadoralive2fb00": "Dead or Alive 2 Feature Buy",
  "deadalive3r96f10": "Dead or Alive™ 3: Wanted",
  "discodanny000000": "Disco Danny",
  "godsoffortune000": "Divine Fortune",
  "divinefortur96f1": "Divine Fortune Black",
  "divinemegaways00": "Divine Fortune Megaways",
  "donteatthecandy0": "Don’t Eat the Candy",
  "doublestacks0000": "Double Stacks",
  "dracula000000000": "Dracula",
  "dragonsplaygroun": "Dragons Playground",
  "multipliermayhem": "Drive: Multiplier Mayhem",
  "druidsmagic00000": "Druid's Magic",
  "druidsdream00000": "Druids' Dream",
  "eggomatic0000000": "EggOMatic",
  "elements00000000": "Elements: The Awakening",
  "elkhunterr96f100": "Elk Hunter",
  "europroulette3ne": "European Roulette",
  "excalibur0000000": "Excalibur",
  "fairyhansel00000": "Fairytale Legends: Hansel and Gretel",
  "fairymirror00000": "Fairytale Legends: Mirror Mirror",
  "fairyred00000000": "Fairytale Legends: Red Riding Hood",
  "finncandyspr96f1": "Finn and the Candy Spin",
  "finndragontr96f1": "Finn and the Dragon Tales",
  "finn000000000000": "Finn and the Swirly Spin",
  "goldentavern0000": "Finn's Golden Tavern",
  "flockmer96f10000": "Flock Me",
  "flowers000000000": "Flowers",
  "football00000000": "Football: Champions Cup",
  "frenchroulettene": "French Roulette",
  "fruitblazef1r300": "Fruit Blaze",
  "fruitshop0000000": "Fruit Shop",
  "fruitshopchristm": "Fruit Shop Christmas Edition",
  "fruitshopfrenzy0": "Fruit Shop Frenzy",
  "fruitshopmegaway": "Fruit Shop Megaways",
  "jewelfruits00000": "Fruit Spin",
  "funkmaster000000": "Funk Master",
  "gemcrush00000000": "Gem Crush",
  "gladiatorclash00": "Gladiator Clash",
  "godbreakerr96f10": "Godbreaker",
  "godsofgold000000": "Gods Of Gold: InfiniReels",
  "goldeneggirs96f1": "Golden Egg Invaders",
  "goldengrimoire00": "Golden Grimoire",
  "goldenrealmr94f1": "Golden Realms",
  "goldenwheelr96f0": "Golden Wheels of Egypt",
  "gonzosgoldr30000": "Gonzo's Gold",
  "eldorado00000000": "Gonzo's Quest",
  "goodold7s0000000": "Good Old 7’s",
  "hellskitchen0000": "Gordon Ramsay Hell's Kitchen",
  "gorillakingdom00": "Gorilla Kingdom",
  "grandspinn000000": "Grand Spinn",
  "grandspinnspot00": "Grand Spinn Superpot",
  "gunsnroses000000": "Guns N' Roses Video Slots",
  "hallofgods000000": "Hall of Gods",
  "halloweenjack000": "Halloween Jack",
  "hotline000000000": "Hotline",
  "hotline200000000": "Hotline 2",
  "imperialriches00": "Imperial Riches",
  "irishpotluck0000": "Irish Pot Luck",
  "jackhammer000000": "Jack Hammer",
  "jackhammer200000": "Jack Hammer 2: Fishy Business",
  "jackhammer3r96f1": "Jack Hammer 3",
  "jackhammer4r96f1": "Jack Hammer 4: Chasing the Dragon",
  "jackandbeanstalk": "Jack and the Beanstalk",
  "jackandbeanr96f1": "Jack and the Beanstalk Remastered",
  "jackpot600000000": "Jackpot 6000",
  "jacksmultihandn1": "Jacks or Better Double Up",
  "jellybellymegawa": "Jelly Belly™ MegaWays™",
  "jimihendrix00000": "Jimi Hendrix Online Slot",
  "jinglebellsbonan": "Jingle Bells Bonanza",
  "jinglespin000000": "Jingle Spin",
  "jokerpro00000000": "Joker Pro",
  "jumanji000000000": "Jumanji",
  "junglespirir96f1": "Jungle Spirit Megaways",
  "junglespirit0000": "Jungle Spirit: Call of the Wild",
  "kingofslots00000": "King of Slots",
  "knightrider00000": "Knight Rider Video Slot",
  "koiprincess00000": "Koi Princess",
  "leprechaunjoy000": "Leprechaun Joy",
  "letitburnr96f100": "Let It Burn",
  "fireflies0000000": "Lights",
  "lightscameracash": "Lights, Camera, Cash!™",
  "lostrelics000000": "Lost Relics",
  "lostrelics200000": "Lost Relics 2",
  "magiclab00000000": "Magic Lab",
  "magicmaidcafe000": "Magic Maid Cafe",
  "megafortune00000": "Mega Fortune",
  "megafortunedream": "Mega Fortune Dreams",
  "megajoker0000000": "Mega Joker",
  "mercyofthegods00": "Mercy Of The Gods",
  "mermaids00000000": "Mermaids™",
  "milkshakexxr96f1": "Milkshake XXXtreme",
  "mineblown0000000": "Mine Blown",
  "monopolymonr96f0": "Monopoly Money Line",
  "motorhead0000000": "Motorhead Video Slot",
  "msrobinhood00000": "Ms Robin Hood",
  "mummymegaways000": "Mummy™ Megaways™",
  "mythicmaiden0000": "Mythic Maiden",
  "narcos0000000000": "Narcos",
  "neonstaxx0000000": "Neon Staxx",
  "oceanstreasure00": "Ocean's Treasure",
  "ozzy000000000000": "Ozzy Osbourne Video Slots",
  "pandorastreasure": "Pandora's Treasure",
  "parthenon0000000": "Parthenon: Quest for Immortality",
  "piggyriches00000": "Piggy Riches",
  "piggyriche3r96f1": "Piggy Riches 3: Hog Heaven",
  "piratesparty0000": "Pirates Party™",
  "pyramid000000000": "Pyramid: Quest for Immortality",
  "rager96f10000000": "RAGE",
  "rabidrandyr96000": "Rabid Randy",
  "rabidrandyls96f0": "Rabid Randy Dark Trails",
  "rabidrandygr96f1": "Rabid Randy Gone Fishing",
  "rageoftheseas000": "Rage of the Seas",
  "rainforestgold00": "Rainforest Gold",
  "reefraiderr30000": "Reef Raider",
  "reelrush00000000": "Reel Rush",
  "reelrush20000000": "Reel Rush 2",
  "reelrushxxxr96f1": "Reel Rush XXXtreme",
  "reelsteal0000000": "Reel Steal",
  "richesofmdgardf1": "Riches of Midgard: Land and Expand",
  "riseofmaya000000": "Rise of Maya",
  "rome000000000000": "Rome: The Golden Age",
  "roulette2advne00": "Roulette Advanced",
  "roulettesne00000": "Roulette Touch",
  "royalnutsr96f100": "Royal Nuts",
  "scruffyduck00000": "Scruffy Duck",
  "scudamore0000000": "Scudamore's Super Stakes",
  "secretofthestone": "Secret of the Stones",
  "highlights000000": "Secrets of Atlantis",
  "secretsofchristm": "Secrets of Christmas",
  "serengetikings00": "Serengeti Kings",
  "silverback000000": "Silverback Gold",
  "spacewars0000000": "Space Wars",
  "spacewars2000000": "Space Wars 2",
  "spacewarsmwr96f1": "Space Wars Megaways™ XXXtreme",
  "colossalpinatas0": "Spinata Grande",
  "spinsane00000000": "Spinsane",
  "starburst0000000": "Starburst",
  "starburstgar96f1": "Starburst Galaxy",
  "starbursttremef1": "Starburst XXXtreme",
  "steamtower000000": "Steam Tower",
  "streetfighter2f1": "Street Fighter II: The World Warrior Slot",
  "superstrikerf100": "Super Striker",
  "superstarsf10000": "Superstars",
  "sweetyhoneyfruit": "Sweety Honey Fruity",
  "invisibleman0000": "The Invisible Man",
  "shangrila0000000": "The Legend of Shangri-La: Cluster Pays",
  "wishmasteroct000": "The Wish Master",
  "thewishmastermeg": "The Wish Master™ Megaways™",
  "thewolfsnight000": "The Wolf's Bane",
  "thrilltogrir96f1": "Thrill To Grill",
  "tickettowild0000": "Ticket To Wild",
  "trollpot00000000": "Trollpot 5000",
  "turnyourfortune0": "Turn Your Fortune",
  "twinspin00000000": "Twin Spin",
  "twinspinmw000000": "Twin Spin Megaways",
  "twinspinextr96f1": "Twin Spin XXXtreme",
  "twisterr96f10000": "Twister",
  "vegasnightlifer1": "Vegas Night Life",
  "victorious000000": "Victorious",
  "vikings000000000": "Vikings Video Slot",
  "warlords00000000": "Warlords: Crystals of Power",
  "wildbazaar000000": "Wild Bazaar",
  "wildminingxx96f1": "Wild Mining XXXtreme",
  "wildturkeymegawa": "Wild Turkey™ Megaways™",
  "wildwater0000000": "Wild Water",
  "wildwildwest0000": "Wild Wild West: The Great Train Heist",
  "wildworlds000000": "Wild Worlds",
  "wilderland000000": "Wilderland",
  "willyshotchillie": "Willy's Hot Chillies",
  "wingsofriches000": "Wings of Riches",
  "wolfcub000000000": "Wolf Cub",
  "wondersofstmasf0": "Wonders of Christmas",
  "1368367": "Alchemy Gold",
  "1940257": "Alibaba's Cave of Fortune",
  "1623475": "Anubis Wrath",
  "1340277": "Asgardian Rising",
  "31": "Baccarat Deluxe Card",
  "1418544": "Bakery Bonanza",
  "94": "Bali Vacation",
  "124": "Battleground Royale",
  "69": "Bikini Paradise",
  "108": "Buffalo Win",
  "125": "Butterfly Blossom",
  "71": "Caishen Wins",
  "100": "Candy Bonanza",
  "70": "Candy Burst",
  "54": "Captain's Bounty",
  "1682240": "Cash Mania",
  "1738001": "Chicky Run",
  "1666445": "Chocolate Deluxe",
  "80": "Circus Delight",
  "117": "Cocktail Nights",
  "1473388": "Cruise Royale",
  "1865521": "Dead Man's Riches",
  "121": "Destiny of Sun and Moon",
  "1372643": "Diner Delights",
  "1935269": "Diner Frenzy Spins",
  "1827457": "Doomsday Rampage",
  "48": "Double Fortune",
  "57": "Dragon Hatch",
  "1451122": "Dragon Hatch 2",
  "29": "Dragon Legend",
  "63": "Dragon Tiger Luck",
  "1897678": "Dragon's Treasure Quest",
  "79": "Dreams of Macau",
  "73": "Egypt's Book of Mystery",
  "114": "Emoji Riches",
  "44": "Emperor's Favour",
  "116": "Farm Invaders",
  "61": "Flirting Scholar",
  "1981965": "Forbidden Alchemy",
  "1555350": "Forge of Wealth",
  "1695365": "Fortune Dragon",
  "3": "Fortune Gods",
  "2100928": "Fortune Horse",
  "68": "Fortune Mouse",
  "98": "Fortune OX",
  "1543462": "Fortune Rabbit",
  "1879752": "Fortune Snake",
  "126": "Fortune Tiger",
  "1397455": "Fruity Candy",
  "2035783": "Funky Fortunez",
  "1778752": "Futebol Fever",
  "86": "Galactic Gems",
  "75": "Ganesha Fortune",
  "42": "Ganesha Gold",
  "122": "Garuda Gems",
  "1702123": "Geisha's Revenge",
  "2": "Gem Saviour",
  "62": "Gem Saviour Conquest",
  "38": "Gem Saviour Sword",
  "1671262": "Gemstones Gold",
  "85": "Genie's 3 Wishes",
  "1804577": "Graffiti Rush",
  "1903012": "Grimms' Bounty: Hansel & Gretel",
  "111": "Groundhog Harvest",
  "91": "Guardians of Ice & Fire",
  "1381200": "Hawaiian Tiki",
  "105": "Heist Stakes",
  "33": "Hip Hop Panda",
  "1": "Honey Trap of Diao Chan",
  "18": "Hood vs Wolf",
  "28": "Hotpot",
  "1850016": "Incan Wonders",
  "1950910": "Inferno Mayhem",
  "97": "Jack Frost's Winter",
  "1834850": "Jack the Giant Hunter",
  "88": "Jewels of Prosperity",
  "50": "Journey to the Wealth",
  "40": "Jungle Delight",
  "110": "Jurassic Kingdom",
  "1881268": "Knockout Riches",
  "1929177": "Kraken Gold Rush",
  "34": "Legend of Hou Yi",
  "128": "Legend of Perseus",
  "107": "Legendary Monkey King",
  "60": "Leprechaun Riches",
  "1601012": "Lucky Clover Riches",
  "89": "Lucky Neko",
  "130": "Lucky Piggy",
  "1580541": "Mafia Mayhem",
  "65": "Mahjong Ways",
  "74": "Mahjong Ways 2",
  "1971587": "Majestic Empire",
  "95": "Majestic Treasures",
  "118": "Mask Carnival",
  "1997301": "Mayan Destiny",
  "7": "Medusa",
  "6": "Medusa II",
  "102": "Mermaid Riches",
  "1402846": "Midas Fortune",
  "35": "Mr. Hallow-Win",
  "1799745": "Mr. Treasure’s Fortune",
  "64": "Muay Thai Champion",
  "1755623": "Museum Mystery",
  "1717688": "Mystic Potion",
  "1432733": "Mystical Spirits",
  "1849515": "Mythical Guardians",
  "1529867": "Ninja Raccoon Frenzy",
  "59": "Ninja vs Samurai",
  "1815268": "Oishi Delights",
  "93": "Opera Dynasty",
  "112": "Oriental Prosperity",
  "2024510": "Perfect Strike",
  "1964781": "Pharaoh Royals",
  "82": "Phoenix Rises",
  "39": "Piggy Gold",
  "1492288": "Pinata Wins",
  "25": "Plushie Frenzy",
  "2009635": "Poker Kingdom Win",
  "1312883": "Prosperity Fortune Tree",
  "36": "Prosperity Lion",
  "84": "Queen of Bounty",
  "113": "Raider Jane's Crypt of Fortune",
  "1420892": "Rave Party Fever",
  "20": "Reel Love",
  "1786529": "Rio Fantasia",
  "123": "Rooster Rumble",
  "1594259": "Safari Wilds",
  "37": "Santa's Gift Rush",
  "90": "Secrets of Cleopatra",
  "67": "Shaolin Soccer",
  "1648578": "Shark Bounty",
  "2012025": "Skylight Wonders",
  "1448762": "Songkran Splash",
  "127": "Speed Winner",
  "119": "Spirited Wonders",
  "1513328": "Super Golf Drive",
  "115": "Supermarket Spree",
  "109": "Sushi Oishi",
  "41": "Symbols of Egypt",
  "92": "Thai River Wonders",
  "53": "The Great Icescape",
  "120": "The Queen's Banquet",
  "1727711": "Three Crazy Piggies",
  "43": "Three Monkeys",
  "1338274": "Totem Wonders",
  "87": "Treasures of Aztec",
  "26": "Tree of Fortune",
  "1655268": "Tsar Treasures",
  "1489936": "Ultimate Striker",
  "58": "Vampire's Charm",
  "106": "Ways of the Qilin",
  "1615454": "Werewolf's Hunt",
  "1508783": "Wild Ape #3258",
  "104": "Wild Bandito",
  "135": "Wild Bounty Showdown",
  "132": "Wild Coaster",
  "83": "Wild Fireworks",
  "1568554": "Wild Heist Cashout",
  "129": "Win Win Fish Prawn Crab",
  "24": "Win Win Won",
  "1747549": "Wings of Iguazu",
  "17": "Wizdom Wonders",
  "1760238": "Yakuza Honor",
  "1635221": "Zombie Outbreak",
  "400041209": "100 Lucky Bell",
  "400041206": "20 Hot Bar",
  "400041203": "20 Lucky Bell",
  "555573843": "20 Royal Hot Golden Coin",
  "400041207": "40 Hot Bar",
  "400041208": "40 Hot Bar Extra",
  "400041204": "40 Lucky Bell",
  "555574051": "40 Money Tree Lucky Coin",
  "555573867": "40 Royal Hot Lucky Coin",
  "500001017": "777 Triple Sevens",
  "420030838": "Age of Vikings",
  "420030878": "Akn of Providence",
  "500008678": "Alpaca Pays",
  "555558820": "Andar Bahar Extra",
  "420018120": "Black Booze",
  "400041200": "Blazing Hot",
  "500010031": "Bon Bon",
  "441450570": "Book of Sherlock",
  "555572038": "Cavalo de Fogo Fortune",
  "555570411": "Chicky Choice",
  "500010297": "Color Hunt",
  "555572961": "Corrida Rica",
  "400041563": "Crazy Poki",
  "426639335": "Crazy Poki Boo",
  "400041201": "Diamond Flash",
  "500006666": "Diamond Flash Buy Bonus",
  "400040615": "Diamond Fruits",
  "400041565": "Diamond Phantom",
  "420014055": "Era of Dragons",
  "500000422": "Eye on the Money",
  "420030043": "Fast Fruits",
  "420019184": "FastMaster",
  "426635140": "Fiery Fruits More Spins",
  "500009026": "Fiery Fruits Sixfold",
  "441450571": "Fiesta",
  "420014054": "Flaming Fruit",
  "420014081": "Flaming Phoenix",
  "500008677": "Fortune Crash",
  "426639191": "Fortune Panda",
  "400041558": "Frozen Fruits",
  "555570327": "Fruit X",
  "420014080": "FruitBall",
  "555573985": "Genie Fortune",
  "420013999": "Goddesses of Zeus",
  "420014074": "Gold of Egypt",
  "400041564": "Happy Easter",
  "400041559": "Happy Valentines Day",
  "420015578": "Ho Ho Ho",
  "500011228": "Holi Fest",
  "420016823": "Hot Angels",
  "400041205": "Hot Bar",
  "400041561": "Hot Muchacho",
  "400041553": "Huga Chaga",
  "420016193": "Incredible Genie",
  "420015509": "Jacks or Better",
  "500043624": "Jaguar Dojo",
  "420031957": "King Craft: Menomin",
  "555559436": "Lady Monopz",
  "500007825": "Lion's Legacy",
  "400041214": "Los Apaches",
  "420014073": "Los Toros",
  "400041550": "Lost Treasure",
  "426636898": "Lucky Clover",
  "400041210": "Lucky Jungle",
  "400041211": "Lucky Jungle 1024",
  "400041562": "Lucky Patrick's Day",
  "420014050": "Lucky Smile",
  "555573713": "Macaco Millionario",
  "420030769": "Magic Time",
  "400041215": "Magic Treasures of Egypt",
  "555570959": "Master Raccoon",
  "555574796": "Matatu Juu",
  "426636516": "Mega Diamond",
  "400041556": "Mega Joker",
  "500009794": "Mega Wheel",
  "420030501": "Milky Farm",
  "420031262": "Milky Farm: Buy Feature",
  "555574023": "Money Tree",
  "555572771": "Moonlight Angel",
  "420032679": "Mr. First Lucky Wheel",
  "400040614": "Multi Fruit",
  "500009236": "Nemrut",
  "555559124": "Night Wolf",
  "400041212": "Novel of Alexander",
  "400041555": "Octopus Life",
  "500009689": "Paradise Beach",
  "426636162": "Pirate Fortune",
  "420014079": "Poki Wild",
  "420014063": "Richy Panda",
  "500008676": "Rico DJ",
  "426639318": "Rico Gorila",
  "500008675": "Rico Rabbit",
  "555573933": "Rico Rhino",
  "500043293": "Rico Tucano",
  "420018947": "Ronin",
  "400040613": "Roulette",
  "426633950": "Royal Flash",
  "500007824": "Royal Flash Buy Bonus",
  "426639194": "Spinosaurus",
  "400041213": "Sultans tale",
  "426639421": "Sumo Baby",
  "500043444": "Tappy Bird",
  "420014069": "Temple of Heroes",
  "420030430": "The Power of Kitsune",
  "426637067": "Time Travelers Hacivat and Karagoz",
  "400041202": "Ultra Hot",
  "400041552": "Ultra Wheel",
  "42001402": "Vikings Mystery",
  "426633712": "White Mustang",
  "420018238": "Wild Queen",
  "426634311": "Wild Shamrock",
  "420019823": "Wukong",
  "426639563": "YO Dragon",
  "400041551": "Yummy",
  "400041554": "Yummy: Trick or Treat",
  "40003124": "108 - Baccarat D",
  "40003322": "108 - Baccarat D No Commission",
  "40003123": "108 - Baccarat E",
  "40003321": "108 - Baccarat E No Commission",
  "40003325": "108 - Baccarat F",
  "40003326": "108 - Baccarat F No Commission",
  "40003102": "108 - Baccarat FTV",
  "40003331": "108 - Baccarat Filipino A",
  "40003332": "108 - Baccarat Filipino A No Commission",
  "40003329": "108 - Baccarat Filipino B",
  "40003330": "108 - Baccarat Filipino B No Commission",
  "40003327": "108 - Baccarat G",
  "40003328": "108 - Baccarat G No Commission",
  "40003122": "108 - Baccarat Korean",
  "40003323": "108 - Baccarat Korean No Commission",
  "400040313": "110 - Auto Roulette Auto Aurum",
  "3001055": "110 - Auto Roulette Auto Speed",
  "400040311": "110 - Auto Roulette Auto Speed Aurum",
  "420019585": "110 - Auto Roulette Luxe",
  "420019586": "110 - Auto Roulette Luxe Aurum",
  "40003094": "110 - Roulette A",
  "400040312": "110 - Roulette A Aurum",
  "40003105": "110 - Roulette B",
  "400040314": "110 - Roulette B Aurum",
  "400040781": "110 - Roulette Brasileira",
  "400040782": "110 - Roulette Brasileira Aurum",
  "40003106": "110 - Roulette C",
  "400040315": "110 - Roulette C Aurum",
  "40003107": "110 - Roulette D",
  "400040316": "110 - Roulette D Aurum",
  "400040792": "110 - Roulette Deluxe",
  "400040793": "110 - Roulette Deluxe Aurum",
  "400040786": "110 - Roulette Eclipse",
  "400040787": "110 - Roulette Eclipse Aurum",
  "40003139": "110 - Roulette F",
  "400040319": "110 - Roulette F Aurum",
  "40003099": "110 - Roulette FTV",
  "400040317": "110 - Roulette FTV Aurum",
  "400040621": "110 - Roulette PopOK",
  "400040629": "110 - Roulette PopOK Aurum",
  "400040638": "110 - Roulette Speed",
  "400040640": "110 - Roulette Speed Aurum",
  "400040329": "110 - Roulette VIP Aurum",
  "40003095": "113 - Bet On Poker",
  "400031662": "114 - Russian Poker A",
  "400040783": "114 - Russian Poker Eclipse",
  "400032365": "118 - Keno Keno Live",
  "400040573": "122 - Sic Bo A",
  "400040639": "122 - Sic Bo A Aurum",
  "40003126": "123 - Baccarat Classic",
  "40003097": "125 - Dragon Tiger A",
  "40003098": "126 - No Commission Baccarat A",
  "420019575": "126 - No Commission Baccarat B",
  "420019576": "126 - No Commission Baccarat C",
  "10412123": "130 - Switch BlackJack 4 A",
  "10412124": "130 - Switch BlackJack 4 C",
  "400031893": "131 - Casino Holdem A",
  "400040784": "131 - Casino Holdem Eclipse",
  "400040324": "133 - Swift Roulette 8 IN ONE",
  "40004107": "140 - Free Bet BJ CREED A",
  "40004108": "140 - Free Bet BJ CREED B",
  "40004111": "140 - Free Bet BJ FIESTA",
  "40004106": "140 - Free Bet BJ Vision F",
  "400031659": "142 - Richie Roulette",
  "420016141": "143 - Cashout Blackjack",
  "42001611": "144 - Andar Bahar",
  "420016100": "145 - Speed Blackjack A",
  "42001610": "145 - Speed Blackjack B",
  "550028": "145 - Speed Blackjack Brazilian A",
  "420016101": "145 - Speed Blackjack C",
  "420016102": "145 - Speed Blackjack D",
  "550027": "147 - TeenPatti A",
  "10412155": "148 - BlackJack Arabic A",
  "10412156": "148 - BlackJack Arabic B",
  "10412146": "148 - BlackJack Armenian A",
  "10412147": "148 - BlackJack Armenian B",
  "10412139": "148 - BlackJack Atrium A",
  "10412140": "148 - BlackJack Atrium B",
  "10412157": "148 - BlackJack Brazilian A",
  "10412158": "148 - BlackJack Brazilian B",
  "400040794": "148 - BlackJack Brazilian C",
  "10412126": "148 - BlackJack Creed A",
  "10412127": "148 - BlackJack Creed B",
  "10412128": "148 - BlackJack Creed C",
  "10412129": "148 - BlackJack Creed D",
  "10412130": "148 - BlackJack Creed E",
  "10412131": "148 - BlackJack Creed F",
  "10412132": "148 - BlackJack Creed G",
  "40003374": "148 - BlackJack Creed H",
  "40003373": "148 - BlackJack Creed I",
  "10412133": "148 - BlackJack Creed J",
  "10412134": "148 - BlackJack Creed K",
  "10412135": "148 - BlackJack Creed L",
  "10412136": "148 - BlackJack Creed M",
  "10412137": "148 - BlackJack Creed N",
  "10412138": "148 - BlackJack Creed O",
  "420019583": "148 - BlackJack Creed P",
  "10412165": "148 - BlackJack Eclipse",
  "10412161": "148 - BlackJack FTV",
  "10412162": "148 - BlackJack FTV VIP",
  "10412159": "148 - BlackJack Fiesta",
  "10412148": "148 - BlackJack Persian A",
  "10412149": "148 - BlackJack Persian B",
  "10412150": "148 - BlackJack Persian C",
  "10412151": "148 - BlackJack Persian D",
  "10412141": "148 - BlackJack Premium",
  "10412144": "148 - BlackJack Russian A",
  "10412145": "148 - BlackJack Russian B",
  "10412154": "148 - BlackJack Turkish A",
  "10412153": "148 - BlackJack Turkish B",
  "10412152": "148 - BlackJack Turkish C",
  "10412142": "148 - BlackJack VIP A",
  "10412143": "148 - BlackJack VIP B",
  "40003375": "148 - BlackJack Vision A",
  "40003333": "149 - FreeBet BlackJack Brazilian A",
  "12124582": "149 - FreeBet BlackJack CREED C",
  "40003103": "Auto Roulette",
  "12124581": "BlackJack Free Bet BJ CREED B",
  "10412180": "BlackJack VIP C",
  "10412160": "BlackJack Vision D",
  "12124580": "Free Bet BlackJack CREED A",
  "10412181": "FreeBet BlackJack Turkish B",
  "10412179": "FreeBet BlackJack VIP A",
  "400032371": "Kickoff Roulette",
  "4400910": "Richie Fruits Roulette",
  "400032367": "Richie Wheel",
  "400040666": "Road to Eldorado",
  "400032362": "Roulette Aurum",
  "400032361": "Roulette Aurum ID",
  "40004120": "Roulette Vision VIP",
  "500010057": "100 Burning Blaze Fortune Chest",
  "420033722": "100 Hot Seven",
  "500022232": "100 Super Blaze: Fortune Chest",
  "500009875": "20 Dazzling Fire Fortune Chest",
  "420032499": "20 Hot Seven",
  "500043403": "40 Burning Blaze 6 Reels Fortune Chest",
  "500009401": "40 Burning Blaze Fortune Chest",
  "420032500": "40 Hot Seven",
  "500009652": "40 Super Blaze Fortune Chest",
  "500000674": "Aviabet",
  "141433": "Big City Bank",
  "33060323": "Big City Cars",
  "334": "Big Hilo",
  "33060327": "Blast",
  "500000425": "Carnival Queens",
  "141426": "CatchMe",
  "426634065": "Champions Cup",
  "500009650": "ChartX",
  "426640044": "Christmas Tree",
  "420032501": "Christmas spins",
  "141414": "Color Wheel /x50",
  "33060328": "Crash",
  "420016144": "Crazy Mummy",
  "33060325": "Crazy Worm",
  "500009054": "Dazzling Crown",
  "500010277": "Dazzling Crown Fortune Chest",
  "500022231": "Dazzling Fire Fortune Chest",
  "141418": "Dice",
  "420016145": "Dogo Fortune",
  "420018582": "Drag Racing",
  "33060322": "Drago Flame",
  "141425": "DreamWheel",
  "426634127": "Extra King",
  "426634129": "Extra King 100",
  "426634128": "Extra King 40",
  "420030656": "Fast Flip",
  "141429": "Fast Trade",
  "141422": "Fighter xXx",
  "141416": "Fishing",
  "500043612": "Franken Alive",
  "420031708": "Fruity clover 100",
  "420019858": "Fruity clover 20",
  "420019859": "Fruity clover 40",
  "420031707": "Fruity clover 5",
  "500000948": "Gates Of Power",
  "420031709": "Golden Tree",
  "420032821": "Golden Tree 100",
  "420032820": "Golden Tree 40",
  "500008078": "Golden Tree:Buy Bonus",
  "420033335": "Gravity",
  "426639192": "Hallo win",
  "420032128": "Honey Money",
  "420031607": "Hot Cricket",
  "420030714": "Inner eye",
  "420019282": "Jogo Do Bicho",
  "33060321": "Jumbo Diamond",
  "420015425": "Keno",
  "420018888": "Keno Pro 10",
  "420018887": "Keno Pro 8",
  "141415": "MagicDice",
  "420018583": "Marble Racing",
  "500008488": "Mega Plinko",
  "420016146": "Mexicano",
  "141413": "Monti",
  "33060314": "OddBall",
  "141419": "Pascal",
  "420031706": "Pumpkin payday",
  "161617": "Shumba",
  "420032497": "Spicy Seven",
  "420032498": "Spicy Seven 20",
  "420015499": "Striker",
  "500000728": "The Golden Egg",
  "420030269": "The time",
  "420016327": "Touch me",
  "500009872": "Ultra Stars",
  "420018581": "Virtual Cycling",
  "420018576": "Virtual Football",
  "420018577": "Virtual Football League",
  "420018580": "Virtual Greyhounds",
  "420018579": "Virtual Horse Racing",
  "420018578": "Virtual Penalty",
  "420018575": "Virtual Tennis",
  "500008451": "Wheel of Chance",
  "33060320": "Wild Clubs",
  "420019257": "Wild Weed",
  "1400": "2 Wild 2 Die™",
  "2128": "3 Arcane Cauldrons Hold And Win",
  "1707": "8-Bit Quest",
  "1598": "Age Of Seth",
  "1756": "Aiko and the Wind Spirit",
  "1885": "Alchemist Wonders",
  "1201": "Alpha Eagle",
  "1655": "Amazing Miceketeers",
  "1596": "Ancient Paws",
  "2130": "Arc Lord",
  "1977": "Army of Ares",
  "1859": "Astro Rumble",
  "2126": "Avalanche",
  "1066": "Aztec Twist",
  "1446": "Baccarat",
  "1061": "Balloons",
  "1944": "Banana Farm",
  "1506": "Barrel Bonanza",
  "1928": "Bash Bros",
  "1426": "Beam Boys™",
  "1279": "Beast Below",
  "1936": "Belle the Blade Hunter",
  "1356": "Benny the Beer",
  "1412": "Blade Master",
  "1664": "Blaze Buddies",
  "1382": "Blocks",
  "1251": "Bloodthirst",
  "1213": "Book of Time",
  "1783": "Booze Bash",
  "1189": "Born Wild",
  "1422": "Bouncy Bombs",
  "1205": "Break Bones",
  "1050": "Break the Ice",
  "1176": "Buffalo Stack'n'Sync",
  "1799": "Bullets and Bounty",
  "2017": "Bullride Loot",
  "2067": "Captain Coil",
  "1055": "Cash Compass",
  "1456": "Cash Crew",
  "1065": "Cash Pool",
  "1099": "Cash Quest",
  "1057": "Cash Scratch",
  "1025": "Cash Vault II",
  "1059": "Chaos Crew",
  "1867": "Chaos Crew 3",
  "1352": "Chaos Crew II",
  "1092": "Chaos Crew Scratch",
  "1865": "Charm of the Dragon",
  "1659": "Chicken Man",
  "1722": "Chocolate Rocket",
  "2019": "Circle Of Life™",
  "1602": "Cloud Princess",
  "1576": "Clover Club",
  "1842": "Club Cabana",
  "1653": "Clumsy Cowboys",
  "1918": "Coconut Chaos",
  "1388": "Colors",
  "1290": "Commander of Trident",
  "1720": "Coop Clash",
  "1062": "Crazy Donuts",
  "2087": "Crowned Corners",
  "1709": "Crystal Robot Backseat Gaming",
  "1048": "Cubes",
  "1069": "Cubes 2",
  "1705": "Culinary Clash",
  "1434": "Cursed Crypt",
  "1263": "Cursed Seas",
  "1046": "Cut the Grass",
  "1686": "Danny Dollar",
  "2143": "Dark Spiral",
  "1392": "Dark Summoning",
  "1442": "Dawn of Kings™",
  "1889": "Dead Headz",
  "2000": "Deal With Death",
  "1348": "Densho",
  "1630": "Desert Temple",
  "2096": "Diamond Mole",
  "1022": "Diamond Rush",
  "1590": "Dice",
  "1490": "Divine Drop",
  "1530": "Donny Dough",
  "2004": "Donny and Danny™",
  "1608": "Donut Division™",
  "1172": "Dork Unit",
  "1173": "Dork Unit",
  "1430": "Dorks of the Deep™",
  "1145": "Double Rainbow",
  "1144": "Double Rainbow",
  "1034": "Double Salary - 1 Year",
  "1360": "Dragon's Domain",
  "1018": "Dream Car SUV",
  "1019": "Dream Car Speed",
  "1017": "Dream Car Urban",
  "1315": "Drop'em",
  "1620": "Duel at Dawn™",
  "2190": "Dusk Princess",
  "2082": "Dynasty of Death™",
  "1082": "Eggstra Cash",
  "1638": "Empress of the Shadows",
  "2185": "Epic Bullets & Bounty",
  "2148": "Eternal Duel™",
  "1679": "Eternal Nile",
  "2011": "Evil Dozen",
  "1570": "Evil Eyes",
  "1006": "Express 200 Scratch",
  "1740": "Eye of Medusa",
  "1344": "Eye of the Panda",
  "1368": "FIreborn",
  "1693": "FRKN Bananas™",
  "2023": "Farmhouse",
  "1271": "Fear the Dark",
  "1372": "Feel the Beat™",
  "1715": "Fighter Pit™",
  "1640": "Fire My Laser™",
  "1408": "Fist of Destruction",
  "1079": "Football Scratch",
  "1942": "Forbidden Fury",
  "1185": "Forest Fortune",
  "1225": "Frank's Farm",
  "1229": "Fred's Food Truck",
  "1051": "Frogs Scratch",
  "1197": "Fruit Duel",
  "1081": "Frutz",
  "1600": "Fury and Fortune",
  "1879": "Gem Ghosts",
  "1580": "Get The Cheese",
  "2113": "Ghostly Hallows",
  "1807": "Gladius: Death Or Glory",
  "1064": "Go Panda",
  "1991": "Godly Gains",
  "1052": "Gold Coins",
  "1020": "Gold Rush",
  "1933": "Grinning Harvest",
  "1221": "Gronk’s Gems",
  "2026": "Grunt Gold",
  "1901": "Halls of Odin",
  "1164": "Hand Of Anubis",
  "1014": "Happy Scratch",
  "1140": "Harvest Wilds",
  "1039": "Haunted Circus",
  "1331": "Hi Lo",
  "1528": "Holy heist",
  "1815": "Home of Thor",
  "1809": "Hoot Shot The Sheriff",
  "1091": "Hop'n'Pop",
  "2062": "Hot Ross™",
  "1666": "Hounds of Hell™",
  "1168": "ITERO",
  "1364": "Immortal Desire",
  "1724": "Infernus",
  "1791": "Invictus",
  "1031": "Its bananas!",
  "1606": "Jawesome Pirates",
  "1946": "Jaws of Justice",
  "1452": "Jelly Slice",
  "1117": "Joker Bombs",
  "2030": "Jumpasaurs!",
  "1526": "Junkyard Kings",
  "2089": "Junkyard Kings 2",
  "1494": "Keep 'Em",
  "1259": "Keep 'em Cool",
  "1127": "King Carrot",
  "1010": "King Treasure",
  "1438": "Klowns",
  "1053": "Koi Cash",
  "1072": "LOVE is all you need",
  "1309": "Le Bandit",
  "2195": "Le Bunny",
  "1924": "Le Cowboy",
  "2229": "Le Digger™",
  "2057": "Le Fisherman™",
  "1787": "Le King™",
  "1562": "Le Pharaoh",
  "1965": "Le Santa",
  "1689": "Le Viking",
  "1830": "Le Zeus",
  "2098": "Lemur Levels",
  "1070": "Let It Snow",
  "1460": "Life and Death™",
  "1624": "Limbo",
  "1337": "Lines",
  "1255": "Lord Venom",
  "1588": "Lucky Multifruit",
  "1028": "Lucky Numbers x12",
  "1029": "Lucky Numbers x16",
  "1030": "Lucky Numbers x20",
  "1027": "Lucky Numbers x8",
  "1016": "Lucky Scratch",
  "1023": "Lucky Shot",
  "1376": "Mafia Clash",
  "1247": "Magic Piggy",
  "2108": "Marlin Masters: Atlantis",
  "1811": "Marlin Masters: The Big Haul",
  "1681": "Marlin Masters™",
  "1275": "Mayan Stackways",
  "1414": "Merlin's Alchemy",
  "1657": "Merlin’s Mania",
  "1824": "Miami Mayhem",
  "1049": "Miami Multiplier",
  "2136": "Midnight Mirage",
  "1305": "Mighty Masks",
  "1124": "Mines",
  "1883": "Mirage City",
  "1969": "Miss Candy’s Sweet Escape",
  "1578": "Monkey Frenzy",
  "2134": "Monkey Frenzy 2: Boss is Here!",
  "1844": "Mortal Oath",
  "2219": "Munchy Milo™",
  "1038": "My Lucky Number",
  "1896": "Mystery Bats",
  "1071": "Mystery Motel",
  "1995": "Neon Frames",
  "1584": "Octo Attack",
  "1568": "Old Gun",
  "1043": "OmNom",
  "1474": "Orb of Destiny",
  "1088": "Outlaws Inc",
  "1083": "Outlaws Inc",
  "1920": "Paper Biker",
  "2120": "Peek & Pounce",
  "2028": "Penguin Royale",
  "1675": "Phoenix DuelReels",
  "1566": "Pickle Bandits",
  "1498": "Piggy Cluster Hun",
  "1552": "Pirate Bonanza",
  "1863": "Pirate Bonanza 2",
  "1294": "Plinko",
  "2015": "Power Pops",
  "2234": "Power of Ten",
  "2115": "Pray For Six™",
  "1736": "Pray for Three",
  "1013": "Prince Treasure",
  "1217": "Pug Life",
  "1828": "PyroFox",
  "1011": "Queen Treasure",
  "1233": "RIP City",
  "1732": "Rad Maxx",
  "1817": "Rainbow Princess",
  "1063": "Rat Riches",
  "1728": "Reign of Rome™",
  "1616": "Rise of Ymir",
  "1102": "Rocket Reels",
  "1268": "Ronin Stackways",
  "1209": "Rotten",
  "1021": "Ruby Rush",
  "1404": "Rusty & Curly™",
  "1004": "SCRATCH! Bronze",
  "1002": "SCRATCH! Gold",
  "1003": "SCRATCH! Silver",
  "2243": "Sand and Ashes™",
  "1008": "Scratchy",
  "1009": "Scratchy Big",
  "1007": "Scratchy Mini",
  "1047": "Scratch’em",
  "1538": "Shadow Strike",
  "1540": "Shadow Treasure",
  "1554": "Shaolin Master™",
  "1045": "Shave the Beard",
  "1060": "Shave the Sheep",
  "1534": "SixSixSix",
  "1482": "Slayers Inc",
  "1981": "Smoking Dragon",
  "1109": "Snow Scratcher",
  "1558": "Snow Slingers™",
  "1524": "Space Zoo",
  "1938": "Spear of Athena",
  "1632": "Speed Crash",
  "1748": "Spinman™",
  "1108": "Spooky Scary Scratchy",
  "1084": "Stack 'Em",
  "1139": "Stack ‘em Scratch",
  "1871": "Steamrunners",
  "1042": "Stick 'em",
  "1875": "Stormborn",
  "1243": "Stormforged",
  "1821": "Street Knockout",
  "1697": "Strength of Hercules™",
  "1861": "Sugar Park",
  "1180": "Summer Scratch",
  "1914": "Sun Princess",
  "1651": "Super Twins",
  "2138": "Superstar Sevens™",
  "1478": "Tai The Toad",
  "1113": "Tasty Treats",
  "1096": "Tasty Treats",
  "1237": "Temple of Torment",
  "1089": "The Big One",
  "1054": "The Bomb",
  "1135": "The Bowery Boys",
  "1803": "The Count",
  "1472": "The Cursed King",
  "1726": "The Library",
  "1922": "The Lost Book of Mummy's Curse",
  "1897": "The Luxe",
  "1795": "The Luxe H.V.",
  "1080": "The Perfect Scratch",
  "1058": "The Respinners",
  "1891": "The Wildwood Curse",
  "1993": "Through the Fire",
  "2069": "Thurisaz",
  "1744": "Tiger Legends",
  "1110": "Tiger Scratch",
  "1181": "Time Spinners",
  "1087": "Toshi Video Club",
  "1971": "Toshi Ways Club™",
  "2013": "Totem Poles",
  "1416": "Twenty-One",
  "1514": "Twisted Labs",
  "1760": "Ultimate Slot of America",
  "1193": "Undead Fortune",
  "1662": "Valhalla: Wild Winter",
  "1341": "Vending Machine",
  "1067": "Wanted Dead or a Wild",
  "1131": "Warrior Ways",
  "1323": "Wheel",
  "1512": "Wild Dojo Strike",
  "1612": "Wings of Horus",
  "1711": "Wishbringer™",
  "1396": "Xmas Drop",
  "1093": "Xpander",
  "1094": "Xpander",
  "1508": "Ze Zeus",
  "2077": "Zeus Ze Zecond",
  "5174": "10 Alebrijes Eternal",
  "533": "10 Burning Heart",
  "491": "10 Power Hot",
  "5063": "100 Art of Gold Dice Edition",
  "5120": "100 Bulky Dice",
  "5089": "100 Bulky Fruits Buy Bonus",
  "8005": "100 Bulky Fruits Golden Coins Link",
  "5181": "100 Burning Hot Buy Bonus",
  "847": "100 Cats",
  "893": "100 Dice",
  "610": "100 Extra Crown",
  "630": "100 Extra Crown 6 reels",
  "5085": "100 Extra Crown Buy Bonus",
  "470": "100 Golden Coins",
  "637": "100 Golden Coins Dice Edition",
  "5170": "100 Golden Coins: Reel Fishing",
  "478": "100 Power Hot Dice Edition",
  "8017": "100 Power Hot Dice Edition Golden Coins Link",
  "8003": "100 Power Hot Golden Coins Link",
  "534": "100 Super Dice",
  "882": "2 Dragons",
  "5179": "20 Burning Hot Buy Bonus",
  "497": "20 Diamond Plus",
  "854": "20 Diamonds",
  "5083": "20 Extra Crown Buy Bonus",
  "8007": "20 Glossy Hot Golden Coins Link",
  "418": "20 Golden Coins Dice Edition",
  "5168": "20 Golden Coins: Reel Fishing",
  "843": "20 Super Dice",
  "803": "20 Super Hot",
  "629": "20 Wild Goals",
  "5069": "20 Wild Goals Dice",
  "5013": "20 aztec coins",
  "409": "27 Dice",
  "5012": "27 Wild Shots",
  "5075": "27 Wild Shots Dice",
  "581": "30 Summer Bliss",
  "903": "4 of a Kind Bonus Poker",
  "5284": "40 Alebrijes Eternal",
  "5064": "40 Art of Gold 6 Reels Dice Edition",
  "5113": "40 Art of Gold Dice Edition",
  "8020": "40 Art of Gold Dice Edition Golden Coins Link",
  "638": "40 Bulky Dice",
  "639": "40 Bulky Dice 6 Reels",
  "8016": "40 Bulky Dice Golden Coins Link",
  "445": "40 Bulky Fruits 6 Reels",
  "5088": "40 Bulky Fruits Buy Bonus",
  "8004": "40 Bulky Fruits Golden Coins Link",
  "5180": "40 Burning Hot Buy Bonus",
  "498": "40 Diamond Plus",
  "607": "40 Extra Crown 40 Lines",
  "5084": "40 Extra Crown Buy Bonus",
  "8019": "40 Extra Crown Classic Dice Golden Coins Link",
  "8001": "40 Extra Crown Golden Coins Link",
  "8010": "40 Extra Crown Triple Boost Golden Coins Link",
  "5109": "40 Glossy Hot",
  "636": "40 Golden Coins: Dice Edition 40 Lines",
  "5169": "40 Golden Coins: Reel Fishing",
  "5115": "40 Lucky Wilds Hot",
  "8011": "40 Lucky Wilds Hot Golden Coins Link",
  "408": "40 Luxury Dice",
  "5117": "40 Mystic Gem",
  "8002": "40 Mystic Gem Golden Coins Link",
  "8000": "40 Power Hot - Golden Coins Link",
  "8015": "40 Power Hot Dice Edition Golden Coins Link",
  "8008": "40 Power Hot Triple Boost Golden Coins Link",
  "844": "40 Super Dice",
  "804": "40 Super Hot",
  "531": "40 Ultra Respin",
  "5094": "40 Vampire Beast",
  "5108": "40 fruits & gold",
  "532": "5 Burning Heart",
  "810": "5 Dazzling Hot",
  "496": "5 Diamond Plus",
  "886": "5 Hot Dice",
  "879": "50 Horses",
  "480": "7 & Crystals",
  "5031": "7 Fire Dice",
  "812": "Age of Troy",
  "884": "Aloha Party",
  "808": "Amazing Amazonia",
  "859": "Amazons' Battle",
  "5043": "Ancient Coins",
  "627": "Art of Gold 6 Reels",
  "8006": "Art of Gold Golden Coins Link",
  "5014": "Asian Palace",
  "443": "Aztec Forest",
  "5074": "Bier O'Meter Dice",
  "814": "Blue Heart",
  "400": "Book of Dice",
  "826": "Book of Magic",
  "5016": "Book of Waka Waka",
  "589": "Brilliant Dice",
  "410": "Bulky Fruits",
  "5086": "Bulky Fruits Buy Bonus",
  "842": "Burning Dice",
  "5178": "Burning Hot Buy Bonus",
  "5172": "Cairo Dice",
  "5309": "Candy Palace 1000",
  "5092": "Candy Wheel",
  "506": "Caramel Hot",
  "5056": "Caramelo Sortudo",
  "5045": "Caramelo Sortudo - Crash Edition",
  "5218": "Cashybara Boxing Edition",
  "5038": "Cashybara Ski Edition",
  "850": "Casino Mania",
  "871": "Cats Royal",
  "829": "Circus Brilliant",
  "5054": "Clover Super Pot",
  "5090": "Cocktail Rush Buy Bonus",
  "487": "Cocktail Rush Easter Edition",
  "910": "Coin Gobbler",
  "5079": "Coin Gobbler Dice Edition",
  "5103": "Crazy Octopus",
  "611": "Crazy Red",
  "437": "Dancing Dead",
  "858": "Dark Queen",
  "824": "Dice & Roll",
  "5072": "Dice Deco Super Pot",
  "484": "Dice Vikings",
  "894": "Dice of Magic",
  "856": "Dice of Ra",
  "444": "Dice of Sherwood",
  "579": "Dorothys Fairyland",
  "888": "Dragon Hot",
  "508": "Dragon Reborn",
  "813": "Dragon Reels",
  "877": "Dragon Spirit",
  "11": "Dynamic European Roulette",
  "15": "Dynamic Roulette 120x",
  "447": "Easter Frog",
  "5005": "Easter Frog Dice",
  "588": "Egypt Dice",
  "998": "Egypt Quest Jackpot",
  "825": "Egypt Sky",
  "578": "Emperors Palace",
  "20201": "European Roulette",
  "446": "Extra Crown",
  "5082": "Extra Crown Classic Buy Bonus",
  "5070": "Extra Crown Classic Dice",
  "632": "Extra Crown Deluxe",
  "3400": "Extra Crown Deluxe Live",
  "857": "Extra Joker",
  "822": "Extra Stars",
  "406": "Extreme Dice",
  "880": "Extremely Hot",
  "5099": "Eye of Ra Roulette 2000x",
  "5214": "Falling Coins",
  "501": "Fast Money",
  "509": "Flaming Dice",
  "805": "Flaming Hot",
  "3150": "Football Thrill",
  "835": "Forest Band",
  "876": "Forest Tale",
  "820": "Fortune Spells",
  "853": "Frog Story",
  "417": "Fruits & Gold",
  "811": "Fruits Kingdom",
  "407": "Fruity Time",
  "823": "Game of Luck",
  "872": "Genius of Leonardo",
  "862": "Gold Dust",
  "8888": "Golden Coins Link Jackpot",
  "5118": "Golden Goal Roulette",
  "5161": "Golden Tiger",
  "817": "Grace of Cleopatra",
  "837": "Great Adventure",
  "864": "Great Empire",
  "416": "Greek Fortune",
  "833": "Halloween",
  "5215": "Hippo Splash",
  "866": "Hot & Cash",
  "5059": "Hot Deco Super Pot",
  "704": "Hot Keno",
  "5213": "Hot Racing",
  "867": "Ice Dice",
  "571": "Ice Valley",
  "841": "Imperial Wars",
  "865": "Inca Gold II",
  "503": "Jungle Adventure",
  "836": "Kangaroo Land",
  "846": "Kashmir Gold",
  "452": "Kemet's Treasures",
  "640": "Kemet’s Dice",
  "574": "Knights Heart",
  "5068": "Latin Heart Dice",
  "510": "Legendary Rome",
  "30": "Live Speed Roulette",
  "868": "Lucky & Wild",
  "881": "Lucky Buzz",
  "849": "Lucky Hot",
  "573": "Lucky Wood",
  "502": "Magellan",
  "830": "Majestic Forest",
  "898": "Mayan Spirit",
  "875": "More Dice & Roll",
  "869": "More Lucky & Wild",
  "5029": "Mystic Tiger",
  "577": "Mythical Treasure",
  "861": "Neon Dice",
  "839": "Ocean Rush",
  "848": "Oil Company II",
  "819": "Olympus Glory",
  "464": "Orient Story Deluxe",
  "5156": "Panda's Gold",
  "8036": "Panda's Gold Golden Coins Link",
  "852": "Penguin Style",
  "440": "Phoenix Star",
  "5121": "Phoenix Star Super Pot",
  "576": "Pin Up Queens",
  "5197": "Porko Collect Super Pot",
  "572": "Rainbow Luck",
  "840": "Rainbow Queen",
  "575": "Retro Cabaret",
  "889": "Retro Style",
  "899": "Rich World",
  "806": "Rise of RA",
  "860": "Rolling Dice",
  "5042": "Roman Coins",
  "504": "Route of Mexico",
  "883": "Royal Gardens",
  "809": "Royal Secrets",
  "892": "Savanna's Life",
  "828": "Secrets Of Alchemy",
  "463": "Secrets of Cairo",
  "831": "Shining Crown",
  "5000": "Shining Crown Buy Bonus",
  "47": "Showtime Roulette 500x",
  "895": "Spanish Passion",
  "5173": "Sparta Dice",
  "3104": "Speed Baccarat",
  "475": "Stoichkov#8",
  "855": "Summer Bliss",
  "897": "Super 20",
  "703": "Superb Keno",
  "845": "Supreme Dice",
  "821": "Supreme Hot",
  "test_walletId": "Test Game",
  "834": "The Explorers",
  "885": "The Great Egypt",
  "873": "The Secrets of London",
  "896": "The Story of Alexander",
  "580": "The Story of Alexander 2",
  "863": "The White Wolf",
  "507": "Thumbelina's Dream",
  "5196": "Triple Fortune Festival",
  "802": "Ultimate Hot",
  "5281": "VIP Saray Rulet",
  "461": "Vampire Beast",
  "5091": "Vampire Dice",
  "5100": "Vegas Gobbler LIVE",
  "832": "Venezia D'oro",
  "818": "Versailles Gold",
  "603": "Virtual Vegas Roulette 500x",
  "635": "Wenshi Lion",
  "5030": "Wild Fortune",
  "815": "Witches' Charm",
  "505": "Wonder Tree",
  "807": "Zodiac Wheel",
  "aviafly": "AviaFly",
  "aviafly-two": "AviaFly 2",
  "ballonix": "BallooniX",
  "bubbles": "Bubbles",
  "chicken-banana": "Chicken Banana",
  "chicken-coin": "Chicken Coin",
  "chicken-road": "Chicken Road",
  "chicken-road-two-bonus": "Chicken Road 2 Bonus",
  "chicken-road-two": "Chicken Road 2.0",
  "chicken-road-bonus": "Chicken Road Bonus",
  "chicken-road-gold": "Chicken Road Gold",
  "chicken-road-new-year": "Chicken Road Ice",
  "chicken-road-race": "Chicken Road Race",
  "chicken-road-vegas": "Chicken Road Vegas",
  "chicken-royal": "Chicken Royal",
  "chicken-shoot": "Chicken Shoot",
  "chicken-road-zombies": "Chicken vs Zombies",
  "crash": "Crash",
  "cricket-road": "Cricket Road",
  "cryptos": "Cryptos",
  "diver": "Diver",
  "new-double": "Double",
  "fish-boom": "Fish Boom",
  "fish-road-v1": "Fish Road",
  "forest-fortune-v1": "Forest Arrow",
  "goblin-tower": "Goblin-tower",
  "hamster-run": "Hamster Run",
  "hot-mines": "Hot-mines",
  "jogo-do-bicho": "Jogo Do Bicho",
  "x": "Joker Coin",
  "joker-poker": "Joker Poker",
  "joker-pyre": "Joker Pyre",
  "jumper": "Jumper",
  "limbo": "Limbo",
  "lucky-mines": "Lucky mines",
  "megablock": "MegaBlock",
  "mine-slot": "Mine Slot",
  "mine-slot-two": "Mine Slot 2",
  "platform-mines": "Mines",
  "new-hilo": "New Hilo",
  "penalty-unlimited": "Penalty Unlimited",
  "pengu-sport": "Pengu Sport",
  "peperoad": "Pepe Road",
  "plinko": "Plinko 1000",
  "plinko-aztec": "Plinko Aztec",
  "rabbit-road-inout": "Rabbit Road",
  "robo-dice": "Robo dice",
  "rock-paper-scissors": "Rock Paper Scissors",
  "roulette": "Roulette",
  "squid-game": "Squid Gamebler",
  "stairs": "Stairs",
  "sugar-daddy": "SugarDaddy",
  "keno": "Sweet Keno",
  "twist": "TWIST",
  "topo-mole": "Topo Mole",
  "tower": "Tower",
  "triple": "Triple",
  "twist-san-quentin": "Twist San Quentin",
  "twist-new-year": "Twist X-Mas",
  "wheel": "Wheel",
  "coinflip": "Сoinflip",
  "ThreeKingsScratch": "3 Kings Scratch",
  "acceptance:test": "Acceptance Test",
  "AliceWonderLuck": "Alice WonderLuck",
  "AlienFruits": "Alien Fruits",
  "AlienFruits2": "Alien Fruits 2",
  "AllLuckyClover": "All Lucky Clover",
  "AllLuckyClover100": "All Lucky Clover 100",
  "AllLuckyClover20": "All Lucky Clover 20",
  "AllLuckyClover40": "All Lucky Clover 40",
  "AllLuckyClover5": "All Lucky Clover 5",
  "AllStarFruits": "All-Star Fruits",
  "AlohaKingElvis": "Aloha King Elvis",
  "AlwaysUp": "Always Up!",
  "AlwaysUpX10000": "Always Up! x10000",
  "AmericanRoulette": "American Roulette",
  "ArrowSlot": "Arrow Slot",
  "Avalon": "Avalon: The Lost Kingdom",
  "Aviamasters": "Aviamasters",
  "Aviamasters2": "Aviamasters 2",
  "AviamastersXmas": "Aviamasters X-mas",
  "AztecClusters": "Aztec Clusters",
  "AztecMagic": "Aztec Magic",
  "AztecMagicBonanza": "Aztec Magic Bonanza",
  "AztecMagicDeluxe": "Aztec Magic Deluxe",
  "AztecMagicMegaways": "Aztec Magic Megaways",
  "Baccarat": "Baccarat",
  "BalloonMania": "Balloon Mania",
  "BeastBand": "Beast Band",
  "BeerBonanza": "Beer Bonanza",
  "BigAtlantisFrenzy": "Big Atlantis Frenzy",
  "BigTunaBonanza": "Big Boat Big Catch",
  "BlackbeardsBounty": "Blackbeard's Bounty",
  "BlackjackSurrender": "Blackjack Surrender",
  "BlingBlitzDiamondDrop": "Bling Blitz Diamond Drop",
  "BobsCoffeeShop": "Bobs Coffee Shop",
  "BonanzaBillion": "Bonanza Billion",
  "BonanzaBillionXtreme": "Bonanza Billion Xtreme",
  "BonanzaTrillion": "Bonanza Trillion",
  "BoneBonanza": "Bone Bonanza",
  "BookOfCats": "Book of Cats",
  "BookOfCatsMegaways": "Book of Cats Megaways",
  "BookOfKemet": "Book of Kemet",
  "BookOfPanda": "Book of Panda MEGAWAYS™",
  "BookOfPyramids": "Book of Pyramids",
  "BraveViking": "Brave Viking",
  "BurningChilli243": "Burning Chilli 243",
  "BurningChilliX": "Burning Chilli X",
  "CandyMonsta": "Candy Monsta",
  "CapymaniaGreen": "Capymania Green",
  "CapymaniaOrange": "Capymania Orange",
  "CapymaniaYellow": "Capymania Yellow",
  "CaribbeanPoker": "Caribbean Poker",
  "CarnivalBonanza": "Carnival Bonanza",
  "CasinoHoldem": "Casino Holdem",
  "CatsSoup": "Cat's Soup",
  "CatchTheGoldHoldAndWin": "Catch The Gold Hold & Win",
  "Catdiana": "Catdiana",
  "CherryFiesta": "Cherry Fiesta",
  "ChickenRush": "Chicken Rush",
  "ClassicMultihandBlackjack": "Classic Multihand Blackjack",
  "CloverBonanza": "Clover Bonanza",
  "CluckingHell": "Clucking Hell",
  "CrazyStarter": "Crazy Starter",
  "CrystalClusters": "Crystal Clusters",
  "DeepSea": "Deep Sea",
  "DerbyRush": "Derby Rush",
  "DesertTreasure": "Desert Treasure",
  "DiamondOfJungle": "Diamond of Jungle",
  "DiceBonanza": "Dice Bonanza",
  "DiceClash": "Dice Clash",
  "DiceMillion": "Dice Million",
  "DigDigDigger": "Dig Dig Digger",
  "DiscoParty": "Disco Party",
  "DivineQueenHeartOfIce": "Divine Queen: Heart of Ice",
  "DomnitorsTreasure": "Domnitor's Treasure",
  "Domnitors": "Domnitors",
  "DomnitorsDeluxe": "Domnitors Deluxe",
  "DoomsdaySaloon": "Doomsday Saloon",
  "DoubleExposure": "Double Exposure",
  "DragonAge": "Dragon Age Hold & Win",
  "DragonQueenMegaways": "Dragon Queen MEGAWAYS",
  "DragonsCrash": "Dragon's Crash",
  "DragonsGold100": "Dragon's Gold 100",
  "EasterHeist": "Easter Heist",
  "EasterPlinko": "Easter Plinko",
  "ElvisFrog": "Elvis Frog In Vegas",
  "ElvisFrogTrueways": "Elvis Frog TRUEWAYS™",
  "EuropeanRoulette": "European Roulette",
  "FaceOff": "Face Off",
  "FantasyPark": "Fantasy Park",
  "FiestaClusters": "Fiesta Clusters",
  "FireLightning": "Fire Lightning",
  "FishingClub": "Fishing Club",
  "FishingClub2": "Fishing Club 2",
  "FootballPlinko": "Football Plinko",
  "Forgotten": "Fortgotten",
  "FortunaTrueways": "Fortuna TRUEWAYS",
  "FortuneBells": "Fortune Bells",
  "FortuneRedPackets": "Fortune Red Packets",
  "FortuneSpin": "Fortune Spin",
  "FortyFruityMillion": "Forty Fruity Million",
  "FourLuckyClover": "Four Lucky Clover",
  "FourLuckyDiamonds": "Four Lucky Diamonds",
  "FrenchRoulette": "French Roulette",
  "FrozenFruit": "Frozen Fruit",
  "FruitMillion": "Fruit Million",
  "Gangsterz": "Gangsterz",
  "Gemhalla": "Gemhalla",
  "Gemza": "Gemza X-mas edition",
  "GiftRush": "Gift Rush",
  "GiftX": "Gift X",
  "GodOfWealthHoldAndWin": "God of Wealth Hold And Win",
  "GoldMagnate": "Gold Magnate",
  "GoldRushWithJohnny": "Gold Rush with Johnny Cash",
  "GoldOfMinos": "Gold of Minos",
  "GoldenAvalonHoldAndWin": "Golden Avalon Hold and Win",
  "GoldenPawHoldAndWin": "Golden Paw Hold & Win",
  "GoldenPinataHoldAndWin": "Golden Pinata Hold and Win",
  "GoldenPride": "Golden Pride",
  "GrandBuffaloHoldAndWin": "Grand Buffalo Hold and Win",
  "GrandMustang": "Grand Mustang",
  "HalloweenBonanza": "Halloween Bonanza",
  "HauntedReels": "Haunted Reels",
  "HawaiiCocktails": "Hawaii Cocktails",
  "HeadsTails": "Heads and Tails",
  "HeadsTailsXY": "Heads and Tails XY",
  "HeartOfTiki": "Heart of Tiki",
  "HelloEaster": "Hello Easter",
  "HiLoSwitch": "Hi-Lo Switch",
  "HitTheRoute": "Hit The Route",
  "HotChilliBells": "Hot Chilli Bells",
  "HotChilliBells100": "Hot Chilli Bells 100",
  "Hottest666": "Hottest 666",
  "IceScratch": "Ice Scratch",
  "IceScratchBronze": "Ice Scratch Bronze",
  "IceScratchGold": "Ice Scratch Gold",
  "IceScratchSilver": "Ice Scratch Silver",
  "InfinityPull": "Infinity Pull",
  "JewelBoom": "Jewel Boom Super Drop",
  "JogoDoBicho": "Jogo do Bicho",
  "JohnnyCash": "Johnny Cash",
  "JokerQueen": "Joker Queen",
  "JokerXLove": "Joker X Love",
  "JokersMillion": "Joker's Million",
  "JourneyFlirt": "Journey Flirt",
  "JungleQueen": "Jungle Queen",
  "KeepersOfTheSecret7rst": "Keepers Of The Secret",
  "KrakensHunger": "Kraken's Hunger",
  "LadyLuckyGun": "Lady Lucky Gun",
  "LuckyLadyMoon": "Lady Wolf Moon",
  "LuckyLadyMoonMegaways": "Lady Wolf Moon Megaways",
  "LetItRide": "Let it Ride",
  "Limbo": "Limbo XY",
  "LokiLoot": "Loki Loot",
  "LuckAndMagic": "Luck & Magic",
  "LuckAndMagicScratch": "Luck & Magic Scratch",
  "Lucky8MergeUp": "Lucky 8 Merge Up",
  "LuckyBlue": "Lucky Blue",
  "LuckyCrew": "Lucky Crew",
  "LuckyDamaMuerta": "Lucky Dama Muerta",
  "LuckyDragonMultiDiceX": "Lucky Dragon MultiDice X",
  "LuckyDucky": "Lucky Ducky",
  "LuckyFarmBonanza": "Lucky Farm Bonanza",
  "LuckyLadyClover": "Lucky Ladys Clover",
  "LuckyLagerX9990": "Lucky Lager x9990",
  "LuckyLu": "Lucky Lu",
  "LuckyOak": "Lucky Oak",
  "LuckySweets": "Lucky Sweets",
  "MagicMummyMegaways": "Magic Mummy Megaways",
  "Maneki88Fortunes": "Maneki 88 Fortunes",
  "Maneki88Gold": "Maneki 88 Gold",
  "MechanicalClover": "Mechanical Clover",
  "MechanicalOrange": "Mechanical Orange",
  "MergeUp": "Merge Up",
  "MergeUp2": "Merge Up 2",
  "MiceAndMagic": "Mice & Magic Wonder Spin",
  "MineGems": "Mine Gems",
  "Minesweeper": "Minesweeper",
  "MinesweeperXY": "Minesweeper XY",
  "MissCherryFruits": "Miss Cherry Fruits",
  "MissCherryFruitsJackpotparty": "Miss Cherry Fruits Jackpot Party",
  "MonsterHunt": "Monster Hunt",
  "MultihandBlackjack": "Multihand Blackjack",
  "BlackjackPro": "Multihand Blackjack Pro",
  "MultihandBlackjackPro2": "Multihand Blackjack Pro 2",
  "MummysGold": "Mummys Gold",
  "MysteryGarden": "Mystery Garden",
  "MysteryHeist": "Mystery Heist",
  "Oof": "OOF The Goldmine Planet",
  "OasisPoker": "Oasis Poker",
  "OlympusTrueways": "Olympus TRUEWAYS",
  "OpenIt": "Open It!",
  "PandaFortuneRush": "Panda Fortune Rush",
  "PandaLuck": "Panda Luck",
  "ParimatchMillion": "Parimatch Million",
  "ParimatchSoccermania": "Parimatch Soccermania",
  "PenaltyDuel": "Penalty Duel",
  "PennyPelican": "Penny Pelican",
  "PiggyBankHoldAndWin": "Piggy Bank Hold&Win",
  "PlatinumLightning": "Platinum Lightning",
  "PlatinumLightningDeluxe": "Platinum Lightning Deluxe",
  "Plinko": "Plinko",
  "Plinko2": "Plinko 2",
  "Plinko2Halloween": "Plinko 2 Halloween",
  "PlinkoXY": "Plinko XY",
  "Pontoon": "Pontoon",
  "PopZen": "Pop Zen",
  "PotionSpells": "Potion Spells",
  "PrincessRoyal": "Princess Royal",
  "PrincessOfSky": "Princess of Sky",
  "BInvestLive": "Retro Trader",
  "Road2Riches": "Road 2 Riches",
  "RocketDice": "Rocket Dice",
  "RocketDiceXY": "Rocket Dice XY",
  "RocketEruptionTripleBlast": "Rocket Eruption: Triple Blast",
  "RotatingElement": "Rotating Element",
  "RoyalBeellionHoldAndWin": "Royal Beellion Hold & Win",
  "RoyalEaster": "Royal Easter",
  "RoyalFruitsMultiLines": "Royal Fruits MultiLines",
  "RoyalHighRoad": "Royal High-Road",
  "RoyalRoulette500X": "Royal Roulette 500X",
  "SakuraRiches60": "Sakura Riches 60",
  "SavageBuffaloSpirit": "Savage Buffalo Spirit",
  "SavageBuffaloSpiritMegaways": "Savage Buffalo Spirit Megaways",
  "ScratchAlpacaBronze": "Scratch Alpaca Bronze",
  "ScratchAlpacaGold": "Scratch Alpaca Gold",
  "ScratchAlpacaSilver": "Scratch Alpaca Silver",
  "ScratchDice": "Scratch Dice",
  "ScrollOfAdventure": "Scroll of Adventure",
  "SecretBarMultiDiceX": "Secret Bar Multidice X",
  "SlotMachine": "Slot Machine Christmas edition",
  "SlotomonGo": "Slotomon Go",
  "SnoopDoggDollars": "Snoop Dogg Dollars",
  "Soccermania": "Soccermania",
  "SpaceXY": "SpaceXY",
  "SpinAndSpell": "Spin And Spell",
  "Squidpot": "Squidpot",
  "StarTrekNextGen": "Star Trek The Next Generation",
  "StreetPower": "Street Power",
  "SugarMix": "Sugar Mix",
  "SurrenderMultihandBlackjack": "Surrender Multihand Blackjack",
  "SweetRushMegaways": "Sweet Rush Megaways",
  "TexasHoldem": "Texas Holdem",
  "TileMaster": "Tile Master",
  "TopEagle": "Top Eagle",
  "TotallyHot": "Totally Hot",
  "TrainToRioGrande": "Train to Rio Grande",
  "TrampDay": "Tramp Day",
  "TrampDayTrueways": "Tramp Day TRUEWAYS",
  "TreasureExplorer": "Treasure Explorer",
  "TreasureOfAnubis": "Treasure of Anubis",
  "TreyPoker": "Trey Poker",
  "UFOPyramids": "UFO Pyramids",
  "VoodooPeople": "Voodoo People",
  "WbcRingOfRiches": "WBC Ring of Riches",
  "WestTown": "West Town",
  "WildCardGang": "Wild Card Gang",
  "WildCash": "Wild Cash",
  "WildCashDice": "Wild Cash Dice",
  "WildCashX9990": "Wild Cash x9990",
  "WildChicago": "Wild Chicago",
  "WildClusters": "Wild Clusters",
  "WildHeart": "Wild Heart",
  "WildMillion": "Wild Million",
  "WildMoonThieves": "Wild Moon Thieves",
  "WildTexas": "Wild Texas",
  "WildTiger": "Wild Tiger",
  "WildTiger2": "Wild Tiger 2",
  "WildWestTrueways": "Wild West Trueways",
  "WildWick": "Wild Wick",
  "WinterFishingClub": "Winter Fishing Club",
  "WinterTrophyHoldAndWin": "Winter Trophy Hold and Win",
  "YommiRush": "Yommi Rush",
  "ZeusGoesWild": "Zeus Goes Wild",
  "maya2": "#buyBonus of Maya",
  "super_stars": "20 Super Stars",
  "pepper_super_3x": "3x Super Peppers - Hot Wins",
  "aladdin": "4 Secrets of Aladdin",
  "pepper_wild_5": "5 Wild Wild Peppers",
  "juicy_fruits": "500 Juicy Fruits",
  "anland100_7days": "7 Days Anotherland",
  "armada100_7days": "7 Days Spanish armada",
  "seven_fruits": "7 Fruits",
  "treasure88": "88 Dragons Treasure",
  "golden88": "88 Golden 88",
  "action": "Action",
  "africa10": "Africa",
  "africa2": "Africa Gold 2",
  "american_roulette": "American Roulette",
  "atemple_gems": "Ancient Temple Gems",
  "axe_fortune": "Axe of Fortune",
  "bank_robbers": "Bank Robbers",
  "bears_tricks": "Bear's Tricks",
  "beauty_beast": "Beauty and the Beast",
  "big_bang": "Big Bang",
  "big_bang2": "Big Bang 2",
  "buffalo": "Big Wild Buffalo",
  "buffalo2": "Big Wild Buffalo 2",
  "bingo_power": "Bingo Power",
  "bingo_soccer": "Bingo Soccer",
  "fishing": "Blast The Bass",
  "bluebeard": "BlueBeard",
  "book": "Book of Doom",
  "cafe_50s": "Cafe 50's",
  "carousel": "Carousel",
  "smack_me": "Catch & Snatch",
  "worms": "Caterpillars",
  "chefs_fruits": "Chef's Sticky Fruits",
  "chicago": "Chicago Bang, Bang",
  "christmas": "Christmas Jackpot",
  "cleos_book": "Cleo’s Book",
  "cops_vs_robs": "Cops vs Robs",
  "digger": "Crystals Digger",
  "customs": "Customs Storage",
  "cyber_gypsies": "Cyber Gypsies",
  "diggers_fortune": "Digger's Fortune",
  "dracula20": "Dracula Riches",
  "dragons_bonanza": "Dragon's Bonanza",
  "mex_old": "Elusive Gonzales",
  "alc_old": "Escape from Alcatraz",
  "fortune_craft": "Fortune Craft",
  "fortune_mummy": "Fortune Mummy",
  "frog100": "Frog Creek",
  "hobbits_xmas": "Frozen Barrel Tavern",
  "fullmoon": "Full Moon Magic",
  "golden_lantern": "Golden Lantern",
  "lemon": "Golden Lemon",
  "lemon_deluxe": "Golden Lemon Deluxe",
  "golden_plinko": "Golden Plinko",
  "golden_axe": "Golden øks",
  "goose_bang": "Goose Boom Bang",
  "vgt25": "Greengrocery",
  "halloween": "Halloween",
  "bingo_halloween": "Halloween Bingo",
  "digger_halloween": "Halloween Crystals",
  "halloween2": "Halloween Jackpot",
  "highway25": "Highway Star",
  "hot_wild_pepper": "Hot Wild Pepper",
  "fishing_winter": "Ice Bass",
  "princess_xmas": "Ice Princess",
  "irish": "Irish Thunder",
  "miner": "Jackpot Mines",
  "jackpot_pagoda": "Jackpot Pagoda",
  "jewels10": "Jewels",
  "lotto_scratch_frog_discount": "King of Jumping Scratch",
  "joker": "Lavish Joker",
  "book_legacy": "Legacy of Doom",
  "long_neck": "Long Neck Fortune",
  "lovem10": "Love Magic",
  "lucie": "Lucie's cats",
  "lucky_bandits": "Lucky Bandits",
  "hobbits": "Lucky Barrel Tavern",
  "lucky_old": "Lucky Drink",
  "lucky10": "Lucky Drink In Egypt",
  "lucky_roulette": "Lucky Roulette",
  "mwa": "MWA",
  "make_gold": "Make it Gold",
  "gold": "Master Of Gold",
  "gold_xmas": "Master of Xmas",
  "maya10": "Maya Mystery",
  "maya3": "Mayan Book",
  "richy_hog_xmas": "Merry Hog",
  "fruit_mix": "Mix Fruits",
  "monkey": "Monkey Jackpot",
  "lazy_monkey": "Monkey Match",
  "monsters": "Monsters",
  "mummy_mines": "Mummy Mines",
  "mummyland": "Mummyland Treasures",
  "neptune20": "Neptune's Kingdom",
  "northern_boom": "Northern Boom",
  "piggy_old": "Piggy Bank",
  "lotto_scratch_piggy_discount": "Piggy Bank Scratch",
  "pirate_jackpots": "Pirate JackPots",
  "prehistoric": "Prehistoric Story",
  "princess_suki": "Princess Suki",
  "frog_old": "Princess of swamp",
  "richy_hog": "Richy Hog",
  "zeus": "Rise of Zeus",
  "rockets": "Rockets",
  "mummyland_xmas": "Santa Mummy",
  "sevens": "Sevens",
  "shoguns_fortune": "Shogun's Fortune",
  "sic_bo": "SicBo",
  "battle": "Slattors Battle - Orcs vs Elves",
  "sevens2": "Super Sevens",
  "sweet_lotto": "Sweet Lotto",
  "ghost20": "The Ghost Walks",
  "moneymania": "The Moneymania",
  "night_racing": "The Night Racing",
  "garden20": "The Smart Rabbit",
  "wildlife2": "The Wildlife 2",
  "tony_gambler": "Tony Gambler",
  "tortuga_codex": "Tortuga CodeX",
  "pepper_triplex": "Triple X Hot Pepper",
  "voodoo": "Voodoo Coins",
  "winter_thunder": "Winter Thunder",
  "witchschool": "Witch School",
  "wolf_thunder": "Wolf Thunder",
  "towers": "X Towers",
  "buffalo_x_mas": "X-Mas Buffalo",
  "digger_xmas": "X-Mas Gifts",
  "chinese_panda": "Xing Fu Panda",
  "zombie_town": "Zombie Town",
  "t2lvfq7tvm4aap3j": "Auto Lightning Roulette",
  "t5anzllcq37abrdg": "Auto-Roulette",
  "t5an2sqoq37abrdk": "Auto-Roulette VIP",
  "t3fjt3xp2khqahzu": "Blackjack Classic 70",
  "t5an3p4xq37abrdq": "Bucharest Auto-Roulette",
  "t5an53ysq37abrdz": "Casino Malta Roulette",
  "t5aoakjlq37abreh": "Double Ball Roulette",
  "t5aocvldq37abrer": "Dragonara Roulette",
  "t5aodtx5q37abrev": "Emperor Roulette",
  "t5aoelmiq37abrex": "Fireball Roulette",
  "t5aofienq37abre2": "Football Studio Roulette",
  "twf66kttmokqafm3": "Free Bet Blackjack 10",
  "t5aogsmtq37abrfb": "French Roulette Gold",
  "t5aojb7bq37abrfm": "Gold Vault Roulette",
  "t5aoj2rbq37abrfq": "Hindi Lightning Roulette",
  "t5aolqo4q37abrfw": "Hindi Roulette",
  "t5aomoo5q37abrfz": "Immersive Roulette",
  "t5aonkmhq37abrf5": "Instant Roulette",
  "t5apadjxq37abrgl": "Jawhara Roulette",
  "t5apbehnq37abrgp": "Lightning Roulette",
  "t5apcap6q37abrgr": "Lotus Roulette",
  "t5apcytmq37abrgv": "MONOPOLY Roulette",
  "t5aplwxxq37abrhd": "Red Door Roulette",
  "t5apnhtbq37abrhj": "Roleta Relâmpago",
  "t5apmq2yq37abrhh": "Roleta ao Vivo",
  "t5apoct4q37abrhm": "Roulette",
  "t5apo7m4q37abrho": "Ruleta Relámpago XXXtreme",
  "t5app2u4q37abrhr": "Speed Auto Roulette",
  "t5apqwxqq37abrht": "Speed Roulette",
  "t5aprqlgq37abrhx": "Türkçe Lightning Rulet",
  "t5apsnmiq37abrh2": "Türkçe Rulet",
  "t5apto4uq37abrh6": "Türkçe XXXtreme Lightning Roulette",
  "t5aogbfiq37abre6": "VIP Roulette",
  "t5an7axhq37abreb": "World Cup Roulette",
  "tyn5l5lipf4abcha": "World Cup Roulette",
  "t5apukpnq37abria": "XXXtreme Lightning Roulette",
  "divinegoldr94f00": "Divine Fortune Gold",
  "fruitshopgrr96f0": "Fruit Shop Grand Re-Opening",
  "tlnfdyg6p5naaio4": "Netent TG 4",
  "whatsupwitcr96f0": "What's Up? Witches",
  "diamondblitz3000": "Diamond Blitz 3",
  "hitthejungle0000": "Hit the Jungle",
  "jackpottrain0000": "Jackpot Train",
  "pandagoesboom000": "Panda Goes Boom",
  "worldfootballfor": "World Football Fortunes",
  "monopolyrollem01": "MONOPOLY Roll 'em",
  "spicer96f1000000": "Spice",
  "rebeltech-502763": "Roulette Lobby",
  "rebeltech-502764": "Baccarat & Sicbo Lobby",
  "rebeltech-502765": "Game Shows Lobby",
  "rebeltech-502766": "Top Games Lobby",
  "rebeltech-506278": "Roleta Ao Vivo",
  "rebeltech-506279": "Ruleta En Vivo",
  "rebeltech-502767": "Roulette",
  "rebeltech-502768": "American Roulette",
  "rebeltech-502769": "Lightning Roulette",
  "rebeltech-506280": "Greek Lightning Roulette",
  "rebeltech-506281": "Hindi Lightning Roulette",
  "rebeltech-506282": "Lotus Roulette",
  "rebeltech-506283": "Emperor Roulette",
  "rebeltech-506284": "Türkçe Rulet",
  "rebeltech-506285": "Japanese Roulette",
  "rebeltech-506286": "Hindi Roulette",
  "rebeltech-506287": "Jawhara Roulette",
  "rebeltech-502770": "Double Ball Roulette",
  "rebeltech-502771": "Immersive Roulette",
  "rebeltech-502772": "Auto-Roulette Vip",
  "rebeltech-502773": "Auto-Roulette",
  "rebeltech-502774": "Speed Roulette",
  "rebeltech-502775": "Grand Casino Roulette",
  "rebeltech-502776": "Casino Malta Roulette",
  "rebeltech-502777": "Dragonara Roulette",
  "rebeltech-502778": "Speed Auto Roulette",
  "rebeltech-506288": "Türkçe Lightning Rulet",
  "rebeltech-502779": "Vip Roulette",
  "rebeltech-502780": "Baccarat A",
  "rebeltech-502781": "Baccarat B",
  "rebeltech-502782": "Speed Baccarat A",
  "rebeltech-502783": "Speed Baccarat B",
  "rebeltech-502784": "Speed Baccarat C",
  "rebeltech-502785": "Speed Baccarat D",
  "rebeltech-502786": "Speed Baccarat E",
  "rebeltech-502787": "Speed Baccarat F",
  "rebeltech-502788": "Speed Baccarat G",
  "rebeltech-502789": "Speed Baccarat H",
  "rebeltech-502790": "Speed Baccarat I",
  "rebeltech-502791": "Speed Baccarat J",
  "rebeltech-502792": "Speed Baccarat L",
  "rebeltech-502793": "Speed Baccarat N",
  "rebeltech-502794": "Speed Baccarat Q",
  "rebeltech-502795": "Speed Baccarat R",
  "rebeltech-502796": "Speed Baccarat S",
  "rebeltech-502797": "Speed Baccarat T",
  "rebeltech-502798": "Speed Baccarat U",
  "rebeltech-502799": "Speed Baccarat V",
  "rebeltech-502800": "Speed Baccarat W",
  "rebeltech-502801": "Speed Baccarat X",
  "rebeltech-502802": "Speed Baccarat Z",
  "rebeltech-502803": "Speed Baccarat 1",
  "rebeltech-502804": "Speed Baccarat 2",
  "rebeltech-502805": "Speed Baccarat 3",
  "rebeltech-502806": "Speed Baccarat 4",
  "rebeltech-502807": "No Commission Baccarat",
  "rebeltech-502808": "Golden Wealth Baccarat",
  "rebeltech-502809": "Crazy Time",
  "rebeltech-502810": "Crazy Time A",
  "rebeltech-506289": "Crazy Time Italia",
  "rebeltech-502811": "Lightning Dice",
  "rebeltech-502812": "Dream Catcher",
  "rebeltech-502813": "Super Sic Bo",
  "rebeltech-506290": "Emperor Sic Bo",
  "rebeltech-506291": "Emperor Sic Bo A",
  "rebeltech-502814": "Speed Super Sic Bo",
  "rebeltech-502815": "Lightning Roulette Italia",
  "rebeltech-502816": "Dynasty Lightning Roulette",
  "rebeltech-502817": "Dynasty Roulette",
  "rebeltech-506292": "First Person Blackjack",
  "rebeltech-506293": "First Person Dream Catcher",
  "rebeltech-506294": "First Person Golden Wealth Baccarat",
  "rebeltech-506295": "First Person American Roulette",
  "rebeltech-506296": "First Person Roulette",
  "rebeltech-506297": "First Person Lightning Roulette",
  "rebeltech-506298": "First Person Xxxtreme Lightning Roulette",
  "rebeltech-506299": "First Person Bac Bo",
  "rebeltech-506300": "First Person Baccarat",
  "rebeltech-506301": "First Person Super Sic Bo",
  "rebeltech-502057": "Roulette 1",
  "rebeltech-502058": "Roulette Macao",
  "rebeltech-502059": "Blackjack 33",
  "rebeltech-502060": "Roulette 3",
  "rebeltech-502061": "Roulette 2",
  "rebeltech-502062": "Speed Roulette 1",
  "rebeltech-502063": "Auto Roulette",
  "rebeltech-502064": "Baccarat 5",
  "rebeltech-502065": "Baccarat 6",
  "rebeltech-502066": "Blackjack 3",
  "rebeltech-502067": "Blackjack 6",
  "rebeltech-502068": "Blackjack 7",
  "rebeltech-502069": "Blackjack 9",
  "rebeltech-502070": "Blackjack 10",
  "rebeltech-502071": "Blackjack 8",
  "rebeltech-502072": "Blackjack 22",
  "rebeltech-502073": "Blackjack 23",
  "rebeltech-502074": "Blackjack 24",
  "rebeltech-502075": "Blackjack 25",
  "rebeltech-502076": "Blackjack 26",
  "rebeltech-502077": "Blackjack 27",
  "rebeltech-502078": "Blackjack 28",
  "rebeltech-502079": "Blackjack 29",
  "rebeltech-502080": "Blackjack 30",
  "rebeltech-502081": "Blackjack 31",
  "rebeltech-502082": "Blackjack 32",
  "rebeltech-502083": "Blackjack 34",
  "rebeltech-502084": "Blackjack 35",
  "rebeltech-502085": "Blackjack 36",
  "rebeltech-502086": "Vip Roulette",
  "rebeltech-502087": "One Blackjack 2",
  "rebeltech-502088": "Blackjack Lobby",
  "rebeltech-502089": "Sweet Bonanza Candyland",
  "rebeltech-502090": "Blackjack 14",
  "rebeltech-502091": "Speed Baccarat 12",
  "rebeltech-502092": "Speed Baccarat 11",
  "rebeltech-502093": "Blackjack 21",
  "rebeltech-502094": "Roulette Lobby",
  "rebeltech-502095": "Baccarat Lobby",
  "rebeltech-502096": "Blackjack 4",
  "rebeltech-502097": "Blackjack 19",
  "rebeltech-502098": "Blackjack 20",
  "rebeltech-502099": "Game Shows",
  "rebeltech-502100": "Blackjack 1",
  "rebeltech-502101": "Blackjack 5",
  "rebeltech-502102": "Blackjack 2",
  "rebeltech-502103": "Blackjack 11",
  "rebeltech-502104": "Blackjack 12",
  "rebeltech-502105": "Blackjack 15",
  "rebeltech-502106": "Blackjack 16",
  "rebeltech-502107": "Blackjack 18",
  "rebeltech-502108": "Blackjack 17",
  "rebeltech-502109": "Speed Baccarat 3",
  "rebeltech-502110": "Speed Baccarat 5",
  "rebeltech-502111": "Baccarat 7",
  "rebeltech-502112": "Speed Baccarat 9",
  "rebeltech-502113": "Turbo Baccarat",
  "rebeltech-502114": "Speed Baccarat 8",
  "rebeltech-502115": "Speed Baccarat 14",
  "rebeltech-502116": "Speed Baccarat 7",
  "rebeltech-502117": "Baccarat 3",
  "rebeltech-502118": "Baccarat 2",
  "rebeltech-502119": "Speed Baccarat 15",
  "rebeltech-502120": "Speed Baccarat 6",
  "rebeltech-502121": "Blackjack 48",
  "rebeltech-502122": "Blackjack 49",
  "rebeltech-502123": "Blackjack 50",
  "rebeltech-502124": "Blackjack 51",
  "rebeltech-502125": "Vip Blackjack 1",
  "rebeltech-502126": "Vip Blackjack 2",
  "rebeltech-502127": "Big Bass Crash",
  "rebeltech-502128": "Spaceman",
  "rebeltech-502129": "Blackjack 63",
  "rebeltech-502130": "Blackjack 37",
  "rebeltech-502131": "Blackjack 38",
  "rebeltech-502132": "Blackjack 39",
  "rebeltech-502133": "Blackjack 40",
  "rebeltech-502134": "Blackjack 41",
  "rebeltech-502135": "Blackjack 42",
  "rebeltech-502136": "Blackjack 43",
  "rebeltech-502137": "Blackjack 44",
  "rebeltech-502138": "Blackjack 45",
  "rebeltech-502139": "Blackjack 46",
  "rebeltech-502140": "Blackjack 47",
  "rebeltech-502141": "Speed Baccarat 10",
  "rebeltech-502142": "Speed Baccarat 13",
  "rebeltech-502143": "Speed Blackjack 3",
  "rebeltech-502144": "Blackjack 77",
  "rebeltech-502145": "Super 8 Baccarat",
  "rebeltech-502146": "Speed Blackjack 1",
  "rebeltech-502147": "Speed Blackjack 2",
  "rebeltech-502148": "Blackjack 78",
  "rebeltech-502149": "Fortune 6 Baccarat",
  "rebeltech-502150": "Speed Baccarat 16",
  "rebeltech-502151": "Speed Baccarat 17",
  "rebeltech-502152": "Baccarat 9",
  "rebeltech-502153": "Powerup Roulette",
  "rebeltech-502154": "Speed Roulette 2",
  "rebeltech-502155": "Blackjack 52",
  "rebeltech-502156": "Blackjack 53",
  "rebeltech-502157": "Blackjack 54",
  "rebeltech-502158": "Blackjack 55",
  "rebeltech-502159": "Blackjack 56",
  "rebeltech-502160": "Blackjack 62",
  "rebeltech-502161": "Blackjack 64",
  "rebeltech-502162": "Blackjack 65",
  "rebeltech-502163": "Vip Blackjack 9",
  "rebeltech-502164": "Vip Blackjack 10",
  "rebeltech-502165": "Vip Blackjack 11",
  "rebeltech-502166": "Vip Blackjack 12",
  "rebeltech-502167": "Blackjack 70",
  "rebeltech-502168": "Blackjack 71",
  "rebeltech-502169": "Blackjack 72",
  "rebeltech-502170": "Blackjack 73",
  "rebeltech-502171": "Blackjack 74",
  "rebeltech-502172": "Blackjack 148",
  "rebeltech-502173": "Blackjack 149",
  "rebeltech-502174": "Speed Blackjack 17",
  "rebeltech-502175": "Speed Blackjack 18",
  "rebeltech-502176": "Speed Blackjack 10",
  "rebeltech-502177": "Speed Blackjack 6",
  "rebeltech-502178": "Speed Blackjack 7",
  "rebeltech-502179": "Speed Blackjack 8",
  "rebeltech-502180": "Speed Blackjack 11",
  "rebeltech-502181": "Speed Blackjack 9",
  "rebeltech-502182": "Speed Blackjack 12",
  "rebeltech-502183": "Speed Blackjack 14",
  "rebeltech-502184": "Blackjack 75",
  "rebeltech-502185": "Blackjack 76",
  "rebeltech-502186": "Blackjack 79",
  "rebeltech-502187": "Blackjack 80",
  "rebeltech-502188": "Blackjack 81",
  "rebeltech-502189": "Vip Blackjack 13",
  "rebeltech-502190": "Blackjack 61",
  "rebeltech-502191": "Blackjack 60",
  "rebeltech-502192": "Blackjack 59",
  "rebeltech-502193": "Blackjack 58",
  "rebeltech-502194": "Speed Auto Roulette",
  "rebeltech-502195": "Mega Baccarat",
  "rebeltech-502196": "Blackjack 150",
  "rebeltech-502197": "Speed Blackjack 20",
  "rebeltech-502198": "Speed Blackjack 21",
  "rebeltech-502199": "Speed Blackjack 22",
  "rebeltech-502200": "Vip Blackjack 6",
  "rebeltech-502201": "Vip Blackjack 7",
  "rebeltech-502202": "Auto Mega Roulette",
  "rebeltech-502203": "Prive Lounge Blackjack 1",
  "rebeltech-502204": "Prive Lounge Blackjack 2",
  "rebeltech-502205": "Prive Lounge Blackjack 3",
  "rebeltech-502206": "Prive Lounge Blackjack 4",
  "rebeltech-502207": "Prive Lounge Blackjack 5",
  "rebeltech-502208": "Speed Blackjack 24",
  "rebeltech-502209": "Speed Blackjack 25",
  "rebeltech-502210": "Speed Blackjack 26",
  "rebeltech-502211": "Speed Blackjack 27",
  "rebeltech-502212": "Blackjack 151",
  "rebeltech-502213": "Blackjack 152",
  "rebeltech-502214": "Speed Blackjack 30",
  "rebeltech-502215": "Sic Bo",
  "rebeltech-502216": "Lucky 6 Roulette™",
  "rebeltech-502217": "Blackjackx 1",
  "rebeltech-502218": "Blackjackx 2",
  "rebeltech-502219": "Blackjackx 3",
  "rebeltech-502220": "Blackjackx 4",
  "rebeltech-502221": "Blackjackx 5",
  "rebeltech-502222": "Blackjackx 6",
  "rebeltech-502223": "Blackjackx 7",
  "rebeltech-502224": "Blackjackx 8",
  "rebeltech-502225": "Blackjackx 9",
  "rebeltech-502226": "Blackjackx 10",
  "rebeltech-502227": "Blackjackx 14",
  "rebeltech-502228": "Blackjackx 15",
  "rebeltech-502229": "Blackjackx 16",
  "rebeltech-502230": "Blackjackx 17",
  "rebeltech-502231": "Blackjackx 18",
  "rebeltech-502232": "Blackjackx 19",
  "rebeltech-502233": "Blackjackx 20",
  "rebeltech-502234": "Blackjackx 21",
  "rebeltech-502235": "Blackjackx 24",
  "rebeltech-502236": "Blackjackx 25",
  "rebeltech-502237": "Blackjack 57",
  "rebeltech-502238": "Baccarat 1",
  "rebeltech-502239": "Speed Baccarat 1",
  "rebeltech-502240": "One Blackjack 1",
  "rebeltech-502241": "Dragon Tiger",
  "rebeltech-502242": "Speed Baccarat 2",
  "rebeltech-502243": "Andar Bahar",
  "rebeltech-502244": "Mega Roulette",
  "rebeltech-502245": "Mega Wheel",
  "rebeltech-502246": "Mega Sic Bo",
  "rebeltech-502247": "3 Buzzing Wilds",
  "rebeltech-502248": "3 Dancing Monkeys",
  "rebeltech-502249": "3 Genie Wishes",
  "rebeltech-502250": "3 Kingdoms Battle Of Red Cliffs",
  "rebeltech-502251": "5 Frozen Charms Megaways",
  "rebeltech-502252": "5 Lions",
  "rebeltech-502253": "5 Lions Dance",
  "rebeltech-502254": "5 Lions Gold",
  "rebeltech-502255": "5 Lions Megaways",
  "rebeltech-502256": "5 Lions Megaways 2",
  "rebeltech-502257": "5 Lions Reborn",
  "rebeltech-502258": "6 Jokers",
  "rebeltech-502259": "7 Clovers Of Fortune",
  "rebeltech-502260": "7 Monkeys",
  "rebeltech-502261": "7 Piggies",
  "rebeltech-502262": "7 Piggies 5,000",
  "rebeltech-502263": "8 Dragons",
  "rebeltech-502264": "8 Golden Dragon Challenge",
  "rebeltech-502265": "888 Dragons",
  "rebeltech-502266": "888 Gold",
  "rebeltech-502267": "African Elephant",
  "rebeltech-502268": "Aladdin And The Sorcerer",
  "rebeltech-502269": "Aladdin’S Treasure",
  "rebeltech-502270": "American Blackjack",
  "rebeltech-502271": "Ancient Egypt",
  "rebeltech-502272": "Ancient Egypt Classic",
  "rebeltech-502273": "Ancient Island Megaways",
  "rebeltech-502274": "Angel Vs Sinner",
  "rebeltech-502275": "Asgard",
  "rebeltech-502276": "Aztec Blaze",
  "rebeltech-502277": "Aztec Bonanza",
  "rebeltech-502278": "Aztec Gems",
  "rebeltech-502279": "Aztec Gems Deluxe",
  "rebeltech-502280": "Aztec Gems Megaways",
  "rebeltech-502281": "Aztec Powernudge",
  "rebeltech-502282": "Aztec Smash",
  "rebeltech-502283": "Aztec Treasure Hunt",
  "rebeltech-502284": "Baccarat",
  "rebeltech-502285": "Badge Blitz",
  "rebeltech-502286": "Bandit Megaways",
  "rebeltech-502287": "Barn Festival",
  "rebeltech-502288": "Barnyard Megahays Megaways",
  "rebeltech-502289": "Beware The Deep Megaways",
  "rebeltech-502290": "Big Bass - Hold & Spinner",
  "rebeltech-502291": "Big Bass - Secrets Of The Golden Lake",
  "rebeltech-502292": "Big Bass Amazon Xtreme",
  "rebeltech-502293": "Big Bass Bonanza",
  "rebeltech-502294": "Big Bass Bonanza - Reel Action",
  "rebeltech-502295": "Big Bass Bonanza 1000",
  "rebeltech-502296": "Big Bass Bonanza 3 Reeler",
  "rebeltech-502297": "Big Bass Bonanza Keeping It Reel",
  "rebeltech-502298": "Big Bass Bonanza Megaways",
  "rebeltech-502299": "Big Bass Christmas Bash",
  "rebeltech-502300": "Big Bass Day At The Races",
  "rebeltech-502301": "Big Bass Floats My Boat",
  "rebeltech-502302": "Big Bass Halloween",
  "rebeltech-502303": "Big Bass Halloween 2",
  "rebeltech-502304": "Big Bass Hold & Spinner Megaways",
  "rebeltech-502305": "Big Bass Mission Fishin'",
  "rebeltech-502306": "Big Bass Return To The Races",
  "rebeltech-502307": "Big Bass Splash",
  "rebeltech-502308": "Big Bass Vegas Double Down Deluxe",
  "rebeltech-502309": "Big Bass Xmas Xtreme",
  "rebeltech-502310": "Big Burger Load It Up With Xtra Cheese",
  "rebeltech-502311": "Big Juan",
  "rebeltech-502312": "Bigger Bass Blizzard Christmas Catch",
  "rebeltech-502313": "Bigger Bass Bonanza",
  "rebeltech-502314": "Bigger Bass Splash",
  "rebeltech-502315": "Black Bull",
  "rebeltech-502316": "Blade & Fangs",
  "rebeltech-502317": "Blazing Wilds Megaways",
  "rebeltech-502318": "Blitz Super Wheel",
  "rebeltech-502319": "Bomb Bonanza",
  "rebeltech-502320": "Book Of Golden Sands",
  "rebeltech-502321": "Book Of Kingdoms",
  "rebeltech-502322": "Book Of Monsters",
  "rebeltech-502323": "Book Of The Fallen",
  "rebeltech-502324": "Book Of Vikings",
  "rebeltech-502325": "Bounty Gold",
  "rebeltech-502326": "Bow Of Artemis",
  "rebeltech-502327": "Brick House Bonanza",
  "rebeltech-502328": "Buffalo King",
  "rebeltech-502329": "Buffalo King Megaways",
  "rebeltech-502330": "Buffalo King Untamed Megaways",
  "rebeltech-502331": "Caishen'S Cash",
  "rebeltech-502332": "Caishen'S Gold",
  "rebeltech-502333": "Candy Blitz",
  "rebeltech-502334": "Candy Blitz Bombs",
  "rebeltech-502335": "Candy Corner",
  "rebeltech-502336": "Candy Jar Clusters",
  "rebeltech-502337": "Candy Stars",
  "rebeltech-502338": "Cash Bonanza",
  "rebeltech-502339": "Cash Box",
  "rebeltech-502340": "Cash Chips",
  "rebeltech-502341": "Cash Elevator",
  "rebeltech-502342": "Cash Patrol",
  "rebeltech-502343": "Cash Surge",
  "rebeltech-502344": "Castle Of Fire",
  "rebeltech-502345": "Chase For Glory",
  "rebeltech-502346": "Chests Of Cai Shen",
  "rebeltech-502347": "Chicken Chase",
  "rebeltech-502348": "Chicken Drop",
  "rebeltech-502349": "Chilli Heat",
  "rebeltech-502350": "Chilli Heat Megaways",
  "rebeltech-502351": "Christmas Big Bass Bonanza",
  "rebeltech-502352": "Christmas Carol Megaways",
  "rebeltech-502353": "Cleocatra",
  "rebeltech-502354": "Clover Gold",
  "rebeltech-502355": "Club Tropicana",
  "rebeltech-502356": "Colossal Cash Zone",
  "rebeltech-502357": "Congo Cash",
  "rebeltech-502358": "Congo Cash Xl",
  "rebeltech-502359": "Cosmic Cash",
  "rebeltech-502360": "Country Farming",
  "rebeltech-502361": "Cowboy Coins",
  "rebeltech-502362": "Cowboys Gold",
  "rebeltech-502363": "Crank It Up",
  "rebeltech-502364": "Crown Of Fire",
  "rebeltech-502365": "Crystal Caverns Megaways",
  "rebeltech-502366": "Curse Of The Werewolf Megaways",
  "rebeltech-502367": "Cyclops Smash",
  "rebeltech-502368": "Da Vinci'S Treasure",
  "rebeltech-502369": "Dance Party",
  "rebeltech-502370": "Day Of Dead",
  "rebeltech-502371": "Demon Pots",
  "rebeltech-502372": "Devilicious",
  "rebeltech-502373": "Diamond Cascade",
  "rebeltech-502374": "Diamond Strike",
  "rebeltech-502375": "Diamond Strike 100,000",
  "rebeltech-502376": "Diamonds Are Forever 3 Lines",
  "rebeltech-502377": "Diamonds Of Egypt",
  "rebeltech-502378": "Ding Dong Christmas Bells",
  "rebeltech-502379": "Down The Rails",
  "rebeltech-502380": "Drago Jewels Of Fortune",
  "rebeltech-502381": "Dragon Gold 88",
  "rebeltech-502382": "Dragon Hero",
  "rebeltech-502383": "Dragon Hot Hold & Spin",
  "rebeltech-502384": "Dragon King Hot Pots",
  "rebeltech-502385": "Dragon Kingdom",
  "rebeltech-502386": "Dragon Kingdom Eyes Of Fire",
  "rebeltech-502387": "Dragon Tiger",
  "rebeltech-502388": "Drill That Gold",
  "rebeltech-502389": "Dwarf & Dragon",
  "rebeltech-502390": "Dwarven Gold",
  "rebeltech-502391": "Dwarven Gold Deluxe",
  "rebeltech-502392": "Dynamite Diggin Doug",
  "rebeltech-502393": "Egyptian Fortunes",
  "rebeltech-502394": "Elemental Gems Megaways",
  "rebeltech-502395": "Emerald King",
  "rebeltech-502396": "Emerald King Rainbow Road",
  "rebeltech-502397": "Emotiwins",
  "rebeltech-502398": "Empty The Bank",
  "rebeltech-502399": "Escape The Pyramid – Fire And Ice",
  "rebeltech-502400": "Eternal Empress - Freeze Time",
  "rebeltech-502401": "Excalibur Unleashed",
  "rebeltech-502402": "Extra Juicy",
  "rebeltech-502403": "Extra Juicy Megaways",
  "rebeltech-502404": "Eye Of Cleopatra",
  "rebeltech-502405": "Eye Of The Storm",
  "rebeltech-502406": "Fairytale Fortune",
  "rebeltech-502407": "Fangtastic Freespins",
  "rebeltech-502408": "Fat Panda",
  "rebeltech-502409": "Fire 88",
  "rebeltech-502410": "Fire Archer",
  "rebeltech-502411": "Fire Hot 100",
  "rebeltech-502412": "Fire Hot 20",
  "rebeltech-502413": "Fire Hot 40",
  "rebeltech-502414": "Fire Hot 5",
  "rebeltech-502415": "Fire Portals",
  "rebeltech-502416": "Fire Stampede",
  "rebeltech-502417": "Fire Strike",
  "rebeltech-502418": "Fire Strike 2",
  "rebeltech-502419": "Firebird Spirit Connect & Collect",
  "rebeltech-502420": "Fish Eye",
  "rebeltech-502421": "Fishin' Reels",
  "rebeltech-502422": "Floating Dragon - Dragon Boat Festival",
  "rebeltech-502423": "Floating Dragon - Year Of The Snake",
  "rebeltech-502424": "Floating Dragon Hold & Spin Megaways",
  "rebeltech-502425": "Floating Dragon Hold And Spin",
  "rebeltech-502426": "Floating Dragon New Year Festival Ultra Megaways",
  "rebeltech-502427": "Forge Of Olympus",
  "rebeltech-502428": "Forging Wilds",
  "rebeltech-502429": "Fortune Hit'N Roll",
  "rebeltech-502430": "Fortune Of Giza",
  "rebeltech-502431": "Fortunes Of Aztec",
  "rebeltech-502432": "Front Runner Odds On",
  "rebeltech-502433": "Frozen Tropics",
  "rebeltech-502434": "Fruit Party",
  "rebeltech-502435": "Fruit Party 2",
  "rebeltech-502436": "Fruit Rainbow",
  "rebeltech-502437": "Fruity Treats",
  "rebeltech-502438": "Fury Of Odin Megaways",
  "rebeltech-502439": "Gates Of Olympus",
  "rebeltech-502440": "Gates Of Olympus 1000",
  "rebeltech-502441": "Gates Of Olympus Dice",
  "rebeltech-502442": "Gates Of Olympus Super Scatter",
  "rebeltech-502443": "Gates Of Olympus Xmas 1000",
  "rebeltech-502444": "Gates Of Valhalla",
  "rebeltech-502445": "Gears Of Horus",
  "rebeltech-502446": "Gem Elevator",
  "rebeltech-502447": "Gems Bonanza",
  "rebeltech-502448": "Gems Of Serengeti",
  "rebeltech-502449": "Glorious Rome",
  "rebeltech-502450": "Goblin Heist Powernudge",
  "rebeltech-502451": "Gods Of Giza",
  "rebeltech-502452": "Gold Oasis",
  "rebeltech-502453": "Gold Party",
  "rebeltech-502454": "Gold Rush",
  "rebeltech-502455": "Gold Rush 250,000",
  "rebeltech-502456": "Gold Train",
  "rebeltech-502457": "Good Luck & Good Fortune",
  "rebeltech-502458": "Gorilla Mayhem",
  "rebeltech-502459": "Gravity Bonanza",
  "rebeltech-502460": "Great Reef",
  "rebeltech-502461": "Great Rhino",
  "rebeltech-502462": "Great Rhino Deluxe",
  "rebeltech-502463": "Great Rhino Megaways",
  "rebeltech-502464": "Greedy Fortune Pig",
  "rebeltech-502465": "Greedy Wolf",
  "rebeltech-502466": "Greek Gods",
  "rebeltech-502467": "Hand Of Midas 2",
  "rebeltech-502468": "Happy Hooves",
  "rebeltech-502469": "Heart Of Cleopatra",
  "rebeltech-502470": "Heart Of Rio",
  "rebeltech-502471": "Heist For The Golden Nuggets",
  "rebeltech-502472": "Hellvis Wild",
  "rebeltech-502473": "Hercules And Pegasus",
  "rebeltech-502474": "Hercules Son Of Zeus",
  "rebeltech-502475": "Heroic Spins",
  "rebeltech-502476": "Himalayan Wild",
  "rebeltech-502477": "Hockey League",
  "rebeltech-502478": "Hockey League Wild Match",
  "rebeltech-502479": "Honey Honey Honey",
  "rebeltech-502480": "Hot Chilli",
  "rebeltech-502481": "Hot Fiesta",
  "rebeltech-502482": "Hot Pepper",
  "rebeltech-502483": "Hot Safari",
  "rebeltech-502484": "Hot Safari 50,000",
  "rebeltech-502485": "Hot To Burn",
  "rebeltech-502486": "Hot To Burn 7 Deadly Free Spins",
  "rebeltech-502487": "Hot To Burn Extreme",
  "rebeltech-502488": "Hot To Burn Hold And Spin",
  "rebeltech-502489": "Hot To Burn Multiplier",
  "rebeltech-502490": "Ice Lobster",
  "rebeltech-502491": "Infective Wild",
  "rebeltech-502492": "Irish Charms",
  "rebeltech-502493": "Irish Crown",
  "rebeltech-502494": "Jackpot Hunter",
  "rebeltech-502495": "Jade Butterfly",
  "rebeltech-502496": "Jane Hunter And The Mask Of Montezuma",
  "rebeltech-502497": "Jasmine Dreams",
  "rebeltech-502498": "Jelly Candy",
  "rebeltech-502499": "Jewel Rush",
  "rebeltech-502500": "John Hunter And Galileo’S Secrets",
  "rebeltech-502501": "John Hunter And The Aztec Treasure",
  "rebeltech-502502": "John Hunter And The Book Of Tut",
  "rebeltech-502503": "John Hunter And The Book Of Tut Megaways",
  "rebeltech-502504": "John Hunter And The Book Of Tut Respin",
  "rebeltech-502505": "John Hunter And The Mayan Gods",
  "rebeltech-502506": "John Hunter And The Quest For Bermuda Riches",
  "rebeltech-502507": "John Hunter And The Tomb Of The Scarab Queen",
  "rebeltech-502508": "Joker King",
  "rebeltech-502509": "Joker'S Jewels",
  "rebeltech-502510": "Joker'S Jewels Cash",
  "rebeltech-502511": "Joker'S Jewels Dice",
  "rebeltech-502512": "Joker'S Jewels Hot",
  "rebeltech-502513": "Joker'S Jewels Wild",
  "rebeltech-502514": "Journey To The West",
  "rebeltech-502515": "Juicy Fruits",
  "rebeltech-502516": "Juicy Fruits Multihold",
  "rebeltech-502517": "Jungle Gorilla",
  "rebeltech-502518": "Jurassic Giants",
  "rebeltech-502519": "Kingdom Of The Dead",
  "rebeltech-502520": "Knight Hot Spotz",
  "rebeltech-502521": "Lady Godiva",
  "rebeltech-502522": "Lady Of The Moon",
  "rebeltech-502523": "Lamp Of Infinity",
  "rebeltech-502524": "Leprechaun Carol",
  "rebeltech-502525": "Leprechaun Song",
  "rebeltech-502526": "Little Gem Hold And Spin",
  "rebeltech-502527": "Lobster Bob'S Crazy Crab Shack",
  "rebeltech-502528": "Lobster Bob'S Sea Food And Win It",
  "rebeltech-502529": "Loki'S Riches",
  "rebeltech-502530": "Lucky Dog",
  "rebeltech-502531": "Lucky Dragons",
  "rebeltech-502532": "Lucky Lightning",
  "rebeltech-502533": "Lucky Mouse",
  "rebeltech-502534": "Lucky New Year",
  "rebeltech-502535": "Lucky Ox",
  "rebeltech-502536": "Lucky Tiger",
  "rebeltech-502537": "Lucky, Grace & Charm",
  "rebeltech-502538": "Lucky’S Wild Pub",
  "rebeltech-502539": "Madame Destiny",
  "rebeltech-502540": "Madame Destiny Megaways",
  "rebeltech-502541": "Magic Crystals",
  "rebeltech-502542": "Magic Journey",
  "rebeltech-502543": "Magic Money Maze",
  "rebeltech-502544": "Magician'S Secrets",
  "rebeltech-502545": "Mammoth Gold Megaways",
  "rebeltech-502546": "Master Chen'S Fortune",
  "rebeltech-502547": "Master Joker",
  "rebeltech-502548": "Medusa'S Stone",
  "rebeltech-502549": "Might Of Freya Megaways",
  "rebeltech-502550": "Might Of Ra",
  "rebeltech-502551": "Mighty Kong",
  "rebeltech-502552": "Mighty Munching Melons",
  "rebeltech-502553": "Mining Rush",
  "rebeltech-502554": "Mochimon",
  "rebeltech-502555": "Moleionaire",
  "rebeltech-502556": "Money Mouse",
  "rebeltech-502557": "Money Stacks",
  "rebeltech-502558": "Money Stacks Dice",
  "rebeltech-502559": "Money Stacks Megaways",
  "rebeltech-502560": "Monkey Madness",
  "rebeltech-502561": "Monkey Warrior",
  "rebeltech-502562": "Monster Superlanche",
  "rebeltech-502563": "Muertos Multiplier Megaways",
  "rebeltech-502564": "Multihand Blackjack",
  "rebeltech-502565": "Mustang Gold",
  "rebeltech-502566": "Mustang Gold Megaways",
  "rebeltech-502567": "Mustang Trail",
  "rebeltech-502568": "Mysterious",
  "rebeltech-502569": "Mysterious Egypt",
  "rebeltech-502570": "Mystery Mice",
  "rebeltech-502571": "Mystery Of The Orient",
  "rebeltech-502572": "Mystic Chief",
  "rebeltech-502573": "Nile Fortune",
  "rebeltech-502574": "North Guardians",
  "rebeltech-502575": "Octobeer Fortunes",
  "rebeltech-502576": "Oodles Of Noodles",
  "rebeltech-502577": "Panda Gold 10,000",
  "rebeltech-502578": "Panda'S Fortune",
  "rebeltech-502579": "Panda'S Fortune 2",
  "rebeltech-502580": "Panther Queen",
  "rebeltech-502581": "Peak Power",
  "rebeltech-502582": "Peking Luck",
  "rebeltech-502583": "Penguins Christmas Party Time",
  "rebeltech-502584": "Peppe’S Pepperoni Pizza Plaza",
  "rebeltech-502585": "Phoenix Forge",
  "rebeltech-502586": "Piggy Bank Bills",
  "rebeltech-502587": "Piggy Bankers",
  "rebeltech-502588": "Pinup Girls",
  "rebeltech-502589": "Pirate Gold",
  "rebeltech-502590": "Pirate Gold Deluxe",
  "rebeltech-502591": "Pirate Golden Age",
  "rebeltech-502592": "Pirates Pub",
  "rebeltech-502593": "Pixie Wings",
  "rebeltech-502594": "Pizza Pizza Pizza",
  "rebeltech-502595": "Pompeii Megareels Megaways",
  "rebeltech-502596": "Pot Of Fortune",
  "rebeltech-502597": "Power Of Merlin Megaways",
  "rebeltech-502598": "Power Of Thor Megaways",
  "rebeltech-502599": "Pub Kings",
  "rebeltech-502600": "Pyramid King",
  "rebeltech-502601": "Queen Of Atlantis",
  "rebeltech-502602": "Queen Of Gods",
  "rebeltech-502603": "Queen Of Gold 100,000",
  "rebeltech-502604": "Queenie",
  "rebeltech-502605": "Rabbit Garden",
  "rebeltech-502606": "Raging Waterfall Megaways",
  "rebeltech-502607": "Rainbow Gold",
  "rebeltech-502608": "Rainbow Reels",
  "rebeltech-502609": "Red Hot Luck",
  "rebeltech-502610": "Reel Banks",
  "rebeltech-502611": "Release The Bison",
  "rebeltech-502612": "Release The Kraken",
  "rebeltech-502613": "Release The Kraken 2",
  "rebeltech-502614": "Release The Kraken Megaways",
  "rebeltech-502615": "Resurrecting Riches",
  "rebeltech-502616": "Return Of The Dead",
  "rebeltech-502617": "Revenge Of Loki Megaways",
  "rebeltech-502618": "Ride The Lightning",
  "rebeltech-502619": "Ripe Rewards",
  "rebeltech-502620": "Rise Of Giza Powernudge",
  "rebeltech-502621": "Rise Of Pyramids",
  "rebeltech-502622": "Rock Vegas",
  "rebeltech-502623": "Rocket Blast Megaways",
  "rebeltech-502624": "Romeo And Juliet",
  "rebeltech-502625": "Roulette",
  "rebeltech-502626": "Running Sushi",
  "rebeltech-502627": "Safari King",
  "rebeltech-502628": "Samurai Code",
  "rebeltech-502629": "Santa",
  "rebeltech-502630": "Santa'S Great Gifts",
  "rebeltech-502631": "Santa'S Wonderland",
  "rebeltech-502632": "Santa'S Xmas Rush",
  "rebeltech-502633": "Saray Ruyasi",
  "rebeltech-502634": "Savannah Legend",
  "rebeltech-502635": "Secret City Gold",
  "rebeltech-502636": "Shield Of Sparta",
  "rebeltech-502637": "Shining Hot 100",
  "rebeltech-502638": "Shining Hot 20",
  "rebeltech-502639": "Shining Hot 40",
  "rebeltech-502640": "Shining Hot 5",
  "rebeltech-502641": "Sky Bounty",
  "rebeltech-502642": "Sleeping Dragon",
  "rebeltech-502643": "Smugglers Cove",
  "rebeltech-502644": "Snakes & Ladders Snake Eyes",
  "rebeltech-502645": "Snakes And Ladders Megadice",
  "rebeltech-502646": "Spartan King",
  "rebeltech-502647": "Spellbinding Mystery",
  "rebeltech-502648": "Spin & Score Megaways",
  "rebeltech-502649": "Spirit Of Adventure",
  "rebeltech-502650": "Star Bounty",
  "rebeltech-502651": "Star Pirates Code",
  "rebeltech-502652": "Starlight Christmas",
  "rebeltech-502653": "Starlight Princess",
  "rebeltech-502654": "Starlight Princess 1000",
  "rebeltech-502655": "Starlight Princess Pachi",
  "rebeltech-502656": "Starz Megaways",
  "rebeltech-502657": "Sticky Bees",
  "rebeltech-502658": "Strawberry Cocktail",
  "rebeltech-502659": "Street Racer",
  "rebeltech-502660": "Striking Hot 5",
  "rebeltech-502661": "Sugar Rush",
  "rebeltech-502662": "Sugar Rush 1000",
  "rebeltech-502663": "Sugar Rush Dice",
  "rebeltech-502664": "Sugar Rush Xmas",
  "rebeltech-502665": "Sugar Supreme Powernudge",
  "rebeltech-502666": "Sumo Supreme Megaways",
  "rebeltech-502667": "Super 7s",
  "rebeltech-502668": "Super Joker",
  "rebeltech-502669": "Super X",
  "rebeltech-502670": "Sweet Baklava",
  "rebeltech-502671": "Sweet Bonanza",
  "rebeltech-502672": "Sweet Bonanza 1000",
  "rebeltech-502673": "Sweet Bonanza Dice",
  "rebeltech-502674": "Sweet Bonanza Xmas",
  "rebeltech-502675": "Sweet Kingdom",
  "rebeltech-502676": "Sweet Powernudge",
  "rebeltech-502677": "Sword Of Ares",
  "rebeltech-502678": "Tales Of Egypt",
  "rebeltech-502679": "Temujin Treasures",
  "rebeltech-502680": "The Alter Ego",
  "rebeltech-502681": "The Amazing Money Machine",
  "rebeltech-502682": "The Big Dawgs",
  "rebeltech-502683": "The Catfather",
  "rebeltech-502684": "The Catfather Part Ii",
  "rebeltech-502685": "The Champions",
  "rebeltech-502686": "The Conqueror",
  "rebeltech-502687": "The Dog House",
  "rebeltech-502688": "The Dog House - Dog Or Alive",
  "rebeltech-502689": "The Dog House - Muttley Crew",
  "rebeltech-502690": "The Dog House - Royal Hunt",
  "rebeltech-502691": "The Dog House Dice Show",
  "rebeltech-502692": "The Dog House Megaways",
  "rebeltech-502693": "The Dog House Multihold",
  "rebeltech-502694": "The Dragon Tiger",
  "rebeltech-502695": "The Great Chicken Escape",
  "rebeltech-502696": "The Great Stick Up",
  "rebeltech-502697": "The Hand Of Midas",
  "rebeltech-502698": "The Knight King",
  "rebeltech-502699": "The Magic Cauldron Enchanted Brew",
  "rebeltech-502700": "The Money Men Megaways",
  "rebeltech-502701": "The Red Queen",
  "rebeltech-502702": "The Ultimate 5",
  "rebeltech-502703": "The Wild Gang",
  "rebeltech-502704": "The Wild Machine",
  "rebeltech-502705": "Three Star Fortune",
  "rebeltech-502706": "Tic Tac Take",
  "rebeltech-502707": "Timber Stacks",
  "rebeltech-502708": "Tiny Toads",
  "rebeltech-502709": "Towering Fortunes",
  "rebeltech-502710": "Treasure Horse",
  "rebeltech-502711": "Treasure Wild",
  "rebeltech-502712": "Tree Of Riches",
  "rebeltech-502713": "Trees Of Treasure",
  "rebeltech-502714": "Triple Dragons",
  "rebeltech-502715": "Triple Jokers",
  "rebeltech-502716": "Triple Pot Gold",
  "rebeltech-502717": "Triple Tigers",
  "rebeltech-502718": "Tropical Tiki",
  "rebeltech-502719": "Tundra'S Fortune",
  "rebeltech-502720": "Twilight Princess",
  "rebeltech-502721": "Ultra Burn",
  "rebeltech-502722": "Ultra Hold And Spin",
  "rebeltech-502723": "Vampires Vs Wolves",
  "rebeltech-502724": "Vampy Party",
  "rebeltech-502725": "Vegas Magic",
  "rebeltech-502726": "Vegas Nights",
  "rebeltech-502727": "Viking Forge",
  "rebeltech-502728": "Volcano Goddess",
  "rebeltech-502729": "Voodoo Magic",
  "rebeltech-502730": "Wheel O’Gold",
  "rebeltech-502731": "Wild Beach Party",
  "rebeltech-502732": "Wild Bison Charge",
  "rebeltech-502733": "Wild Booster",
  "rebeltech-502734": "Wild Celebrity Bus Megaways",
  "rebeltech-502735": "Wild Depths",
  "rebeltech-502736": "Wild Gladiators",
  "rebeltech-502737": "Wild Hop & Drop",
  "rebeltech-502738": "Wild Pixies",
  "rebeltech-502739": "Wild Spells",
  "rebeltech-502740": "Wild Walker",
  "rebeltech-502741": "Wild West Duels",
  "rebeltech-502742": "Wild West Gold",
  "rebeltech-502743": "Wild West Gold Megaways",
  "rebeltech-502744": "Wild Wild Bananas",
  "rebeltech-502745": "Wild Wild Joker",
  "rebeltech-502746": "Wild Wild Pearls",
  "rebeltech-502747": "Wild Wild Riches",
  "rebeltech-502748": "Wild Wild Riches Megaways",
  "rebeltech-502749": "Wild Wildebeest Wins",
  "rebeltech-502750": "Wildies",
  "rebeltech-502751": "Wisdom Of Athena",
  "rebeltech-502752": "Wisdom Of Athena 1000",
  "rebeltech-502753": "Witch Heart Megaways",
  "rebeltech-502754": "Wolf Gold",
  "rebeltech-502755": "Wolf Gold 1,000,000",
  "rebeltech-502756": "Wolf Gold Dice",
  "rebeltech-502757": "Wolf Gold Ultimate",
  "rebeltech-502758": "Year Of The Dragon King",
  "rebeltech-502759": "Yeti Quest",
  "rebeltech-502760": "Yum Yum Powerways",
  "rebeltech-502761": "Zeus Vs Hades - Gods Of War",
  "rebeltech-502762": "Zombie Carnival",
  "rebeltech-506595": "3 Magic Eggs",
  "rebeltech-506596": "777 Rush",
  "rebeltech-506597": "Alien Invaders",
  "rebeltech-506598": "Anaconda Gold",
  "rebeltech-506599": "Argonauts",
  "rebeltech-506600": "Bee Keeper",
  "rebeltech-506601": "Big Bass Boxing Bonus Round",
  "rebeltech-506602": "Big Bass Christmas - Frozen Lake",
  "rebeltech-506603": "Big Bass Halloween 3",
  "rebeltech-506604": "Big Bass Raceday Repeat",
  "rebeltech-506605": "Big Bass Reel Repeat",
  "rebeltech-506606": "Big Bass Splash 1000",
  "rebeltech-506607": "Bigger Barn House Bonanza",
  "rebeltech-506608": "Bingo Mania",
  "rebeltech-506609": "Bloody Dawn",
  "rebeltech-506610": "Bounty Hunter",
  "rebeltech-506611": "Captain Kraken Megaways",
  "rebeltech-506612": "Chests Of Cai Shen 2",
  "rebeltech-506613": "Chilli Heat Spicy Spins",
  "rebeltech-506614": "Club Tropicana - Happy Hour",
  "rebeltech-506615": "Code Of Cairo",
  "rebeltech-506616": "Cult.",
  "rebeltech-506617": "Cyberheist City",
  "rebeltech-506618": "Dino Drop",
  "rebeltech-506619": "Dj Neko",
  "rebeltech-506620": "Dragon Tiger Fortunes",
  "rebeltech-506621": "Duel Of Night & Day",
  "rebeltech-506622": "Emerald King - Wheel Of Wealth",
  "rebeltech-506623": "Eye Of Spartacus",
  "rebeltech-506624": "Fiesta Fortune",
  "rebeltech-506625": "Finger Lick'N Free Spins",
  "rebeltech-506626": "Fire Stampede 2",
  "rebeltech-506627": "Fire Stampede Ultimate",
  "rebeltech-506628": "Floating Dragon Wild Horses",
  "rebeltech-506629": "Fonzo’S Feline Fortunes",
  "rebeltech-506630": "Fortune Of Aztec",
  "rebeltech-506631": "Fortune Of Olympus",
  "rebeltech-506632": "Frightening Frankie",
  "rebeltech-506633": "Gates Of Hades",
  "rebeltech-506634": "Gem Fire Fortune",
  "rebeltech-506635": "Gem Trio",
  "rebeltech-506636": "Genie'S Gem Bonanza",
  "rebeltech-506637": "Gold Party 2 - After Hours",
  "rebeltech-506638": "Hammerstorm",
  "rebeltech-506639": "Happy Dragon",
  "rebeltech-506640": "Happy Nets",
  "rebeltech-506641": "Haunted Crypt",
  "rebeltech-506642": "Hot Tuna",
  "rebeltech-506643": "Ice Mints",
  "rebeltech-506644": "Jackpot Blaze",
  "rebeltech-506645": "Joker'S Jewels Hold & Spin",
  "rebeltech-506646": "Jumbo Safari",
  "rebeltech-506647": "Knights Vs Barbarians",
  "rebeltech-506648": "Lava Balls",
  "rebeltech-506649": "Lobster House",
  "rebeltech-506650": "Lucky Dice",
  "rebeltech-506651": "Lucky Fortune Tree",
  "rebeltech-506652": "Lucky Monkey",
  "rebeltech-506653": "Lucky Panda",
  "rebeltech-506654": "Lucky Phoenix",
  "rebeltech-506655": "Lucky Tiger 1000",
  "rebeltech-506656": "Lucky Tiger Gold",
  "rebeltech-506657": "Lucky'S Wild Pub 2",
  "rebeltech-506658": "Mahjong Wins Super Scatter",
  "rebeltech-506659": "Majestic Express - Gold Run",
  "rebeltech-506660": "Master Gems",
  "rebeltech-506661": "Mermaid'S Treasure Trove",
  "rebeltech-506662": "Mummy'S Jewels",
  "rebeltech-506663": "Mummy'S Jewels 100",
  "rebeltech-506664": "Mystic Wishes",
  "rebeltech-506665": "Olympus Wins",
  "rebeltech-506666": "Oracle Of Gold",
  "rebeltech-506667": "Pandemic Rising",
  "rebeltech-506668": "Pig Farm",
  "rebeltech-506669": "Plinko+",
  "rebeltech-506670": "Plushie Wins",
  "rebeltech-506671": "Rolling In Treasures",
  "rebeltech-506672": "Santa'S Slay",
  "rebeltech-506673": "Spellmaster",
  "rebeltech-506674": "Starlight Princess Super Scatter",
  "rebeltech-506675": "Starlight Wins",
  "rebeltech-506676": "Steamin' Reels",
  "rebeltech-506677": "Sugar Rush Super Scatter",
  "rebeltech-506678": "Super Gummy Strike",
  "rebeltech-506679": "Super Tiki Strike",
  "rebeltech-506680": "Sweet Bonanza Super Scatter",
  "rebeltech-506681": "Sweet Burst",
  "rebeltech-506682": "Sweet Craze",
  "rebeltech-506683": "Sweet Rush Bonanza",
  "rebeltech-506684": "Temple Guardians",
  "rebeltech-506685": "Treasures Of Osiris",
  "rebeltech-506686": "Tut'S Treasure Tower",
  "rebeltech-506687": "Waves Of Poseidon",
  "rebeltech-506688": "Wealthy Frog",
  "rebeltech-506689": "Wheel Of Happiness",
  "rebeltech-506690": "Wild Skullz",
  "rebeltech-506691": "Wild West Gold Blazing Bounty",
  "rebeltech-506692": "Wild Wild Riches Returns",
  "rebeltech-506693": "Wisdom Of Athena 1000 Xmas",
  "rebeltech-506694": "Wolf Gold 4 Pack",
  "rebeltech-506695": "You Can Piggy Bank On It",
  "rebeltech-506696": "Zeus Vs Hades - Gods Of War 250",
  "rebeltech-506697": "Zeus Vs Typhon",
  "rebeltech-506698": "Zombie School Megaways",
  "lucky_apple_x2500": "Lucky Apple x2500",
  "3oaks-lucky-apple-x2500": "Lucky Apple x2500",
  "chili_coins_xxxl": "Chili Coins XXXL",
  "3oaks-chili-coins-xxxl": "Chili Coins XXXL",
  "4_dragon_pearls": "4 Dragon Pearls",
  "3oaks-4-dragon-pearls": "4 Dragon Pearls",
  "4_super_clover_pots": "4 Super Clover Pots",
  "3oaks-4-super-clover-pots": "4 Super Clover Pots",
  "lucky_penny_3_pots_super_wheel": "Lucky Penny 3 Pots: Super Wheel",
  "3oaks-lucky-penny-3-pots-super-wheel": "Lucky Penny 3 Pots: Super Wheel",
  "3_super_hot_teapots": "3 Super Hot Teapots",
  "3oaks-3-super-hot-teapots": "3 Super Hot Teapots",
  "coinup_volcano": "Coin UP Volcano",
  "3oaks-coin-up-volcano": "Coin UP Volcano",
  "grand": "Grand",
  "3oaks-grand": "Grand",
  "super_hotfire_diamonds": "Super Hotfire Diamonds",
  "3oaks-super-hotfire-diamonds": "Super Hotfire Diamonds",
  "3_superpower_diamonds": "3 SuperPower Diamonds",
  "3oaks-3-superpower-diamonds": "3 SuperPower Diamonds",
  "supreme_diamond_xxl": "Supreme Diamond XXL",
  "3oaks-supreme-diamond-xxl": "Supreme Diamond XXL",
  "mdj_4_pots_of_egypt": "Must Drop JACKPOT™ 4 Pots of Egypt",
  "3oaks-must-drop-jackpot-4-pots-of-egypt": "Must Drop JACKPOT™ 4 Pots of Egypt",
  "chili_coins": "Chili Coins",
  "3oaks-chili-coins": "Chili Coins",
  "3_olymp_fortunes": "3 Olymp Fortunes",
  "3oaks-3-olymp-fortunes": "3 Olymp Fortunes",
  "4_fairy_flowers": "4 Fairy Flowers",
  "3oaks-4-fairy-flowers": "4 Fairy Flowers",
  "dj_tiger_x1000": "DJ Tiger x1000",
  "3oaks-dj-tiger-x1000": "DJ Tiger x1000",
  "rush_for_gold": "Rush for Gold",
  "3oaks-rush-for-gold": "Rush for Gold",
  "egypt_power_x1000": "Egypt Power x1000",
  "3oaks-egypt-power-x1000": "Egypt Power x1000",
  "4_african_drums": "4 African Drums",
  "3oaks-4-african-drums": "4 African Drums",
  "lava_coins_2": "Lava Coins 2",
  "3oaks-lava-coins-2": "Lava Coins 2",
  "mdj_flame_fruits": "Must Drop JACKPOT™ Flame Fruits",
  "3oaks-must-drop-jackpot-flame-fruits": "Must Drop JACKPOT™ Flame Fruits",
  "egypt_fire_2": "Egypt Fire 2",
  "3oaks-egypt-fire-2": "Egypt Fire 2",
  "super_hot_teapots": "Super Hot Teapots",
  "3oaks-super-hot-teapots": "Super Hot Teapots",
  "magic_clovers": "Magic Clovers",
  "3oaks-magic-clovers": "Magic Clovers",
  "4_fortune_clovers": "4 Fortune Clovers",
  "3oaks-4-fortune-clovers": "4 Fortune Clovers",
  "777_fruity_coins": "777 Fruity Coins",
  "3oaks-777-fruity-coins": "777 Fruity Coins",
  "mdj_hot_fire_fruits": "Must Drop JACKPOT™ Hot Fire Fruits",
  "3oaks-must-drop-jackpot-hot-fire-fruits": "Must Drop JACKPOT™ Hot Fire Fruits",
  "joker_glitz_x1000": "Joker Glitz x1000",
  "3oaks-joker-glitz-x1000": "Joker Glitz x1000",
  "3_lucky_sparks": "3 Lucky Sparks",
  "3oaks-3-lucky-sparks": "3 Lucky Sparks",
  "4_clover_pots": "4 Clover Pots",
  "3oaks-4-clover-pots": "4 Clover Pots",
  "lucky_penny_powerscatter": "Lucky Penny Power Scatter",
  "3oaks-lucky-penny-power-scatter": "Lucky Penny Power Scatter",
  "jungle_volcano": "Jungle Volcano",
  "3oaks-jungle-volcano": "Jungle Volcano",
  "lucky_apple_x1000": "Lucky Apple x1000",
  "3oaks-lucky-apple-x1000": "Lucky Apple x1000",
  "thunder_tiger": "Thunder Tiger",
  "3oaks-thunder-tiger": "Thunder Tiger",
  "purple_diamond": "Purple Diamonds",
  "3oaks-purple-diamonds": "Purple Diamonds",
  "4_wolf_drums": "4 Wolf Drums",
  "3oaks-4-wolf-drums": "4 Wolf Drums",
  "lord_of_thunder": "Lord of Thunder",
  "3oaks-lord-of-thunder": "Lord of Thunder",
  "3_super_coin_volcanoes": "3 Super Coin Volcanoes",
  "3oaks-3-super-coin-volcanoes": "3 Super Coin Volcanoes",
  "4_pots_of_egypt": "4 Pots of Egypt",
  "3oaks-4-pots-of-egypt": "4 Pots of Egypt",
  "3_jewel_crowns": "3 Jewel Crowns",
  "3oaks-3-jewel-crowns": "3 Jewel Crowns",
  "super_china_pots": "Super China Pots",
  "3oaks-super-china-pots": "Super China Pots",
  "space_coins": "Space Coins",
  "3oaks-space-coins": "Space Coins",
  "power_sun_xxl": "Power Sun XXL",
  "3oaks-power-sun-xxl": "Power Sun XXL",
  "sun_of_egypt_5": "Sun of Egypt 5",
  "3oaks-sun-of-egypt-5": "Sun of Egypt 5",
  "mdj_777_fruity_classic": "Must Drop JACKPOT™ 777 Fruity Classic",
  "3oaks-must-drop-jackpot-777-fruity-classic": "Must Drop JACKPOT™ 777 Fruity Classic",
  "lucky_penny_2": "Lucky Penny 2",
  "3oaks-lucky-penny-2": "Lucky Penny 2",
  "coin_volcano_2": "Coin Volcano 2",
  "3oaks-coin-volcano-2": "Coin Volcano 2",
  "maya_lock": "Maya Lock",
  "3oaks-maya-lock": "Maya Lock",
  "amazonia_wins": "Amazonia Wins",
  "3oaks-amazonia-wins": "Amazonia Wins",
  "coin_princess_x1000": "Coin Princess x1000",
  "3oaks-coin-princess-x1000": "Coin Princess x1000",
  "3_super_hot_chillies": "3 Super Hot Chillies",
  "3oaks-3-super-hot-chillies": "3 Super Hot Chillies",
  "dancing_joker": "Dancing Joker",
  "3oaks-dancing-joker": "Dancing Joker",
  "3_hot_teapots": "3 Hot Teapots",
  "3oaks-3-hot-teapots": "3 Hot Teapots",
  "coin_express": "Coin Express",
  "3oaks-coin-express": "Coin Express",
  "3_aztec_temples": "3 Aztec Temples",
  "3oaks-3-aztec-temples": "3 Aztec Temples",
  "power_sun": "Power Sun",
  "3oaks-power-sun": "Power Sun",
  "3_clover_pots_extra": "3 Clover Pots Extra",
  "3oaks-3-clover-pots-extra": "3 Clover Pots Extra",
  "coin_lamp": "Coin Lamp",
  "3oaks-3oaks-coin-lamp": "Coin Lamp",
  "rocket_wins": "Rocket Wins",
  "3oaks-rocket-wins": "Rocket Wins",
  "3_african_drums": "3 African Drums",
  "3oaks-3-african-drums": "3 African Drums",
  "hawaii_riches": "Hawaii Riches",
  "3oaks-hawaii-riches": "Hawaii Riches",
  "lava_coins": "Lava Coins",
  "3oaks-lava-coins": "Lava Coins",
  "china_festival": "China Festival",
  "3oaks-china-festival": "China Festival",
  "3_coin_volcanoes": "3 Coin Volcanoes",
  "3oaks-3-coin-volcanoes": "3 Coin Volcanoes",
  "hot_fire_fruits": "Hot Fire Fruits",
  "3oaks-hot-fire-fruits": "Hot Fire Fruits",
  "3_pots_of_egypt": "3 Pots of Egypt",
  "3oaks-3-pots-of-egypt": "3 Pots of Egypt",
  "fortune_globe": "Fortune Globe",
  "3oaks-fortune-globe": "Fortune Globe",
  "storm_of_olympus": "Storm of Olympus",
  "3oaks-storm-of-olympus": "Storm of Olympus",
  "lucky_penny": "Lucky Penny",
  "3oaks-lucky-penny": "Lucky Penny",
  "amazonia_spirit": "Amazonia Spirit",
  "3oaks-amazonia-spirit": "Amazonia Spirit",
  "777_fruity_classic": "777 Fruity Classic",
  "3oaks-fruity-classic": "777 Fruity Classic",
  "super_hot_chilli": "Super Hot Chilli",
  "3oaks-3-super-hot-chilli": "Super Hot Chilli",
  "golden_teapot": "Golden Teapot",
  "3oaks-golden-teapot": "Golden Teapot",
  "coin_lightning": "Coin UP: Lightning",
  "3oaks-scoin-up-lightning": "Coin UP: Lightning",
  "sky_coins": "Sky Coins",
  "3oaks-sky-coins": "Sky Coins",
  "super_sticky_piggy": "Super Sticky Piggy",
  "3oaks-super-sticky-piggy": "Super Sticky Piggy",
  "lamp_of_wonder": "Lamp of Wonder",
  "3oaks-lamp-of-wonder": "Lamp of Wonder",
  "fishing_bear": "Fishin' Bear",
  "3oaks-fishin-bear": "Fishin' Bear",
  "3_china_pots": "3 China Pots",
  "3oaks-3-china-pots": "3 China Pots",
  "3_clover_pots": "3 Clover Pots",
  "3oaks-3-clover-pots": "3 Clover Pots",
  "lion_coins": "Lion Coins",
  "3oaks-lion-coins": "Lion Coins",
  "sky_pearls": "Sky Pearls",
  "3oaks-sky-pearls": "Sky Pearls",
  "3_egypt_chests": "3 Egypt Chests",
  "3oaks-3-egypt-chests": "3 Egypt Chests",
  "coin_up": "Coin UP: Hot Fire",
  "3oaks-coin-up-hot-fire": "Coin UP: Hot Fire",
  "sun_of_egypt_4": "Sun of Egypt 4",
  "3oaks-sun-of-egypt-4": "Sun of Egypt 4",
  "aztec_fire_2": "Aztec Fire 2",
  "3oaks-aztec-fire-2": "Aztec Fire 2",
  "gold_nuggets": "Gold Nuggets",
  "3oaks-gold-nuggets": "Gold Nuggets",
  "grab_more_gold": "Grab more Gold!",
  "3oaks-grab-more-gold": "Grab more Gold!",
  "crystal_scarabs": "Crystal Scarabs",
  "3oaks-crystal-scarabs": "Crystal Scarabs",
  "african_spirit_sticky_wilds": "African Spirit Sticky Wilds",
  "3oaks-african-spirit-sticky-wilds": "African Spirit Sticky Wilds",
  "olaf_viking": "Olaf Viking",
  "3oaks-olaf-viking": "Olaf Viking",
  "3_hot_chillies": "3 Hot Chillies",
  "3oaks-3-hot-chillies": "3 Hot Chillies",
  "777_coins": "777 Coins",
  "3oaks-777-coins": "777 Coins",
  "black_wolf_2": "Black Wolf 2",
  "3oaks-black-wolf-2": "Black Wolf 2",
  "little_farm": "Little Farm",
  "3oaks-little-farm": "Little Farm",
  "green_chilli_2": "Green Chilli 2",
  "3oaks-green-chilli-2": "Green Chilli 2",
  "forest_spirit": "Forest Spirit",
  "3oaks-forest-spirit": "Forest Spirit",
  "coin_volcano": "Coin Volcano",
  "3oaks-coin-volcano": "Coin Volcano",
  "lady_fortune": "Lady Fortune",
  "3oaks-lady-fortune": "Lady Fortune",
  "mummy_power": "Mummy Power",
  "3oaks-mummy-power": "Mummy Power",
  "yo_ho_gold": "Yo-Ho Gold!",
  "3oaks-yo-ho-gold": "Yo-Ho Gold!",
  "egypt_fire": "Egypt Fire",
  "3oaks-egypt-fire": "Egypt Fire",
  "more_magic_apple": "More Magic Apple",
  "3oaks-more-magic-apple": "More Magic Apple",
  "grab_the_gold": "Grab the Gold!",
  "3oaks-grab-the-gold": "Grab the Gold!",
  "tiger_gems": "Tiger Gems",
  "3oaks-tiger-gems": "Tiger Gems",
  "boom_gold": "Boom! Boom! Gold!",
  "3oaks-boom-boom-gold": "Boom! Boom! Gold!",
  "maya_sun": "Maya Sun",
  "3oaks-maya-sun": "Maya Sun",
  "dragon_wealth": "Dragon Wealth",
  "3oaks-dragon-wealth": "Dragon Wealth",
  "sunlight_princess": "Sunlight Princess",
  "3oaks-sunlight-princess": "Sunlight Princess",
  "goddess_of_egypt": "Goddess of Egypt",
  "3oaks-goddess-of-egypt": "Goddess of Egypt",
  "rio_gems": "Rio Gems",
  "3oaks-rio-jems": "Rio Gems",
  "hit_more_gold": "Hit More Gold: Hold and Win",
  "3oaks-hit-more-gold-hold-and-win": "Hit More Gold: Hold and Win",
  "sticky_piggy": "Sticky Piggy",
  "3oaks-sticky-piggy": "Sticky Piggy",
  "green_chilli": "Green Chilli",
  "3oaks-green-chilly": "Green Chilli",
  "big_heist": "Big Heist",
  "3oaks-big-heist": "Big Heist",
  "aztec_fire": "Aztec Fire",
  "3oaks-aztec-fire": "Aztec Fire",
  "lotus_charm": "Lotus Charm",
  "3oaks-lotus-charm": "Lotus Charm",
  "eggs_of_gold": "Eggs of Gold",
  "3oaks-eggs-of-gold": "Eggs of Gold",
  "king_of_heroes": "The King of Heroes",
  "3oaks-the-king-of-heroes": "The King of Heroes",
  "magic_apple_2": "Magic Apple 2",
  "3oaks-magic-apple-2": "Magic Apple 2",
  "caishen_wealth": "Caishen Wealth",
  "3oaks-caishen-wealth": "Caishen Wealth",
  "wolf_night": "Wolf Night",
  "3oaks-wolf-night": "Wolf Night",
  "tiger_jungle": "Tiger Jungle",
  "3oaks-tiger-jungle": "Tiger Jungle",
  "queen_of_the_sun": "Queen Of The Sun",
  "3oaks-queen-of-the-sun": "Queen Of The Sun",
  "lord_fortune_2": "Lord Fortune 2",
  "3oaks-lord-fortune-2": "Lord Fortune 2",
  "buddha_megaways": "Buddha Megaways",
  "3oaks-buddha-megaways": "Buddha Megaways",
  "candy_boom": "Candy Boom",
  "3oaks-candy-boom": "Candy Boom",
  "gold_express": "Gold Express",
  "3oaks-gold-express": "Gold Express",
  "sun_of_egypt_3": "Sun of Egypt 3",
  "3oaks-sun-of-egypt-3": "Sun of Egypt 3",
  "book_of_wizard": "Book of Wizard",
  "3oaks-book_of_wizard": "Book of Wizard",
  "thunder_of_olympus": "Thunder Of Olympus",
  "3oaks-thunder_of_olympus": "Thunder Of Olympus",
  "buddha_fortune": "Buddha Fortune",
  "3oaks-buddha_fortune": "Buddha Fortune",
  "magic_apple": "Magic Apple",
  "3oaks-magic_apple": "Magic Apple",
  "scarab_boost": "Scarab Boost",
  "3oaks-scarab_boost": "Scarab Boost",
  "super_rich_god": "Super Rich God",
  "3oaks-super_rich_god": "Super Rich God",
  "scarab_temple": "Scarab Temple",
  "3oaks-scarab_temple": "Scarab Temple",
  "3_coins_egypt": "3 Coins Egypt",
  "3oaks-3_coins_egypt": "3 Coins Egypt",
  "tiger_stone": "Tiger Stone",
  "3oaks-tiger_stone": "Tiger Stone",
  "moon_sisters": "Moon Sisters",
  "3oaks-moon_sisters": "Moon Sisters",
  "dragon_pearls": "Dragon Pearls",
  "3oaks-dragon_pearls": "Dragon Pearls",
  "aztec_sun": "Aztec Sun",
  "3oaks-aztec_sun": "Aztec Sun",
  "aztec_pyramid": "Aztec Pyramid",
  "3oaks-aztec_pyramid": "Aztec Pyramid",
  "super_marble": "Super Marble",
  "3oaks-super_marble": "Super Marble",
  "pearl_diver_2": "Pearl Diver 2",
  "3oaks-pearl_diver_2": "Pearl Diver 2",
  "book_of_sun_multichance": "Book Of Sun Multichance",
  "3oaks-book_of_sun_multichance": "Book Of Sun Multichance",
  "15_dragon_pearls": "15 Dragon Pearls",
  "3oaks-15_dragon_pearls": "15 Dragon Pearls",
  "olympian_gods": "Olympian Gods",
  "3oaks-olympian_gods": "Olympian Gods",
  "sun_of_egypt_2": "Sun of Egypt 2",
  "3oaks-sun_of_egypt_2": "Sun of Egypt 2",
  "3_coins": "3 Coins",
  "3oaks-3_coins": "3 Coins",
  "magic_ball": "Magic Ball",
  "3oaks-magic_ball": "Magic Ball",
  "777_gems_respin": "777 Gems Respin",
  "3oaks-777_gems_respin": "777 Gems Respin",
  "book_of_sun_choice": "Book Of Sun Choice",
  "3oaks-book_of_sun_choice": "Book Of Sun Choice",
  "sun_of_egypt": "Sun of Egypt",
  "3oaks-sun_of_egypt": "Sun of Egypt",
  "tigers_gold": "Tigers Gold",
  "3oaks-tigers_gold": "Tigers Gold",
  "great_panda": "Great Panda",
  "3oaks-great_panda": "Great Panda",
  "wolf_saga": "Wolf Saga",
  "3oaks-wolf_saga": "Wolf Saga",
  "wukong": "Wukong",
  "3oaks-wukong": "Wukong",
  "black_wolf": "Black Wolf",
  "3oaks-black_wolf": "Black Wolf",
  "hit_the_gold": "Hit The Gold",
  "3oaks-hit_the_gold": "Hit The Gold",
  "scarab_riches": "Scarab Riches",
  "3oaks-scarab_riches": "Scarab Riches",
  "pearl_diver": "Pearl Diver",
  "3oaks-pearl_diver": "Pearl Diver",
  "fish_reef": "Fish Reef",
  "3oaks-fish_reef": "Fish Reef",
  "book_of_wizard_crystal": "Book Of Wizard Crystal Chance",
  "3oaks-book_of_wizard_crystal": "Book Of Wizard Crystal Chance",
  "book_of_sun": "Book of Sun",
  "3oaks-book_of_sun": "Book of Sun",
  "eye_of_gold": "Eye Of Gold",
  "3oaks-eye_of_gold": "Eye Of Gold"
};

/**
 * Get the game name for a given walletId
 * @param {string} walletId - The wallet ID to look up
 * @returns {string|null} The game name (translationKey) or null if not found
 */
export function getGameName(walletId) {
  if (!walletId) {
    return null;
  }
  
  // Convert to string to ensure consistency
  const id = String(walletId);

  // Direct match in the primary mapping
  if (gameNameMapping[id]) {
    return gameNameMapping[id];
  }

  // RebelTech pm8 callbacks use bare numeric catalog ids (e.g. "500490").
  if (rebeltechGameNameMapping[id]) {
    return rebeltechGameNameMapping[id];
  }

  // Eva wallet ids for the same RebelTech titles are stored as rebeltech-502xxx.
  if (/^\d+$/.test(id)) {
    const prefixed = `rebeltech-${id}`;
    if (gameNameMapping[prefixed]) {
      return gameNameMapping[prefixed];
    }
  }

  // Databetrix callbacks identify a game only by its 40-char catalog hash.
  if (databetrixGameNameMapping[id]) {
    return databetrixGameNameMapping[id];
  }

  // Betinovio games use standard Pragmatic codes with a "_tmp" suffix
  // (e.g. "vs20wildparty_tmp"). The same game must resolve whether or not the
  // suffix is present, so we look both directions:
  if (id.endsWith('_tmp')) {
    // Suffixed code: betinovio catalog first, then base mapping un-suffixed.
    const baseId = id.slice(0, -'_tmp'.length);
    return betinovioGameNameMapping[id] || gameNameMapping[baseId] || null;
  }

  // Un-suffixed code: already missed the base mapping above, so try the
  // betinovio catalog using the suffixed variant of the same game.
  if (betinovioGameNameMapping[`${id}_tmp`]) {
    return betinovioGameNameMapping[`${id}_tmp`];
  }

  return null;
}

/**
 * Get the game name with a fallback value
 * @param {string} walletId - The wallet ID to look up
 * @param {string} fallback - The fallback value if game is not found
 * @returns {string} The game name or fallback value
 */
export function getGameNameWithFallback(walletId, fallback = 'Unknown Game') {
  return getGameName(walletId) || fallback;
}

/**
 * Check if a walletId exists in the mapping
 * @param {string} walletId - The wallet ID to check
 * @returns {boolean} True if the walletId exists, false otherwise
 */
export function hasGame(walletId) {
  if (!walletId) {
    return false;
  }
  
  return getGameName(walletId) !== null;
}

/**
 * Get all wallet IDs
 * @returns {string[]} Array of all wallet IDs
 */
export function getAllWalletIds() {
  return Object.keys(gameNameMapping);
}

/**
 * Get all game names
 * @returns {string[]} Array of all game names
 */
export function getAllGameNames() {
  return Object.values(gameNameMapping);
}

/**
 * Search for games by name (case-insensitive partial match)
 * @param {string} searchTerm - The search term
 * @returns {Array<{walletId: string, gameName: string}>} Array of matching games
 */
export function searchGamesByName(searchTerm) {
  if (!searchTerm) {
    return [];
  }
  
  const term = searchTerm.toLowerCase();
  const results = [];
  
  for (const [walletId, gameName] of Object.entries(gameNameMapping)) {
    if (gameName.toLowerCase().includes(term)) {
      results.push({ walletId, gameName });
    }
  }
  
  return results;
}

// Export the mapping object as well for direct access if needed
export { gameNameMapping };

// Default export
export default {
  gameNameMapping,
  getGameName,
  getGameNameWithFallback,
  hasGame,
  getAllWalletIds,
  getAllGameNames,
  searchGamesByName
};
